import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import { AnyJson, JsonObject } from './json'

export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Date: string
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: string
  /** An ISO 8601-encoded date */
  ISO8601Date: any
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string
  JSON: AnyJson
  /** A valid JSON schema for building HTML forms, see: https://react-jsonschema-form.readthedocs.io/en/latest */
  JSONSchemaForm: JsonObject
  /** The `Long` scalar type represents 52-bit integers */
  Long: number
  /** Valid markdown, ready for translation to HTML, JSX, etc. */
  Markdown: string
  /** Input type for dynamic zone link of MenuItem */
  MenuItemLinkDynamicZoneInput: JsonObject
  Object: any
  /** A time string with format: HH:mm:ss.SSS */
  Time: string
  /** A valid URL, transported as a string */
  URL: string
  /** A valid UUID */
  UUID: any
  /** The `Upload` scalar type represents a file upload. */
  Upload: JsonObject
  /** Input type for dynamic zone content of WebPage */
  WebPageContentDynamicZoneInput: JsonObject
}

export type Accepted = {
  __typename?: 'Accepted'
  count: Scalars['Int']
}

export type AccountAttributes = {
  email: Scalars['String']
  firstName: Scalars['String']
  lastName?: Maybe<Scalars['String']>
}

export type Active = {
  __typename?: 'Active'
  assigned: Assigned
  count: Scalars['Int']
  unassigned: Unassigned
}

/** Autogenerated input type of AddOnAssign */
export type AddOnAssignInput = {
  addOnId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName?: Maybe<Scalars['String']>
}

/** Autogenerated return type of AddOnAssign. */
export type AddOnAssignPayload = {
  __typename?: 'AddOnAssignPayload'
  addOn: Maybe<TaAddOn>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export enum AddOnAssignmentState {
  Accepted = 'ACCEPTED',
  Unaccepted = 'UNACCEPTED',
}

export enum AddOnSortFields {
  AddOnTypeName = 'ADD_ON_TYPE_NAME',
  AssigneeEmail = 'ASSIGNEE_EMAIL',
  AssigneeFirstName = 'ASSIGNEE_FIRST_NAME',
  AssigneeLastName = 'ASSIGNEE_LAST_NAME',
}

export enum AddOnState {
  Accepted = 'ACCEPTED',
  Locked = 'LOCKED',
  Unaccepted = 'UNACCEPTED',
  Unassigned = 'UNASSIGNED',
  Void = 'VOID',
}

/** Autogenerated input type of AddOnUnassign */
export type AddOnUnassignInput = {
  addOnId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of AddOnUnassign. */
export type AddOnUnassignPayload = {
  __typename?: 'AddOnUnassignPayload'
  addOn: Maybe<TaAddOn>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export type Address = {
  __typename?: 'Address'
  city: Maybe<Scalars['String']>
  country: Maybe<EventConfigurationCountry>
  id: Scalars['ID']
  lineOne: Maybe<Scalars['String']>
  lineTwo: Maybe<Scalars['String']>
  postalCode: Maybe<Scalars['String']>
  region: Maybe<Scalars['String']>
}

export type AddressInput = {
  city: Scalars['String']
  countryId: Scalars['ID']
  lineOne: Scalars['String']
  lineTwo?: Maybe<Scalars['String']>
  postalCode: Scalars['String']
  region: Scalars['String']
}

export type AdminUser = {
  __typename?: 'AdminUser'
  id: Scalars['ID']
  username: Maybe<Scalars['String']>
}

export type All = {
  __typename?: 'All'
  active: Active
  count: Scalars['Int']
  void: Void
}

export type AppConfig = {
  __typename?: 'AppConfig'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  googleAnalyticsLinkerDomains: Array<ComponentSiteConfigGoogleAnalyticsLinkerDomainList>
  googleAnalyticsTrackingId: Maybe<Scalars['String']>
  googleFontsUrl: Maybe<Scalars['String']>
  googleTagManagerId: Maybe<Scalars['String']>
  id: Scalars['ID']
  matomoSiteId: Maybe<Scalars['String']>
  matomoTagManagerContainerId: Maybe<Scalars['String']>
  matomoUrl: Maybe<Scalars['String']>
  metaData: ComponentSiteConfigMetaData
  segmentId: Maybe<Scalars['String']>
  theme: Maybe<Scalars['JSON']>
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type AppConfigInput = {
  created_by?: Maybe<Scalars['ID']>
  googleAnalyticsLinkerDomains: Array<ComponentSiteConfigGoogleAnalyticsLinkerDomainListInput>
  googleAnalyticsTrackingId?: Maybe<Scalars['String']>
  googleFontsUrl?: Maybe<Scalars['String']>
  googleTagManagerId?: Maybe<Scalars['String']>
  matomoSiteId?: Maybe<Scalars['String']>
  matomoTagManagerContainerId?: Maybe<Scalars['String']>
  matomoUrl?: Maybe<Scalars['String']>
  metaData: ComponentSiteConfigMetaDatumInput
  segmentId?: Maybe<Scalars['String']>
  theme?: Maybe<Scalars['JSON']>
  updated_by?: Maybe<Scalars['ID']>
}

export type Appearance = {
  __typename?: 'Appearance'
  attendanceConnections: AttendanceAppearanceConnectionLinkConnection
  boothUrl: Maybe<Scalars['String']>
  company: Company
  connectionState: ConnectionState
  endorsedBy: Maybe<Appearance>
  endorsees: AppearanceConnection
  id: Scalars['ID']
  industries: Array<Industry>
  industry: Maybe<Industry>
  pitchDeckUrl: Maybe<Scalars['String']>
  pitchVimeoUrl: Maybe<Scalars['String']>
  products: Maybe<AppearanceProductConnection>
  sponsoredSessions: ScheduleTimeslotConnection
  standNumber: Maybe<Scalars['String']>
  team: AttendeeConnection
  track: Maybe<Scalars['String']>
  videoFileUrl: Maybe<Scalars['String']>
}

export type AppearanceAttendanceConnectionsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AppearanceEndorseesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AppearanceProductsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AppearanceSponsoredSessionsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AppearanceTeamArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of AppearanceConnect */
export type AppearanceConnectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  source?: Maybe<Scalars['String']>
}

/** Autogenerated return type of AppearanceConnect */
export type AppearanceConnectPayload = {
  __typename?: 'AppearanceConnectPayload'
  appearance: Maybe<Appearance>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
}

/** The connection type for Appearance. */
export type AppearanceConnection = {
  __typename?: 'AppearanceConnection'
  /** A list of edges. */
  edges: Array<AppearanceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AppearanceEdge = {
  __typename?: 'AppearanceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Appearance
}

export type AppearanceProduct = {
  __typename?: 'AppearanceProduct'
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  imageUrl: Maybe<Scalars['String']>
  name: Scalars['String']
}

/** The connection type for AppearanceProduct. */
export type AppearanceProductConnection = {
  __typename?: 'AppearanceProductConnection'
  /** A list of edges. */
  edges: Array<AppearanceProductEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AppearanceProductEdge = {
  __typename?: 'AppearanceProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: AppearanceProduct
}

/** Autogenerated input type of AppearanceUpdate */
export type AppearanceUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  isSponsor: Scalars['Boolean']
  privacyPolicyUrl?: Maybe<Scalars['String']>
}

/** Autogenerated return type of AppearanceUpdate */
export type AppearanceUpdatePayload = {
  __typename?: 'AppearanceUpdatePayload'
  appearance: Maybe<Appearance>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  errors: Array<Error>
}

export type ApplicableTicket = {
  __typename?: 'ApplicableTicket'
  id: Scalars['ID']
  source: Maybe<ApplicableTicketTypeSource>
  ticketType: TicketType
  versions: Maybe<Array<PaperTrailVersion>>
}

/** The connection type for ApplicableTicket. */
export type ApplicableTicketConnection = {
  __typename?: 'ApplicableTicketConnection'
  /** A list of edges. */
  edges: Array<ApplicableTicketEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ApplicableTicketEdge = {
  __typename?: 'ApplicableTicketEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ApplicableTicket
}

export type ApplicableTicketTypeSource = TaAddOnType | TaTicketUpgradeType

export type Assigned = {
  __typename?: 'Assigned'
  accepted: Accepted
  checkedIn: CheckedIn
  count: Scalars['Int']
  duplicate: Duplicate
  locked: Locked
  pending: Pending
}

export type AssigneeAddOns = {
  __typename?: 'AssigneeAddOns'
  accepted: TaAddOnConnection
  unaccepted: TaAddOnConnection
  voided: TaAddOnConnection
}

export type AssigneeAddOnsAcceptedArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type AssigneeAddOnsUnacceptedArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type AssigneeAddOnsVoidedArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type AssigneeTicketUpgrades = {
  __typename?: 'AssigneeTicketUpgrades'
  accepted: TaTicketUpgradeConnection
  unaccepted: TaTicketUpgradeConnection
  voided: TaTicketUpgradeConnection
}

export type AssigneeTicketUpgradesAcceptedArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type AssigneeTicketUpgradesUnacceptedArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type AssigneeTicketUpgradesVoidedArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type Assignment = {
  __typename?: 'Assignment'
  appLoginEmail: Maybe<Scalars['String']>
  assignee: Maybe<AssignmentUser>
  assigner: Maybe<AssignmentUser>
  id: Scalars['ID']
  leadScanningActive: Maybe<Scalars['Boolean']>
  state: AssignmentState
  versions: Maybe<Array<PaperTrailVersion>>
}

/** Autogenerated input type of AssignmentAccountUpdate */
export type AssignmentAccountUpdateInput = {
  accountId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email: Scalars['String']
}

/** Autogenerated return type of AssignmentAccountUpdate. */
export type AssignmentAccountUpdatePayload = {
  __typename?: 'AssignmentAccountUpdatePayload'
  account: Maybe<AssignmentUser>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AssignmentAddOnUnvoid */
export type AssignmentAddOnUnvoidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AssignmentAddOnUnvoid. */
export type AssignmentAddOnUnvoidPayload = {
  __typename?: 'AssignmentAddOnUnvoidPayload'
  addOn: Maybe<TaAddOn>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AssignmentAddOnVoid */
export type AssignmentAddOnVoidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  sendEmailNotification?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of AssignmentAddOnVoid. */
export type AssignmentAddOnVoidPayload = {
  __typename?: 'AssignmentAddOnVoidPayload'
  addOn: Maybe<TaAddOn>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AssignmentAuthenticate */
export type AssignmentAuthenticateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  token: Scalars['String']
}

/** Autogenerated return type of AssignmentAuthenticate. */
export type AssignmentAuthenticatePayload = {
  __typename?: 'AssignmentAuthenticatePayload'
  accessToken: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  conferenceSlug: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** The connection type for Assignment. */
export type AssignmentConnection = {
  __typename?: 'AssignmentConnection'
  /** A list of edges. */
  edges: Array<AssignmentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type AssignmentEdge = {
  __typename?: 'AssignmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Assignment
}

/** Autogenerated input type of AssignmentMagicLinkGenerate */
export type AssignmentMagicLinkGenerateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Email address of the account. */
  email: Scalars['String']
  eventSlug: Scalars['String']
  /** Specifies the time in minutes the generated login link will be valid for. Defaults to 30 minutes. */
  ttl?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of AssignmentMagicLinkGenerate. */
export type AssignmentMagicLinkGeneratePayload = {
  __typename?: 'AssignmentMagicLinkGeneratePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  email: Maybe<Scalars['String']>
  loginLink: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AssignmentMagicLinkLoginRequest */
export type AssignmentMagicLinkLoginRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email: Scalars['String']
}

/** Autogenerated return type of AssignmentMagicLinkLoginRequest. */
export type AssignmentMagicLinkLoginRequestPayload = {
  __typename?: 'AssignmentMagicLinkLoginRequestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AssignmentProfileAdminUpdate */
export type AssignmentProfileAdminUpdateInput = {
  accountId: Scalars['ID']
  bio?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  companySizeId?: Maybe<Scalars['ID']>
  firstName?: Maybe<Scalars['String']>
  gender?: Maybe<Scalars['String']>
  industryId?: Maybe<Scalars['ID']>
  jobTitle?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  phoneNumber?: Maybe<Scalars['String']>
}

/** Autogenerated return type of AssignmentProfileAdminUpdate. */
export type AssignmentProfileAdminUpdatePayload = {
  __typename?: 'AssignmentProfileAdminUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  profile: Maybe<AssignmentUser>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AssignmentProfileUpdate */
export type AssignmentProfileUpdateInput = {
  city?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  companySizeId?: Maybe<Scalars['ID']>
  firstName: Scalars['String']
  industryId: Scalars['ID']
  jobTitle: Scalars['String']
  lastName?: Maybe<Scalars['String']>
  marketingConsent: Scalars['String']
  partnerSharingConsent?: Maybe<Scalars['String']>
  passportNumber?: Maybe<Scalars['String']>
  personalisationConsent: Scalars['String']
  phoneNumber?: Maybe<Scalars['String']>
  ticketId: Scalars['ID']
  washingtonPostConsent?: Maybe<Scalars['String']>
}

/** Autogenerated return type of AssignmentProfileUpdate. */
export type AssignmentProfileUpdatePayload = {
  __typename?: 'AssignmentProfileUpdatePayload'
  assignee: Maybe<AssignmentUser>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export type AssignmentProperties = {
  __typename?: 'AssignmentProperties'
  bookingRefSuffix: Maybe<Scalars['String']>
  cycleable: Scalars['Boolean']
  orderOwnerEditable: Scalars['Boolean']
  reassignable: Scalars['Boolean']
  rejectable: Scalars['Boolean']
}

/** Autogenerated input type of AssignmentResendOrderEmail */
export type AssignmentResendOrderEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  reference: Scalars['String']
}

/** Autogenerated return type of AssignmentResendOrderEmail. */
export type AssignmentResendOrderEmailPayload = {
  __typename?: 'AssignmentResendOrderEmailPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  order: Maybe<Order>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AssignmentSalesforceAccountUpdate */
export type AssignmentSalesforceAccountUpdateInput = {
  announcementStatus?: Maybe<Scalars['String']>
  appLoginEmail?: Maybe<Scalars['String']>
  bio?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  countryName?: Maybe<Scalars['String']>
  gender?: Maybe<Scalars['String']>
  industry?: Maybe<Scalars['String']>
  jobTitle?: Maybe<Scalars['String']>
  passportNumber?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  salesforceAttendanceUid: Scalars['String']
}

/** Autogenerated return type of AssignmentSalesforceAccountUpdate. */
export type AssignmentSalesforceAccountUpdatePayload = {
  __typename?: 'AssignmentSalesforceAccountUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export enum AssignmentState {
  Accepted = 'ACCEPTED',
  Duplicate = 'DUPLICATE',
  Pending = 'PENDING',
}

/** Autogenerated input type of AssignmentTicketLoginUpdate */
export type AssignmentTicketLoginUpdateInput = {
  appLoginEmail: Scalars['String']
  bookingRef: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of AssignmentTicketLoginUpdate. */
export type AssignmentTicketLoginUpdatePayload = {
  __typename?: 'AssignmentTicketLoginUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

export type AssignmentUser = {
  __typename?: 'AssignmentUser'
  addOns: AssigneeAddOns
  assigneeAssignments: Maybe<AssignmentConnection>
  bio: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  companyName: Maybe<Scalars['String']>
  companySizeId: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  gender: Maybe<Scalars['String']>
  id: Scalars['ID']
  industryId: Maybe<Scalars['String']>
  jobTitle: Maybe<Scalars['String']>
  lastLoginTokenCreatedAt: Maybe<Scalars['ISO8601Date']>
  lastName: Maybe<Scalars['String']>
  loginDetails: Maybe<LoginDetails>
  marketingConsent: Maybe<Scalars['String']>
  me: Scalars['Boolean']
  metadata: Maybe<Scalars['JSON']>
  partnerSharingConsent: Maybe<Scalars['String']>
  passportNumber: Maybe<Scalars['String']>
  personalisationConsent: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
  rejectedAssignments: Maybe<AssignmentConnection>
  ticket: Maybe<Ticket>
  ticketUpgrades: AssigneeTicketUpgrades
  versions: Maybe<Array<PaperTrailVersion>>
  washingtonPostConsent: Maybe<Scalars['String']>
}

export type AssignmentUserAssigneeAssignmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type AssignmentUserRejectedAssignmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export enum Attendance {
  /** Investor */
  Investor = 'INVESTOR',
  /** Investor_voided */
  InvestorVoided = 'INVESTOR_VOIDED',
  /** Speaker */
  Speaker = 'SPEAKER',
}

export type AttendanceAppearanceConnectionLink = {
  __typename?: 'AttendanceAppearanceConnectionLink'
  createdAt: Scalars['ISO8601DateTime']
  entity: Attendee
  id: Scalars['ID']
  source: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for AttendanceAppearanceConnectionLink. */
export type AttendanceAppearanceConnectionLinkConnection = {
  __typename?: 'AttendanceAppearanceConnectionLinkConnection'
  /** A list of edges. */
  edges: Array<AttendanceAppearanceConnectionLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AttendanceAppearanceConnectionLinkEdge = {
  __typename?: 'AttendanceAppearanceConnectionLinkEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: AttendanceAppearanceConnectionLink
}

export type AttendanceAppearanceSelection = {
  __typename?: 'AttendanceAppearanceSelection'
  appearance: Appearance
  attendance: Attendee
  createdAt: Scalars['String']
  endsAt: Maybe<Scalars['String']>
  id: Scalars['ID']
  participations: Maybe<Array<Attendee>>
  priority: Maybe<Scalars['Int']>
  sessionTimeslotId: Maybe<Scalars['ID']>
  startsAt: Maybe<Scalars['String']>
  status: Scalars['String']
  submittedAt: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
}

export type AttendanceAppearanceSelectionCreatedAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type AttendanceAppearanceSelectionEndsAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type AttendanceAppearanceSelectionStartsAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type AttendanceAppearanceSelectionSubmittedAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type AttendanceAppearanceSelectionUpdatedAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

/** The connection type for AttendanceAppearanceSelection. */
export type AttendanceAppearanceSelectionConnection = {
  __typename?: 'AttendanceAppearanceSelectionConnection'
  /** A list of edges. */
  edges: Array<AttendanceAppearanceSelectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated input type of AttendanceAppearanceSelectionDestroy */
export type AttendanceAppearanceSelectionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AttendanceAppearanceSelectionDestroy */
export type AttendanceAppearanceSelectionDestroyPayload = {
  __typename?: 'AttendanceAppearanceSelectionDestroyPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** An edge in a connection. */
export type AttendanceAppearanceSelectionEdge = {
  __typename?: 'AttendanceAppearanceSelectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: AttendanceAppearanceSelection
}

export type AttendanceAppearanceSelectionsDetails = {
  __typename?: 'AttendanceAppearanceSelectionsDetails'
  acceptedSelectionCount: Scalars['Int']
  attendanceAppearanceSelections: Maybe<AttendanceAppearanceSelectionConnection>
  introductionSelectionCount: Scalars['Int']
  pendingSelectionCount: Scalars['Int']
  rejectedSelectionCount: Scalars['Int']
  submittedSelectionCount: Scalars['Int']
}

export type AttendanceAppearanceSelectionsDetailsAttendanceAppearanceSelectionsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export enum AttendanceAppearanceSelectionsStatus {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Introduce */
  Introduce = 'INTRODUCE',
  /** No Selections */
  NoSelections = 'NO_SELECTIONS',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Submitted */
  Submitted = 'SUBMITTED',
}

/** Autogenerated input type of AttendanceAppearanceSelectionsUpdate */
export type AttendanceAppearanceSelectionsUpdateInput = {
  attendanceIds: Array<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  status: Scalars['String']
}

/** Autogenerated return type of AttendanceAppearanceSelectionsUpdate */
export type AttendanceAppearanceSelectionsUpdatePayload = {
  __typename?: 'AttendanceAppearanceSelectionsUpdatePayload'
  attendances: Maybe<AttendeeConnection>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated return type of AttendanceAppearanceSelectionsUpdate */
export type AttendanceAppearanceSelectionsUpdatePayloadAttendancesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AttendanceFilter = {
  attendanceAppearanceSelectionsStatus?: Maybe<Array<AttendanceAppearanceSelectionsStatus>>
  type?: Maybe<Attendance>
  withSessions?: Maybe<InvestorsWithSessions>
}

/** Autogenerated input type of AttendanceInvestorSessionUpdate */
export type AttendanceInvestorSessionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  investorSessionConfiguration?: Maybe<InvestorSessionConfiguration>
}

/** Autogenerated return type of AttendanceInvestorSessionUpdate */
export type AttendanceInvestorSessionUpdatePayload = {
  __typename?: 'AttendanceInvestorSessionUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export type Attendee = {
  __typename?: 'Attendee'
  attendanceAppearanceSelectionsDetails: Maybe<AttendanceAppearanceSelectionsDetails>
  avatarUrl: Maybe<Scalars['String']>
  bio: Maybe<Scalars['String']>
  blocked: Scalars['Boolean']
  bookingRef: Maybe<Scalars['String']>
  chatAvailable: Scalars['Boolean']
  city: Maybe<Scalars['String']>
  companyName: Maybe<Scalars['String']>
  companySize: Maybe<CompanySize>
  connectionState: ConnectionState
  country: Maybe<Country>
  email: Maybe<Scalars['String']>
  exhibitor: Maybe<Appearance>
  facebookUrl: Maybe<Scalars['String']>
  firstName: Scalars['String']
  gender: Maybe<Scalars['String']>
  githubUrl: Maybe<Scalars['String']>
  id: Scalars['ID']
  industry: Maybe<Industry>
  investorGdprConsent: Scalars['Boolean']
  investorSession: Maybe<InvestorSession>
  jobTitle: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  marketingConsent: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  offeringTopics: TopicConnection
  passportNumber: Maybe<Scalars['String']>
  pendingSelectionCount: Scalars['Int']
  personalisationConsent: Maybe<Scalars['Boolean']>
  phoneNumber: Maybe<Scalars['String']>
  pronoun: Maybe<Scalars['String']>
  role: Maybe<Scalars['String']>
  seekingTopics: TopicConnection
  similarAttendees: AttendeeConnection
  talks: ScheduleTimeslotConnection
  twitterUrl: Maybe<Scalars['String']>
  voided: Maybe<Scalars['Boolean']>
}

export type AttendeeOfferingTopicsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AttendeeSeekingTopicsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AttendeeSimilarAttendeesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type AttendeeTalksArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of AttendeeBlock */
export type AttendeeBlockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AttendeeBlock */
export type AttendeeBlockPayload = {
  __typename?: 'AttendeeBlockPayload'
  attendee: Maybe<Attendee>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
}

/** Autogenerated input type of AttendeeConnect */
export type AttendeeConnectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AttendeeConnect */
export type AttendeeConnectPayload = {
  __typename?: 'AttendeeConnectPayload'
  attendee: Maybe<Attendee>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
}

/** The connection type for Attendee. */
export type AttendeeConnection = {
  __typename?: 'AttendeeConnection'
  /** A list of edges. */
  edges: Array<AttendeeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AttendeeEdge = {
  __typename?: 'AttendeeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Attendee
}

/** Autogenerated input type of AttendeeProfileUpdate */
export type AttendeeProfileUpdateInput = {
  bio?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  companySizeId?: Maybe<Scalars['ID']>
  countryId?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  industryId?: Maybe<Scalars['ID']>
  jobTitle?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  marketingConsent?: Maybe<Scalars['String']>
  offeringTopicIds?: Maybe<Array<Scalars['ID']>>
  passportNumber?: Maybe<Scalars['String']>
  personalisationConsent?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  pronoun?: Maybe<Scalars['String']>
  seekingTopicIds?: Maybe<Array<Scalars['ID']>>
}

/** Autogenerated return type of AttendeeProfileUpdate */
export type AttendeeProfileUpdatePayload = {
  __typename?: 'AttendeeProfileUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  dynamicForm: Maybe<DynamicForm>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of AttendeeUnblock */
export type AttendeeUnblockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AttendeeUnblock */
export type AttendeeUnblockPayload = {
  __typename?: 'AttendeeUnblockPayload'
  attendee: Maybe<Attendee>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
}

export type AuthAttendance = {
  __typename?: 'AuthAttendance'
  avengerAttendanceId: Scalars['ID']
  conferenceSlug: Scalars['String']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  ticketReference: Scalars['String']
}

export type AuthAttendanceCreate = {
  avengerAttendanceId: Scalars['ID']
  conferenceSlug: Scalars['String']
  metadata?: Maybe<Scalars['JSON']>
  ticketReference: Scalars['String']
}

export type AuthAttendanceCreateOrUpdate = {
  avengerAttendanceId?: Maybe<Scalars['ID']>
  conferenceSlug?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  ticketReference?: Maybe<Scalars['String']>
}

export type AuthAttendanceUpdate = {
  avengerAttendanceId?: Maybe<Scalars['ID']>
  conferenceSlug?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  ticketReference?: Maybe<Scalars['String']>
}

export type AuthAuditEntry = {
  __typename?: 'AuthAuditEntry'
  action: Maybe<AuthAuditEntryAction>
  by: Maybe<AuthUser>
  payload: Maybe<Scalars['JSON']>
  reason: Maybe<Scalars['String']>
  scopeId: Maybe<Scalars['ID']>
  scopeType: Maybe<Scalars['String']>
  target: Maybe<Scalars['ID']>
  timestamp: Maybe<Scalars['Date']>
  transactionId: Maybe<Scalars['ID']>
  type: Maybe<Scalars['String']>
}

export enum AuthAuditEntryAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Get = 'GET',
  List = 'LIST',
  NoOp = 'NO_OP',
  Update = 'UPDATE',
}

export type AuthOauth = {
  __typename?: 'AuthOauth'
  accessTokenUrl: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  emailHeaders: Maybe<Scalars['JSON']>
  emailUrl: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  loginUrl: Scalars['String']
  mapping: Maybe<Scalars['JSON']>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  properties: Maybe<Scalars['JSON']>
  slug: Scalars['String']
  userHeaders: Maybe<Scalars['JSON']>
  userUrl: Maybe<Scalars['String']>
}

export type AuthOauthCreate = {
  accessTokenUrl?: Maybe<Scalars['String']>
  emailHeaders?: Maybe<Scalars['JSON']>
  emailUrl?: Maybe<Scalars['String']>
  loginUrl: Scalars['String']
  mapping?: Maybe<Scalars['JSON']>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  properties?: Maybe<Scalars['JSON']>
  slug: Scalars['String']
  userHeaders?: Maybe<Scalars['JSON']>
  userUrl?: Maybe<Scalars['String']>
}

export type AuthOauthUpdate = {
  accessTokenUrl?: Maybe<Scalars['String']>
  emailHeaders?: Maybe<Scalars['JSON']>
  emailUrl?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  loginUrl?: Maybe<Scalars['String']>
  mapping?: Maybe<Scalars['JSON']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  properties?: Maybe<Scalars['JSON']>
  slug?: Maybe<Scalars['String']>
  userHeaders?: Maybe<Scalars['JSON']>
  userUrl?: Maybe<Scalars['String']>
}

export type AuthPageOauth = {
  __typename?: 'AuthPageOauth'
  content: Maybe<Array<AuthOauth>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<AuthPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<AuthSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type AuthPageRole = {
  __typename?: 'AuthPageRole'
  content: Maybe<Array<AuthRole>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<AuthPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<AuthSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type AuthPageUser = {
  __typename?: 'AuthPageUser'
  content: Maybe<Array<AuthUser>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<AuthPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<AuthSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type AuthPageableObject = {
  __typename?: 'AuthPageableObject'
  offset: Maybe<Scalars['Int']>
  pageNumber: Maybe<Scalars['Int']>
  pageSize: Maybe<Scalars['Int']>
  paged: Maybe<Scalars['Boolean']>
  sort: Maybe<AuthSort>
  unpaged: Maybe<Scalars['Boolean']>
}

export type AuthPermission = {
  __typename?: 'AuthPermission'
  allowed: Maybe<Scalars['Boolean']>
  permission: Maybe<Scalars['String']>
}

export type AuthRole = {
  __typename?: 'AuthRole'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  permissions: Maybe<Array<Maybe<Scalars['String']>>>
}

export type AuthRoleCreate = {
  description?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
}

export type AuthRoleCreateOrUpdate = {
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
}

export type AuthRoleUpdate = {
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
}

export type AuthSearchTerm = {
  field?: Maybe<Scalars['String']>
  op?: Maybe<AuthSearchTermOp>
  value?: Maybe<Scalars['Object']>
}

export enum AuthSearchTermOp {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne',
}

export type AuthSort = {
  __typename?: 'AuthSort'
  empty: Maybe<Scalars['Boolean']>
  sorted: Maybe<Scalars['Boolean']>
  unsorted: Maybe<Scalars['Boolean']>
}

export type AuthSortTerm = {
  direction?: Maybe<AuthSortTermDirection>
  field?: Maybe<Scalars['String']>
}

export enum AuthSortTermDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type AuthToken = {
  __typename?: 'AuthToken'
  token: Maybe<Scalars['String']>
}

export type AuthUser = {
  __typename?: 'AuthUser'
  attendances: Maybe<Array<AuthAttendance>>
  createdAt: Maybe<Scalars['Date']>
  deleted: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  permissions: Maybe<Array<Maybe<Scalars['String']>>>
  roles: Maybe<Array<AuthRole>>
  username: Scalars['String']
  verified: Maybe<Scalars['Boolean']>
}

export type AuthUserCreate = {
  attendances?: Maybe<Array<AuthAttendanceCreateOrUpdate>>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  roles?: Maybe<Array<AuthRoleCreateOrUpdate>>
  username: Scalars['String']
}

export type AuthUserUpdate = {
  attendances?: Maybe<Array<AuthAttendanceCreateOrUpdate>>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  roles?: Maybe<Array<AuthRoleCreateOrUpdate>>
  username?: Maybe<Scalars['String']>
}

/** Autogenerated input type of AuthenticateByToken */
export type AuthenticateByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  token: Scalars['String']
}

/** Autogenerated return type of AuthenticateByToken */
export type AuthenticateByTokenPayload = {
  __typename?: 'AuthenticateByTokenPayload'
  accessToken: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  user: User
  userErrors: Array<UserError>
}

export type Booking = {
  __typename?: 'Booking'
  addOns: TaAddOnConnection
  addonTypesSummary: Maybe<Array<TicketTypeInfo>>
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  orders: OrderConnection
  owner: AssignmentUser
  reference: Scalars['String']
  ticketTypesSummary: Maybe<Array<TicketTypeInfo>>
  ticketUpgrades: TaTicketUpgradeConnection
  tickets: TicketConnection
  totalHiddenTickets: Scalars['Int']
  totalInvoices: Scalars['Int']
  upgradeTypesSummary: Maybe<Array<TicketTypeInfo>>
  versions: Maybe<Array<PaperTrailVersion>>
}

export type BookingAddOnsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<BookingAddOnFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<BookingAddOnSorter>>
}

export type BookingOrdersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  onlyWithInvoices?: Maybe<Scalars['Boolean']>
}

export type BookingTicketUpgradesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<BookingUpgradeFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<BookingUpgradeSorter>>
}

export type BookingTicketsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filterV2?: Maybe<BookingTicketFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  onlyHidden?: Maybe<Scalars['Boolean']>
  search?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<BookingTicketSorter>>
}

export type BookingAddOnFilter = {
  addOnTypeIds?: Maybe<Array<Scalars['ID']>>
  assignment?: Maybe<BookingAddOnFilterAssignment>
  status?: Maybe<BookingAddOnFilterStatus>
}

export enum BookingAddOnFilterAssignment {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
}

export enum BookingAddOnFilterStatus {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
  Void = 'VOID',
}

export type BookingAddOnSorter = {
  direction?: Maybe<SortDirection>
  field?: Maybe<AddOnSortFields>
}

/** The connection type for Booking. */
export type BookingConnection = {
  __typename?: 'BookingConnection'
  /** A list of edges. */
  edges: Array<BookingEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type BookingEdge = {
  __typename?: 'BookingEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Booking
}

export type BookingFilter = {
  createdAtFrom?: Maybe<Scalars['ISO8601Date']>
  createdAtTo?: Maybe<Scalars['ISO8601Date']>
  orderIds?: Maybe<Array<Scalars['ID']>>
  reference?: Maybe<Scalars['String']>
  ticketIds?: Maybe<Array<Scalars['ID']>>
}

export type BookingTicketFilter = {
  assignment?: Maybe<BookingTicketFilterAssignment>
  status?: Maybe<BookingTicketFilterStatus>
  ticketTypeIds?: Maybe<Array<Scalars['ID']>>
}

export enum BookingTicketFilterAssignment {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
}

export enum BookingTicketFilterStatus {
  Accepted = 'ACCEPTED',
  Assigned = 'ASSIGNED',
  CheckedIn = 'CHECKED_IN',
  Duplicate = 'DUPLICATE',
  Locked = 'LOCKED',
  Rejected = 'REJECTED',
  Unassigned = 'UNASSIGNED',
  Void = 'VOID',
}

export type BookingTicketSorter = {
  direction?: Maybe<SortDirection>
  field?: Maybe<TicketSortFields>
}

export type BookingUpgradeFilter = {
  assignment?: Maybe<BookingUpgradeFilterAssignment>
  status?: Maybe<BookingUpgradeFilterStatus>
  ticketUpgradeTypeIds?: Maybe<Array<Scalars['ID']>>
}

export enum BookingUpgradeFilterAssignment {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
}

export enum BookingUpgradeFilterStatus {
  Accepted = 'ACCEPTED',
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
  Void = 'VOID',
}

export type BookingUpgradeSorter = {
  direction?: Maybe<SortDirection>
  field?: Maybe<UpgradeSortFields>
}

export type Branding = {
  __typename?: 'Branding'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  favicon: Maybe<UploadFile>
  googleFontsUrl: Maybe<Scalars['String']>
  headerBranding: Maybe<UploadFile>
  id: Scalars['ID']
  invoiceFooter: Maybe<UploadFile>
  invoiceHeader: Maybe<UploadFile>
  invoiceStamp: Maybe<UploadFile>
  logo: Maybe<UploadFile>
  theme: Maybe<Scalars['JSON']>
  ticketLogo: Maybe<UploadFile>
  title: Maybe<Scalars['String']>
  typekitFontsUrl: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type BrandingAggregator = {
  __typename?: 'BrandingAggregator'
  count: Maybe<Scalars['Int']>
  totalCount: Maybe<Scalars['Int']>
}

export type BrandingConnection = {
  __typename?: 'BrandingConnection'
  aggregate: Maybe<BrandingAggregator>
  groupBy: Maybe<BrandingGroupBy>
  values: Maybe<Array<Maybe<Branding>>>
}

export type BrandingConnectionCreatedAt = {
  __typename?: 'BrandingConnectionCreatedAt'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['DateTime']>
}

export type BrandingConnectionCreated_By = {
  __typename?: 'BrandingConnectionCreated_by'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionFavicon = {
  __typename?: 'BrandingConnectionFavicon'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionGoogleFontsUrl = {
  __typename?: 'BrandingConnectionGoogleFontsUrl'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['String']>
}

export type BrandingConnectionHeaderBranding = {
  __typename?: 'BrandingConnectionHeaderBranding'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionId = {
  __typename?: 'BrandingConnectionId'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionInvoiceFooter = {
  __typename?: 'BrandingConnectionInvoiceFooter'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionInvoiceHeader = {
  __typename?: 'BrandingConnectionInvoiceHeader'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionInvoiceStamp = {
  __typename?: 'BrandingConnectionInvoiceStamp'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionLogo = {
  __typename?: 'BrandingConnectionLogo'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionTheme = {
  __typename?: 'BrandingConnectionTheme'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['JSON']>
}

export type BrandingConnectionTicketLogo = {
  __typename?: 'BrandingConnectionTicketLogo'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnectionTitle = {
  __typename?: 'BrandingConnectionTitle'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['String']>
}

export type BrandingConnectionTypekitFontsUrl = {
  __typename?: 'BrandingConnectionTypekitFontsUrl'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['String']>
}

export type BrandingConnectionUpdatedAt = {
  __typename?: 'BrandingConnectionUpdatedAt'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['DateTime']>
}

export type BrandingConnectionUpdated_By = {
  __typename?: 'BrandingConnectionUpdated_by'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingConnection_Id = {
  __typename?: 'BrandingConnection_id'
  connection: Maybe<BrandingConnection>
  key: Maybe<Scalars['ID']>
}

export type BrandingGroupBy = {
  __typename?: 'BrandingGroupBy'
  _id: Maybe<Array<Maybe<BrandingConnection_Id>>>
  createdAt: Maybe<Array<Maybe<BrandingConnectionCreatedAt>>>
  created_by: Maybe<Array<Maybe<BrandingConnectionCreated_By>>>
  favicon: Maybe<Array<Maybe<BrandingConnectionFavicon>>>
  googleFontsUrl: Maybe<Array<Maybe<BrandingConnectionGoogleFontsUrl>>>
  headerBranding: Maybe<Array<Maybe<BrandingConnectionHeaderBranding>>>
  id: Maybe<Array<Maybe<BrandingConnectionId>>>
  invoiceFooter: Maybe<Array<Maybe<BrandingConnectionInvoiceFooter>>>
  invoiceHeader: Maybe<Array<Maybe<BrandingConnectionInvoiceHeader>>>
  invoiceStamp: Maybe<Array<Maybe<BrandingConnectionInvoiceStamp>>>
  logo: Maybe<Array<Maybe<BrandingConnectionLogo>>>
  theme: Maybe<Array<Maybe<BrandingConnectionTheme>>>
  ticketLogo: Maybe<Array<Maybe<BrandingConnectionTicketLogo>>>
  title: Maybe<Array<Maybe<BrandingConnectionTitle>>>
  typekitFontsUrl: Maybe<Array<Maybe<BrandingConnectionTypekitFontsUrl>>>
  updatedAt: Maybe<Array<Maybe<BrandingConnectionUpdatedAt>>>
  updated_by: Maybe<Array<Maybe<BrandingConnectionUpdated_By>>>
}

export type BrandingInput = {
  created_by?: Maybe<Scalars['ID']>
  events?: Maybe<Array<Scalars['ID']>>
  favicon?: Maybe<Scalars['ID']>
  googleFontsUrl?: Maybe<Scalars['String']>
  headerBranding?: Maybe<Scalars['ID']>
  invoiceFooter?: Maybe<Scalars['ID']>
  invoiceHeader?: Maybe<Scalars['ID']>
  invoiceStamp?: Maybe<Scalars['ID']>
  logo?: Maybe<Scalars['ID']>
  theme?: Maybe<Scalars['JSON']>
  ticketLogo?: Maybe<Scalars['ID']>
  title?: Maybe<Scalars['String']>
  typekitFontsUrl?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type ChatChannel = {
  __typename?: 'ChatChannel'
  id: Scalars['ID']
  lastMessage: Maybe<ChatMessage>
  members: ChatUserConnection
  name: Maybe<Scalars['String']>
  provider: ChatProvider
  providerId: Maybe<Scalars['String']>
  status: ChatStatus
}

export type ChatChannelMembersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for ChatChannel. */
export type ChatChannelConnection = {
  __typename?: 'ChatChannelConnection'
  /** A list of edges. */
  edges: Array<ChatChannelEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated input type of ChatChannelCreate */
export type ChatChannelCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  participants: Array<Scalars['ID']>
  provider?: Maybe<ChatProvider>
}

/** Autogenerated return type of ChatChannelCreate */
export type ChatChannelCreatePayload = {
  __typename?: 'ChatChannelCreatePayload'
  chatChannel: Maybe<ChatChannel>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** An edge in a connection. */
export type ChatChannelEdge = {
  __typename?: 'ChatChannelEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ChatChannel
}

export type ChatMessage = {
  __typename?: 'ChatMessage'
  body: Maybe<Scalars['String']>
  id: Scalars['ID']
  providerId: Scalars['ID']
  sender: ChatUser
  sentAt: Scalars['ISO8601DateTime']
}

export enum ChatProvider {
  Pubnub = 'PUBNUB',
  Twilio = 'TWILIO',
}

export enum ChatStatus {
  /** Chats from your connections and other trusted chats */
  Message = 'MESSAGE',
  /** Chats from people you are not connected with */
  Request = 'REQUEST',
}

export type ChatUser = {
  __typename?: 'ChatUser'
  avatarUrl: Maybe<Scalars['String']>
  id: Scalars['ID']
  identity: Scalars['ID']
  name: Scalars['String']
  profile: Attendee
}

/** The connection type for ChatUser. */
export type ChatUserConnection = {
  __typename?: 'ChatUserConnection'
  /** A list of edges. */
  edges: Array<ChatUserEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ChatUserEdge = {
  __typename?: 'ChatUserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ChatUser
}

export type CheckInDetails = {
  __typename?: 'CheckInDetails'
  checkInStation: Maybe<Scalars['String']>
  checkedInAt: Maybe<Scalars['ISO8601DateTime']>
}

export type CheckedIn = {
  __typename?: 'CheckedIn'
  count: Scalars['Int']
}

export type CommerceAddress = {
  __typename?: 'CommerceAddress'
  city: Scalars['String']
  country: Scalars['String']
  countryName: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  line1: Scalars['String']
  line2: Maybe<Scalars['String']>
  metadata: Maybe<Scalars['JSON']>
  owner: Maybe<AuthUser>
  postalCode: Scalars['String']
  state: Maybe<Scalars['String']>
}

export type CommerceAddressCreate = {
  city: Scalars['String']
  country: Scalars['String']
  line1: Scalars['String']
  line2?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  postalCode: Scalars['String']
  state?: Maybe<Scalars['String']>
}

export type CommerceAddressCreateOrUpdate = {
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  line1?: Maybe<Scalars['String']>
  line2?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type CommerceAddressUpdate = {
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  line1?: Maybe<Scalars['String']>
  line2?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type CommerceAuditEntry = {
  __typename?: 'CommerceAuditEntry'
  action: Maybe<CommerceAuditEntryAction>
  by: Maybe<AuthUser>
  payload: Maybe<Scalars['JSON']>
  reason: Maybe<Scalars['String']>
  scopeId: Maybe<Scalars['ID']>
  scopeType: Maybe<Scalars['String']>
  target: Maybe<Scalars['ID']>
  timestamp: Maybe<Scalars['Date']>
  transactionId: Maybe<Scalars['ID']>
  type: Maybe<Scalars['String']>
}

export enum CommerceAuditEntryAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Get = 'GET',
  List = 'LIST',
  NoOp = 'NO_OP',
  Update = 'UPDATE',
}

export type CommerceCategory = {
  __typename?: 'CommerceCategory'
  active: Maybe<Scalars['Boolean']>
  children: Maybe<Array<CommerceCategory>>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  parent: Maybe<CommerceCategory>
  products: Maybe<Array<CommerceProduct>>
}

export type CommerceCategoryCreate = {
  active?: Maybe<Scalars['Boolean']>
  children?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  description?: Maybe<Scalars['String']>
  name: Scalars['String']
  parent?: Maybe<Scalars['ID']>
  products?: Maybe<Array<CommerceProductCreateOrUpdate>>
}

export type CommerceCategoryCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  children?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  parent?: Maybe<Scalars['ID']>
  products?: Maybe<Array<CommerceProductCreateOrUpdate>>
}

export type CommerceCategoryUpdate = {
  active?: Maybe<Scalars['Boolean']>
  children?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  parent?: Maybe<Scalars['ID']>
  products?: Maybe<Array<CommerceProductCreateOrUpdate>>
}

export type CommerceCode = {
  __typename?: 'CommerceCode'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  deal: Maybe<CommerceDeal>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  slug: Maybe<Scalars['String']>
  timesUsed: Maybe<Scalars['Int']>
  type: Maybe<CommerceCodeType>
  usages: Maybe<Scalars['Int']>
  voucher: Maybe<CommerceVoucher>
}

export type CommerceCodeCreate = {
  deal?: Maybe<CommerceDealCreateOrUpdate>
  metadata?: Maybe<Scalars['JSON']>
  slug?: Maybe<Scalars['String']>
  usages?: Maybe<Scalars['Int']>
  voucher?: Maybe<CommerceVoucherCreateOrUpdate>
}

export type CommerceCodeCreateOrUpdate = {
  deal?: Maybe<CommerceDealCreateOrUpdate>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  slug?: Maybe<Scalars['String']>
  usages?: Maybe<Scalars['Int']>
  voucher?: Maybe<CommerceVoucherCreateOrUpdate>
}

export enum CommerceCodeType {
  Deal = 'DEAL',
  Voucher = 'VOUCHER',
}

export type CommerceCodeUpdate = {
  deal?: Maybe<CommerceDealCreateOrUpdate>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  slug?: Maybe<Scalars['String']>
  usages?: Maybe<Scalars['Int']>
  voucher?: Maybe<CommerceVoucherCreateOrUpdate>
}

export type CommerceCustomer = {
  __typename?: 'CommerceCustomer'
  address: Maybe<CommerceAddress>
  companyName: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  email: Scalars['String']
  firstName: Scalars['String']
  id: Maybe<Scalars['ID']>
  lastName: Scalars['String']
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  owner: Maybe<AuthUser>
  phoneNumber: Maybe<Scalars['String']>
  vatNumber: Maybe<Scalars['String']>
  vatVerified: Maybe<Scalars['Boolean']>
}

export type CommerceCustomerCreate = {
  address?: Maybe<CommerceAddressCreateOrUpdate>
  companyName?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  metadata?: Maybe<Scalars['JSON']>
  phoneNumber?: Maybe<Scalars['String']>
  vatNumber?: Maybe<Scalars['String']>
}

export type CommerceCustomerCreateOrUpdate = {
  address?: Maybe<CommerceAddressCreateOrUpdate>
  companyName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  lastName?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  phoneNumber?: Maybe<Scalars['String']>
  vatNumber?: Maybe<Scalars['String']>
}

export type CommerceCustomerUpdate = {
  address?: Maybe<CommerceAddressCreateOrUpdate>
  companyName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  lastName?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  phoneNumber?: Maybe<Scalars['String']>
  vatNumber?: Maybe<Scalars['String']>
}

export type CommerceDeal = {
  __typename?: 'CommerceDeal'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  dealItems: Maybe<Array<CommerceDealItem>>
  description: Maybe<Scalars['String']>
  endDate: Scalars['Date']
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  startDate: Scalars['Date']
  timesUsed: Maybe<Scalars['Int']>
}

export type CommerceDealCreate = {
  active?: Maybe<Scalars['Boolean']>
  dealItems?: Maybe<Array<CommerceDealItemCreateOrUpdate>>
  description?: Maybe<Scalars['String']>
  endDate: Scalars['Date']
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  startDate: Scalars['Date']
}

export type CommerceDealCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  dealItems?: Maybe<Array<CommerceDealItemCreateOrUpdate>>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['Date']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['Date']>
}

export type CommerceDealItem = {
  __typename?: 'CommerceDealItem'
  amount: Scalars['Float']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  max: Scalars['Int']
  metadata: Maybe<Scalars['JSON']>
  min: Scalars['Int']
  name: Maybe<Scalars['String']>
  product: Maybe<CommerceProduct>
  step: Scalars['Int']
  type: CommerceDealItemType
}

export type CommerceDealItemCreate = {
  amount: Scalars['Float']
  max: Scalars['Int']
  min: Scalars['Int']
  name?: Maybe<Scalars['String']>
  product: Scalars['ID']
  step: Scalars['Int']
  type: CommerceDealItemType
}

export type CommerceDealItemCreateOrUpdate = {
  amount?: Maybe<Scalars['Float']>
  id?: Maybe<Scalars['ID']>
  max?: Maybe<Scalars['Int']>
  min?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['ID']>
  step?: Maybe<Scalars['Int']>
  type?: Maybe<CommerceDealItemType>
}

export enum CommerceDealItemType {
  AbsoluteDiscount = 'ABSOLUTE_DISCOUNT',
  AbsolutePrice = 'ABSOLUTE_PRICE',
  PercentageDiscount = 'PERCENTAGE_DISCOUNT',
}

export type CommerceDealItemUpdate = {
  amount?: Maybe<Scalars['Float']>
  id?: Maybe<Scalars['ID']>
  max?: Maybe<Scalars['Int']>
  min?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['ID']>
  step?: Maybe<Scalars['Int']>
  type?: Maybe<CommerceDealItemType>
}

export type CommerceDealUpdate = {
  active?: Maybe<Scalars['Boolean']>
  dealItems?: Maybe<Array<CommerceDealItemCreateOrUpdate>>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['Date']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['Date']>
}

export type CommerceOrder = {
  __typename?: 'CommerceOrder'
  billed: Maybe<Scalars['Int']>
  codes: Maybe<Array<Maybe<CommerceCode>>>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  currency: Maybe<Scalars['String']>
  currencySymbol: Maybe<Scalars['String']>
  customer: Maybe<CommerceCustomer>
  dealDiscount: Maybe<Scalars['Float']>
  discountCodes: Maybe<Array<Maybe<Scalars['String']>>>
  discountTotal: Maybe<Scalars['Float']>
  finished: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['ID']>
  intraEU: Maybe<Scalars['Boolean']>
  invoiceUrl: Maybe<Scalars['String']>
  items: Array<CommerceOrderItem>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  locale: Maybe<Scalars['String']>
  locked: Maybe<Scalars['Boolean']>
  marketingMetadata: Maybe<Scalars['JSON']>
  metadata: Maybe<Scalars['JSON']>
  newCodes: Maybe<Array<Maybe<CommerceCode>>>
  note: Maybe<Scalars['String']>
  owner: AuthUser
  paid: Maybe<Scalars['Int']>
  paymentMethod: Maybe<CommercePaymentMethod>
  paymentStatus: Maybe<CommerceOrderPaymentStatus>
  paymentSubsystem: Maybe<CommerceOrderPaymentSubsystem>
  pending: Maybe<Scalars['Int']>
  reference: Maybe<Scalars['String']>
  refundUrls: Maybe<Scalars['JSON']>
  refunded: Maybe<Scalars['Int']>
  reinstated: Maybe<Scalars['Boolean']>
  sendInvoice: Maybe<Scalars['Boolean']>
  sendRefundReceipts: Maybe<Scalars['Boolean']>
  status: Maybe<CommerceOrderStatus>
  subTotal: Maybe<Scalars['Float']>
  taxTotal: Maybe<Scalars['Float']>
  taxes: Maybe<Array<CommerceTaxSummary>>
  total: Maybe<Scalars['Float']>
  transactions: Maybe<Array<Maybe<CommerceTransaction>>>
  url: Maybe<Scalars['String']>
  valueTotal: Maybe<Scalars['Float']>
  voucherDiscount: Maybe<Scalars['Float']>
}

export type CommerceOrderCreate = {
  billed?: Maybe<Scalars['Int']>
  codes?: Maybe<Array<Maybe<CommerceCodeCreateOrUpdate>>>
  customer?: Maybe<CommerceCustomerCreateOrUpdate>
  dealDiscount?: Maybe<Scalars['Float']>
  discountCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  finished?: Maybe<Scalars['Boolean']>
  invoiceUrl?: Maybe<Scalars['String']>
  items: Array<CommerceOrderItemCreateOrUpdate>
  locale?: Maybe<Scalars['String']>
  locked?: Maybe<Scalars['Boolean']>
  marketingMetadata?: Maybe<Scalars['JSON']>
  metadata?: Maybe<Scalars['JSON']>
  newCodes?: Maybe<Array<Maybe<CommerceCodeCreateOrUpdate>>>
  note?: Maybe<Scalars['String']>
  paid?: Maybe<Scalars['Int']>
  paymentMethod?: Maybe<Scalars['ID']>
  paymentSubsystem?: Maybe<CommerceOrderPaymentSubsystem>
  pending?: Maybe<Scalars['Int']>
  refundUrls?: Maybe<Scalars['JSON']>
  sendInvoice?: Maybe<Scalars['Boolean']>
  sendRefundReceipts?: Maybe<Scalars['Boolean']>
  status?: Maybe<CommerceOrderStatus>
  taxes?: Maybe<Array<CommerceTaxSummaryCreateOrUpdate>>
  voucherDiscount?: Maybe<Scalars['Float']>
}

export type CommerceOrderItem = {
  __typename?: 'CommerceOrderItem'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  dealDiscount: Maybe<Scalars['Float']>
  discountTotal: Maybe<Scalars['Float']>
  id: Maybe<Scalars['ID']>
  itemName: Maybe<Scalars['String']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  price: Maybe<Scalars['Float']>
  product: Maybe<CommerceProduct>
  quantity: Scalars['Int']
  subTotal: Maybe<Scalars['Float']>
  tax: Maybe<CommerceTax>
  taxTotal: Maybe<Scalars['Float']>
  total: Maybe<Scalars['Float']>
  valueTotal: Maybe<Scalars['Float']>
  voucherDiscount: Maybe<Scalars['Float']>
}

export type CommerceOrderItemCreate = {
  dealDiscount?: Maybe<Scalars['Float']>
  itemName?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  price?: Maybe<Scalars['Float']>
  product: Scalars['ID']
  quantity: Scalars['Int']
  valueTotal?: Maybe<Scalars['Float']>
  voucherDiscount?: Maybe<Scalars['Float']>
}

export type CommerceOrderItemCreateOrUpdate = {
  dealDiscount?: Maybe<Scalars['Float']>
  id?: Maybe<Scalars['ID']>
  itemName?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  price?: Maybe<Scalars['Float']>
  product?: Maybe<Scalars['ID']>
  quantity?: Maybe<Scalars['Int']>
  valueTotal?: Maybe<Scalars['Float']>
  voucherDiscount?: Maybe<Scalars['Float']>
}

export type CommerceOrderItemUpdate = {
  dealDiscount?: Maybe<Scalars['Float']>
  id?: Maybe<Scalars['ID']>
  itemName?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  price?: Maybe<Scalars['Float']>
  product?: Maybe<Scalars['ID']>
  quantity?: Maybe<Scalars['Int']>
  valueTotal?: Maybe<Scalars['Float']>
  voucherDiscount?: Maybe<Scalars['Float']>
}

export enum CommerceOrderPaymentStatus {
  Overpaid = 'OVERPAID',
  Paid = 'PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  PendingRefund = 'PENDING_REFUND',
  Refunded = 'REFUNDED',
}

export enum CommerceOrderPaymentSubsystem {
  ApplePay = 'APPLE_PAY',
  CreditCard = 'CREDIT_CARD',
  Paypal = 'PAYPAL',
}

export enum CommerceOrderStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
}

export type CommerceOrderUpdate = {
  billed?: Maybe<Scalars['Int']>
  codes?: Maybe<Array<Maybe<CommerceCodeCreateOrUpdate>>>
  customer?: Maybe<CommerceCustomerCreateOrUpdate>
  dealDiscount?: Maybe<Scalars['Float']>
  discountCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  finished?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  invoiceUrl?: Maybe<Scalars['String']>
  items?: Maybe<Array<CommerceOrderItemCreateOrUpdate>>
  locale?: Maybe<Scalars['String']>
  locked?: Maybe<Scalars['Boolean']>
  marketingMetadata?: Maybe<Scalars['JSON']>
  metadata?: Maybe<Scalars['JSON']>
  newCodes?: Maybe<Array<Maybe<CommerceCodeCreateOrUpdate>>>
  note?: Maybe<Scalars['String']>
  paid?: Maybe<Scalars['Int']>
  paymentMethod?: Maybe<Scalars['ID']>
  paymentSubsystem?: Maybe<CommerceOrderPaymentSubsystem>
  pending?: Maybe<Scalars['Int']>
  refundUrls?: Maybe<Scalars['JSON']>
  sendInvoice?: Maybe<Scalars['Boolean']>
  sendRefundReceipts?: Maybe<Scalars['Boolean']>
  status?: Maybe<CommerceOrderStatus>
  taxes?: Maybe<Array<CommerceTaxSummaryCreateOrUpdate>>
  voucherDiscount?: Maybe<Scalars['Float']>
}

export type CommercePackagedProduct = {
  __typename?: 'CommercePackagedProduct'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  packagedProduct: Maybe<CommerceProduct>
  quantity: Scalars['Int']
}

export type CommercePackagedProductCreate = {
  metadata?: Maybe<Scalars['JSON']>
  packagedProduct: Scalars['ID']
  quantity: Scalars['Int']
}

export type CommercePackagedProductCreateOrUpdate = {
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  packagedProduct?: Maybe<Scalars['ID']>
  quantity?: Maybe<Scalars['Int']>
}

export type CommercePackagedProductUpdate = {
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  packagedProduct?: Maybe<Scalars['ID']>
  quantity?: Maybe<Scalars['Int']>
}

export type CommercePageCategory = {
  __typename?: 'CommercePageCategory'
  content: Maybe<Array<CommerceCategory>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageCode = {
  __typename?: 'CommercePageCode'
  content: Maybe<Array<Maybe<CommerceCode>>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageCustomer = {
  __typename?: 'CommercePageCustomer'
  content: Maybe<Array<CommerceCustomer>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageDeal = {
  __typename?: 'CommercePageDeal'
  content: Maybe<Array<CommerceDeal>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageDealItem = {
  __typename?: 'CommercePageDealItem'
  content: Maybe<Array<CommerceDealItem>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageOrder = {
  __typename?: 'CommercePageOrder'
  content: Maybe<Array<CommerceOrder>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePagePackagedProduct = {
  __typename?: 'CommercePagePackagedProduct'
  content: Maybe<Array<CommercePackagedProduct>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePagePaymentGateway = {
  __typename?: 'CommercePagePaymentGateway'
  content: Maybe<Array<Maybe<CommercePaymentGateway>>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePagePaymentMethod = {
  __typename?: 'CommercePagePaymentMethod'
  content: Maybe<Array<CommercePaymentMethod>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageProduct = {
  __typename?: 'CommercePageProduct'
  content: Maybe<Array<CommerceProduct>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageProductOrderCancellation = {
  __typename?: 'CommercePageProductOrderCancellation'
  content: Maybe<Array<Maybe<CommerceProductOrderCancellation>>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageSale = {
  __typename?: 'CommercePageSale'
  content: Maybe<Array<CommerceSale>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageSaleProduct = {
  __typename?: 'CommercePageSaleProduct'
  content: Maybe<Array<CommerceSaleProduct>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageStore = {
  __typename?: 'CommercePageStore'
  content: Maybe<Array<CommerceStore>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageTag = {
  __typename?: 'CommercePageTag'
  content: Maybe<Array<CommerceTag>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageTax = {
  __typename?: 'CommercePageTax'
  content: Maybe<Array<CommerceTax>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageTaxType = {
  __typename?: 'CommercePageTaxType'
  content: Maybe<Array<CommerceTaxType>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageVoucher = {
  __typename?: 'CommercePageVoucher'
  content: Maybe<Array<CommerceVoucher>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<CommercePageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<CommerceSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type CommercePageableObject = {
  __typename?: 'CommercePageableObject'
  offset: Maybe<Scalars['Int']>
  pageNumber: Maybe<Scalars['Int']>
  pageSize: Maybe<Scalars['Int']>
  paged: Maybe<Scalars['Boolean']>
  sort: Maybe<CommerceSort>
  unpaged: Maybe<Scalars['Boolean']>
}

export type CommercePaymentGateway = {
  __typename?: 'CommercePaymentGateway'
  configKeys: Maybe<Array<Maybe<Scalars['String']>>>
  id: Maybe<Scalars['ID']>
  name: Maybe<Scalars['String']>
  sensitiveKeys: Maybe<Array<Maybe<Scalars['String']>>>
}

export type CommercePaymentMethod = {
  __typename?: 'CommercePaymentMethod'
  active: Maybe<Scalars['Boolean']>
  configuration: Maybe<Scalars['JSON']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  gateway: Scalars['ID']
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
}

export type CommercePaymentMethodCreate = {
  active?: Maybe<Scalars['Boolean']>
  configuration?: Maybe<Scalars['JSON']>
  gateway: Scalars['ID']
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
}

export type CommercePaymentMethodCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  configuration?: Maybe<Scalars['JSON']>
  gateway?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
}

export type CommercePaymentMethodUpdate = {
  active?: Maybe<Scalars['Boolean']>
  configuration?: Maybe<Scalars['JSON']>
  gateway?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
}

export type CommerceProduct = {
  __typename?: 'CommerceProduct'
  active: Maybe<Scalars['Boolean']>
  ancillaryType: Maybe<CommerceProductAncillaryType>
  applicableTo: Maybe<Array<CommerceProduct>>
  assignable: Maybe<Scalars['Boolean']>
  availableAncillaries: Maybe<Array<CommerceProduct>>
  categories: Maybe<Array<CommerceCategory>>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  defaultPrice: Maybe<Scalars['Float']>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  level: Maybe<Scalars['Int']>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  onSale: Maybe<Scalars['Boolean']>
  packagedProducts: Maybe<Array<CommercePackagedProduct>>
  packages: Maybe<Array<CommerceProduct>>
  price: Scalars['Float']
  tags: Maybe<Array<CommerceTag>>
  taxMode: Maybe<CommerceProductTaxMode>
  taxType: CommerceTaxType
  timesUsed: Maybe<Scalars['Int']>
  type: Maybe<CommerceProductType>
  upgradeTo: Maybe<Scalars['ID']>
}

export enum CommerceProductAncillaryType {
  AddOn = 'ADD_ON',
  Na = 'NA',
  Upgrade = 'UPGRADE',
}

export type CommerceProductCreate = {
  active?: Maybe<Scalars['Boolean']>
  ancillaryType?: Maybe<CommerceProductAncillaryType>
  applicableTo?: Maybe<Array<CommerceProductCreateOrUpdate>>
  assignable?: Maybe<Scalars['Boolean']>
  categories?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  defaultPrice?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  packagedProducts?: Maybe<Array<CommercePackagedProductCreateOrUpdate>>
  packages?: Maybe<Array<CommerceProductCreateOrUpdate>>
  price: Scalars['Float']
  tags?: Maybe<Array<CommerceTagCreateOrUpdate>>
  taxMode?: Maybe<CommerceProductTaxMode>
  taxType: CommerceTaxTypeCreateOrUpdate
  timesUsed?: Maybe<Scalars['Int']>
  type?: Maybe<CommerceProductType>
  upgradeTo?: Maybe<Scalars['ID']>
}

export type CommerceProductCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  ancillaryType?: Maybe<CommerceProductAncillaryType>
  applicableTo?: Maybe<Array<CommerceProductCreateOrUpdate>>
  assignable?: Maybe<Scalars['Boolean']>
  categories?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  defaultPrice?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  level?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  packagedProducts?: Maybe<Array<CommercePackagedProductCreateOrUpdate>>
  packages?: Maybe<Array<CommerceProductCreateOrUpdate>>
  price?: Maybe<Scalars['Float']>
  tags?: Maybe<Array<CommerceTagCreateOrUpdate>>
  taxMode?: Maybe<CommerceProductTaxMode>
  taxType?: Maybe<CommerceTaxTypeCreateOrUpdate>
  timesUsed?: Maybe<Scalars['Int']>
  type?: Maybe<CommerceProductType>
  upgradeTo?: Maybe<Scalars['ID']>
}

export type CommerceProductOrderCancellation = {
  __typename?: 'CommerceProductOrderCancellation'
  completedAt: Maybe<Scalars['Date']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  status: Maybe<CommerceProductOrderCancellationStatus>
}

export type CommerceProductOrderCancellationCreate = {
  completedAt?: Maybe<Scalars['Date']>
  metadata?: Maybe<Scalars['JSON']>
  status?: Maybe<CommerceProductOrderCancellationStatus>
}

export enum CommerceProductOrderCancellationStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING',
}

export type CommerceProductOrderCancellationUpdate = {
  completedAt?: Maybe<Scalars['Date']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  status?: Maybe<CommerceProductOrderCancellationStatus>
}

export enum CommerceProductTaxMode {
  B2B = 'B2B',
  B2C = 'B2C',
}

export enum CommerceProductType {
  Ancillary = 'ANCILLARY',
  Package = 'PACKAGE',
  Simple = 'SIMPLE',
}

export type CommerceProductUpdate = {
  active?: Maybe<Scalars['Boolean']>
  ancillaryType?: Maybe<CommerceProductAncillaryType>
  applicableTo?: Maybe<Array<CommerceProductCreateOrUpdate>>
  assignable?: Maybe<Scalars['Boolean']>
  categories?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  defaultPrice?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  level?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  packagedProducts?: Maybe<Array<CommercePackagedProductCreateOrUpdate>>
  packages?: Maybe<Array<CommerceProductCreateOrUpdate>>
  price?: Maybe<Scalars['Float']>
  tags?: Maybe<Array<CommerceTagCreateOrUpdate>>
  taxMode?: Maybe<CommerceProductTaxMode>
  taxType?: Maybe<CommerceTaxTypeCreateOrUpdate>
  timesUsed?: Maybe<Scalars['Int']>
  type?: Maybe<CommerceProductType>
  upgradeTo?: Maybe<Scalars['ID']>
}

export type CommerceSale = {
  __typename?: 'CommerceSale'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  description: Maybe<Scalars['String']>
  endDate: Scalars['Date']
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  saleProducts: Maybe<Array<CommerceSaleProduct>>
  startDate: Scalars['Date']
}

export type CommerceSaleCreate = {
  active?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  endDate: Scalars['Date']
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  saleProducts?: Maybe<Array<CommerceSaleProductCreateOrUpdate>>
  startDate: Scalars['Date']
}

export type CommerceSaleCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['Date']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  saleProducts?: Maybe<Array<CommerceSaleProductCreateOrUpdate>>
  startDate?: Maybe<Scalars['Date']>
}

export type CommerceSaleProduct = {
  __typename?: 'CommerceSaleProduct'
  active: Maybe<Scalars['Boolean']>
  amount: Scalars['Float']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Maybe<Scalars['String']>
  price: Maybe<Scalars['Float']>
  product: Maybe<CommerceProduct>
  type: CommerceSaleProductType
}

export type CommerceSaleProductCreate = {
  active?: Maybe<Scalars['Boolean']>
  amount: Scalars['Float']
  description?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  product: Scalars['ID']
  type: CommerceSaleProductType
}

export type CommerceSaleProductCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  amount?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['ID']>
  type?: Maybe<CommerceSaleProductType>
}

export enum CommerceSaleProductType {
  AbsoluteDiscount = 'ABSOLUTE_DISCOUNT',
  AbsolutePrice = 'ABSOLUTE_PRICE',
  PercentageDiscount = 'PERCENTAGE_DISCOUNT',
}

export type CommerceSaleProductUpdate = {
  active?: Maybe<Scalars['Boolean']>
  amount?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['ID']>
  type?: Maybe<CommerceSaleProductType>
}

export type CommerceSaleUpdate = {
  active?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['Date']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  saleProducts?: Maybe<Array<CommerceSaleProductCreateOrUpdate>>
  startDate?: Maybe<Scalars['Date']>
}

export type CommerceSearchTerm = {
  field?: Maybe<Scalars['String']>
  op?: Maybe<CommerceSearchTermOp>
  value?: Maybe<Scalars['Object']>
}

export enum CommerceSearchTermOp {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne',
}

export type CommerceSort = {
  __typename?: 'CommerceSort'
  empty: Maybe<Scalars['Boolean']>
  sorted: Maybe<Scalars['Boolean']>
  unsorted: Maybe<Scalars['Boolean']>
}

export type CommerceSortTerm = {
  direction?: Maybe<CommerceSortTermDirection>
  field?: Maybe<Scalars['String']>
}

export enum CommerceSortTermDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type CommerceStore = {
  __typename?: 'CommerceStore'
  active: Maybe<Scalars['Boolean']>
  baseUrl: Scalars['String']
  categories: Maybe<Array<CommerceCategory>>
  country: Scalars['String']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  currency: Scalars['String']
  currencySymbol: Maybe<Scalars['String']>
  currentSales: Maybe<Array<CommerceSale>>
  deals: Maybe<Array<CommerceDeal>>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  paymentMethods: Maybe<Array<CommercePaymentMethod>>
  products: Maybe<Array<CommerceProduct>>
  sales: Maybe<Array<CommerceSale>>
  slug: Scalars['String']
  stockMode: CommerceStoreStockMode
  storeBilling: CommerceStoreBilling
  tags: Maybe<Array<CommerceTag>>
  taxErrors: Maybe<Array<Maybe<Scalars['String']>>>
  taxTypes: Maybe<Array<CommerceTaxType>>
  taxes: Maybe<Array<CommerceTax>>
  vatNumber: Scalars['String']
  vouchers: Maybe<Array<CommerceVoucher>>
}

export type CommerceStoreBilling = {
  __typename?: 'CommerceStoreBilling'
  city: Scalars['String']
  companyName: Scalars['String']
  companyRegNumber: Maybe<Scalars['String']>
  country: Scalars['String']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  email: Scalars['String']
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  line1: Scalars['String']
  line2: Maybe<Scalars['String']>
  metadata: Maybe<Scalars['JSON']>
  note: Maybe<Scalars['String']>
  phone: Scalars['String']
  postalCode: Scalars['String']
  state: Maybe<Scalars['String']>
  vatNumber: Scalars['String']
}

export type CommerceStoreBillingCreate = {
  city: Scalars['String']
  companyName: Scalars['String']
  companyRegNumber?: Maybe<Scalars['String']>
  country: Scalars['String']
  email: Scalars['String']
  line1: Scalars['String']
  line2?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  note?: Maybe<Scalars['String']>
  phone: Scalars['String']
  postalCode: Scalars['String']
  state?: Maybe<Scalars['String']>
  vatNumber: Scalars['String']
}

export type CommerceStoreBillingCreateOrUpdate = {
  city?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  companyRegNumber?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  line1?: Maybe<Scalars['String']>
  line2?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  note?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  vatNumber?: Maybe<Scalars['String']>
}

export type CommerceStoreBillingUpdate = {
  city?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  companyRegNumber?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  line1?: Maybe<Scalars['String']>
  line2?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  note?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  vatNumber?: Maybe<Scalars['String']>
}

export type CommerceStoreCreate = {
  active?: Maybe<Scalars['Boolean']>
  baseUrl: Scalars['String']
  categories?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  country: Scalars['String']
  currency: Scalars['String']
  deals?: Maybe<Array<CommerceDealCreateOrUpdate>>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  paymentMethods?: Maybe<Array<CommercePaymentMethodCreateOrUpdate>>
  products?: Maybe<Array<CommerceProductCreateOrUpdate>>
  sales?: Maybe<Array<CommerceSaleCreateOrUpdate>>
  slug: Scalars['String']
  stockMode: CommerceStoreStockMode
  storeBilling: CommerceStoreBillingCreateOrUpdate
  tags?: Maybe<Array<CommerceTagCreateOrUpdate>>
  taxErrors?: Maybe<Array<Maybe<Scalars['String']>>>
  taxTypes?: Maybe<Array<CommerceTaxTypeCreateOrUpdate>>
  taxes?: Maybe<Array<CommerceTaxCreateOrUpdate>>
  vatNumber: Scalars['String']
  vouchers?: Maybe<Array<CommerceVoucherCreateOrUpdate>>
}

export enum CommerceStoreStockMode {
  None = 'NONE',
  Sale = 'SALE',
}

export type CommerceStoreUpdate = {
  active?: Maybe<Scalars['Boolean']>
  baseUrl?: Maybe<Scalars['String']>
  categories?: Maybe<Array<CommerceCategoryCreateOrUpdate>>
  country?: Maybe<Scalars['String']>
  currency?: Maybe<Scalars['String']>
  deals?: Maybe<Array<CommerceDealCreateOrUpdate>>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  paymentMethods?: Maybe<Array<CommercePaymentMethodCreateOrUpdate>>
  products?: Maybe<Array<CommerceProductCreateOrUpdate>>
  sales?: Maybe<Array<CommerceSaleCreateOrUpdate>>
  slug?: Maybe<Scalars['String']>
  stockMode?: Maybe<CommerceStoreStockMode>
  storeBilling?: Maybe<CommerceStoreBillingCreateOrUpdate>
  tags?: Maybe<Array<CommerceTagCreateOrUpdate>>
  taxErrors?: Maybe<Array<Maybe<Scalars['String']>>>
  taxTypes?: Maybe<Array<CommerceTaxTypeCreateOrUpdate>>
  taxes?: Maybe<Array<CommerceTaxCreateOrUpdate>>
  vatNumber?: Maybe<Scalars['String']>
  vouchers?: Maybe<Array<CommerceVoucherCreateOrUpdate>>
}

export type CommerceTag = {
  __typename?: 'CommerceTag'
  code: Scalars['String']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
}

export type CommerceTagCreate = {
  code: Scalars['String']
  description?: Maybe<Scalars['String']>
  name: Scalars['String']
}

export type CommerceTagCreateOrUpdate = {
  code?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
}

export type CommerceTagUpdate = {
  code?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
}

export type CommerceTax = {
  __typename?: 'CommerceTax'
  country: Scalars['String']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  note: Maybe<Scalars['String']>
  rateAmount: Scalars['Float']
  rateType: CommerceTaxRateType
  taxType: CommerceTaxType
}

export type CommerceTaxCreate = {
  country: Scalars['String']
  name: Scalars['String']
  note?: Maybe<Scalars['String']>
  rateAmount: Scalars['Float']
  rateType: CommerceTaxRateType
  taxType: CommerceTaxTypeCreateOrUpdate
}

export type CommerceTaxCreateOrUpdate = {
  country?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  rateAmount?: Maybe<Scalars['Float']>
  rateType?: Maybe<CommerceTaxRateType>
  taxType?: Maybe<CommerceTaxTypeCreateOrUpdate>
}

export type CommerceTaxDetail = {
  __typename?: 'CommerceTaxDetail'
  taxId: Scalars['ID']
  total: Scalars['Int']
}

export type CommerceTaxDetailCreate = {
  taxId: Scalars['ID']
  total: Scalars['Int']
}

export type CommerceTaxDetailCreateOrUpdate = {
  taxId?: Maybe<Scalars['ID']>
  total?: Maybe<Scalars['Int']>
}

export type CommerceTaxDetailUpdate = {
  taxId?: Maybe<Scalars['ID']>
  total?: Maybe<Scalars['Int']>
}

export enum CommerceTaxRateType {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE',
}

export type CommerceTaxSummary = {
  __typename?: 'CommerceTaxSummary'
  name: Maybe<Scalars['String']>
  netTotal: Maybe<Scalars['Int']>
  rateAmount: Maybe<Scalars['Float']>
  rateType: Maybe<CommerceTaxSummaryRateType>
  taxId: Scalars['ID']
  taxType: Maybe<Scalars['String']>
  total: Scalars['Int']
}

export type CommerceTaxSummaryCreate = {
  name?: Maybe<Scalars['String']>
  netTotal?: Maybe<Scalars['Int']>
  rateAmount?: Maybe<Scalars['Float']>
  rateType?: Maybe<CommerceTaxSummaryRateType>
  taxId: Scalars['ID']
  taxType?: Maybe<Scalars['String']>
  total: Scalars['Int']
}

export type CommerceTaxSummaryCreateOrUpdate = {
  name?: Maybe<Scalars['String']>
  netTotal?: Maybe<Scalars['Int']>
  rateAmount?: Maybe<Scalars['Float']>
  rateType?: Maybe<CommerceTaxSummaryRateType>
  taxId?: Maybe<Scalars['ID']>
  taxType?: Maybe<Scalars['String']>
  total?: Maybe<Scalars['Int']>
}

export enum CommerceTaxSummaryRateType {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE',
}

export type CommerceTaxSummaryUpdate = {
  name?: Maybe<Scalars['String']>
  netTotal?: Maybe<Scalars['Int']>
  rateAmount?: Maybe<Scalars['Float']>
  rateType?: Maybe<CommerceTaxSummaryRateType>
  taxId?: Maybe<Scalars['ID']>
  taxType?: Maybe<Scalars['String']>
  total?: Maybe<Scalars['Int']>
}

export type CommerceTaxType = {
  __typename?: 'CommerceTaxType'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  taxes: Maybe<Array<CommerceTax>>
}

export type CommerceTaxTypeCreate = {
  description?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  taxes?: Maybe<Array<CommerceTaxCreateOrUpdate>>
}

export type CommerceTaxTypeCreateOrUpdate = {
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  taxes?: Maybe<Array<CommerceTaxCreateOrUpdate>>
}

export type CommerceTaxTypeUpdate = {
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  taxes?: Maybe<Array<CommerceTaxCreateOrUpdate>>
}

export type CommerceTaxUpdate = {
  country?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  rateAmount?: Maybe<Scalars['Float']>
  rateType?: Maybe<CommerceTaxRateType>
  taxType?: Maybe<CommerceTaxTypeCreateOrUpdate>
}

export type CommerceTransaction = {
  __typename?: 'CommerceTransaction'
  amount: Maybe<Scalars['Int']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  currency: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  paymentMethod: Maybe<CommercePaymentMethod>
  refundedTransaction: Maybe<Scalars['ID']>
  status: Maybe<CommerceTransactionStatus>
  subsystem: Maybe<CommerceTransactionSubsystem>
  taxDetails: Maybe<Array<CommerceTaxDetail>>
  timestamp: Maybe<Scalars['Date']>
  type: Maybe<CommerceTransactionType>
}

export type CommerceTransactionCreate = {
  amount?: Maybe<Scalars['Int']>
  currency?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  paymentMethod?: Maybe<CommercePaymentMethodCreateOrUpdate>
  refundedTransaction?: Maybe<Scalars['ID']>
  status?: Maybe<CommerceTransactionStatus>
  subsystem?: Maybe<CommerceTransactionSubsystem>
  taxDetails?: Maybe<Array<CommerceTaxDetailCreateOrUpdate>>
  timestamp?: Maybe<Scalars['Date']>
  type?: Maybe<CommerceTransactionType>
}

export enum CommerceTransactionStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
}

export enum CommerceTransactionSubsystem {
  ApplePay = 'APPLE_PAY',
  CreditCard = 'CREDIT_CARD',
  Paypal = 'PAYPAL',
}

export enum CommerceTransactionType {
  Payment = 'PAYMENT',
  Refund = 'REFUND',
}

export type CommerceVoucher = {
  __typename?: 'CommerceVoucher'
  active: Maybe<Scalars['Boolean']>
  amount: Scalars['Float']
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  timesUsed: Maybe<Scalars['Int']>
  type: CommerceVoucherType
}

export type CommerceVoucherCreate = {
  active?: Maybe<Scalars['Boolean']>
  amount: Scalars['Float']
  description?: Maybe<Scalars['String']>
  name: Scalars['String']
  type: CommerceVoucherType
}

export type CommerceVoucherCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  amount?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  type?: Maybe<CommerceVoucherType>
}

export enum CommerceVoucherType {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE',
}

export type CommerceVoucherUpdate = {
  active?: Maybe<Scalars['Boolean']>
  amount?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  type?: Maybe<CommerceVoucherType>
}

export type Company = {
  __typename?: 'Company'
  alternativeUrl: Maybe<Scalars['String']>
  angellistUrl: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  countryName: Maybe<Scalars['String']>
  crunchbaseUrl: Maybe<Scalars['String']>
  elevatorPitch: Maybe<Scalars['String']>
  facebookUrl: Maybe<Scalars['String']>
  homepageUrl: Maybe<Scalars['String']>
  id: Scalars['ID']
  instagramUrl: Maybe<Scalars['String']>
  linkedinUrl: Maybe<Scalars['String']>
  logoUrl: Maybe<Scalars['String']>
  name: Scalars['String']
  privacyPolicyUrl: Maybe<Scalars['String']>
  province: Maybe<Scalars['String']>
  twitterUrl: Maybe<Scalars['String']>
  youtubeUrl: Maybe<Scalars['String']>
}

export type CompanySize = {
  __typename?: 'CompanySize'
  id: Scalars['ID']
  name: Scalars['String']
}

export type ComponentSearchAlgoliaRefinement = {
  __typename?: 'ComponentSearchAlgoliaRefinement'
  _id: Scalars['ID']
  attribute: Scalars['String']
  createdAt: Scalars['DateTime']
  defaults: Maybe<Scalars['JSON']>
  id: Scalars['ID']
  refinementItemsLimit: Maybe<Scalars['Int']>
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
  variant: SearchRefinementWidgetType
}

export type ComponentSearchAlgoliaRefinementInput = {
  attribute: Scalars['String']
  defaults?: Maybe<Scalars['JSON']>
  refinementItemsLimit?: Maybe<Scalars['Int']>
  title: Scalars['String']
  variant: SearchRefinementWidgetType
}

export type ComponentSiteConfigGoogleAnalyticsLinkerDomainList = {
  __typename?: 'ComponentSiteConfigGoogleAnalyticsLinkerDomainList'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  domain: Maybe<Scalars['String']>
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type ComponentSiteConfigGoogleAnalyticsLinkerDomainListInput = {
  domain?: Maybe<Scalars['String']>
}

export type ComponentSiteConfigMetaData = {
  __typename?: 'ComponentSiteConfigMetaData'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  facebookId: Maybe<Scalars['String']>
  facebookPublisher: Maybe<Scalars['String']>
  id: Scalars['ID']
  image: Maybe<UploadFile>
  siteDescription: Scalars['String']
  siteTitle: Scalars['String']
  twitterCreator: Maybe<Scalars['String']>
  twitterId: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type ComponentSiteConfigMetaDatumInput = {
  facebookId?: Maybe<Scalars['String']>
  facebookPublisher?: Maybe<Scalars['String']>
  image?: Maybe<Scalars['ID']>
  siteDescription: Scalars['String']
  siteTitle: Scalars['String']
  twitterCreator?: Maybe<Scalars['String']>
  twitterId?: Maybe<Scalars['String']>
}

export type ComponentWebElementsAttendeeSearchSidebarFilterInput = {
  apiKey: Scalars['String']
  indexName: Scalars['String']
  refinements: Array<ComponentSearchAlgoliaRefinementInput>
}

export type ComponentWebElementsAttendeeSearchSidebarFilters = {
  __typename?: 'ComponentWebElementsAttendeeSearchSidebarFilters'
  _id: Scalars['ID']
  apiKey: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  indexName: Scalars['String']
  refinements: Array<ComponentSearchAlgoliaRefinement>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsBenefitInput = {
  benefit?: Maybe<Scalars['ID']>
}

export type ComponentWebElementsBenefits = {
  __typename?: 'ComponentWebElementsBenefits'
  _id: Scalars['ID']
  benefit: Maybe<ProductBenefits>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsCompanySearchSidebarFilterInput = {
  apiKey: Scalars['String']
  conferenceId?: Maybe<Scalars['String']>
  indexName: Scalars['String']
  refinements: Array<ComponentSearchAlgoliaRefinementInput>
}

export type ComponentWebElementsCompanySearchSidebarFilters = {
  __typename?: 'ComponentWebElementsCompanySearchSidebarFilters'
  _id: Scalars['ID']
  apiKey: Scalars['String']
  conferenceId: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  indexName: Scalars['String']
  refinements: Array<ComponentSearchAlgoliaRefinement>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsCtaLink = {
  __typename?: 'ComponentWebElementsCtaLink'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  openInNewTab: Scalars['Boolean']
  text: Scalars['String']
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export type ComponentWebElementsCtaLinkInput = {
  openInNewTab: Scalars['Boolean']
  text: Scalars['String']
  url: Scalars['String']
}

export type ComponentWebElementsFreshchat = {
  __typename?: 'ComponentWebElementsFreshchat'
  OnDesktop: Maybe<Scalars['Boolean']>
  OnMobile: Maybe<Scalars['Boolean']>
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsFreshchatInput = {
  OnDesktop?: Maybe<Scalars['Boolean']>
  OnMobile?: Maybe<Scalars['Boolean']>
}

export type ComponentWebElementsHeroSection = {
  __typename?: 'ComponentWebElementsHeroSection'
  _id: Scalars['ID']
  backgroundImage: Maybe<UploadFile>
  backgroundImageAlt: Maybe<Scalars['String']>
  backgroundImageDescription: Maybe<Scalars['String']>
  brandImage: Maybe<UploadFile>
  createdAt: Scalars['DateTime']
  ctaLink: Maybe<ComponentWebElementsCtaLink>
  id: Scalars['ID']
  subtitle: Maybe<Scalars['Markdown']>
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  variant: Enum_Componentwebelementsherosection_Variant
}

export type ComponentWebElementsHeroSectionInput = {
  backgroundImage?: Maybe<Scalars['ID']>
  backgroundImageAlt?: Maybe<Scalars['String']>
  backgroundImageDescription?: Maybe<Scalars['String']>
  brandImage?: Maybe<Scalars['ID']>
  ctaLink?: Maybe<ComponentWebElementsCtaLinkInput>
  subtitle?: Maybe<Scalars['Markdown']>
  title?: Maybe<Scalars['String']>
  variant: Enum_Componentwebelementsherosection_Variant
}

export type ComponentWebElementsPriceIncreaseCountdownTimer = {
  __typename?: 'ComponentWebElementsPriceIncreaseCountdownTimer'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  product: Maybe<Products>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsPriceIncreaseCountdownTimerInput = {
  product?: Maybe<Scalars['ID']>
}

export type ComponentWebElementsProductInput = {
  benefits?: Maybe<Array<Scalars['ID']>>
  buttonLabel?: Maybe<Scalars['String']>
  link?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['ID']>
  promotionColor?: Maybe<Scalars['String']>
  promotionLabel?: Maybe<Scalars['String']>
  promotionType?: Maybe<Enum_Componentwebelementsproducts_Promotiontype>
  type?: Maybe<Enum_Componentwebelementsproducts_Type>
}

export type ComponentWebElementsProducts = {
  __typename?: 'ComponentWebElementsProducts'
  _id: Scalars['ID']
  benefits: Array<ProductBenefits>
  buttonLabel: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  link: Maybe<Scalars['String']>
  product: Maybe<Products>
  promotionColor: Maybe<Scalars['String']>
  promotionLabel: Maybe<Scalars['String']>
  promotionType: Maybe<Enum_Componentwebelementsproducts_Promotiontype>
  type: Maybe<Enum_Componentwebelementsproducts_Type>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsProductsBenefitsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type ComponentWebElementsReleasePhaseStepper = {
  __typename?: 'ComponentWebElementsReleasePhaseStepper'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  product: Maybe<Products>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsReleasePhaseStepperInput = {
  product?: Maybe<Scalars['ID']>
}

export type ComponentWebElementsScheduleSearchSidebarFilterInput = {
  apiKey: Scalars['String']
  indexName: Scalars['String']
  refinements: Array<ComponentSearchAlgoliaRefinementInput>
  timezone?: Maybe<Enum_Componentwebelementsschedulesearchsidebarfilters_Timezone>
}

export type ComponentWebElementsScheduleSearchSidebarFilters = {
  __typename?: 'ComponentWebElementsScheduleSearchSidebarFilters'
  _id: Scalars['ID']
  apiKey: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  indexName: Scalars['String']
  refinements: Array<ComponentSearchAlgoliaRefinement>
  timezone: Maybe<Enum_Componentwebelementsschedulesearchsidebarfilters_Timezone>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsSeoMetaData = {
  __typename?: 'ComponentWebElementsSeoMetaData'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  defaultImage: Maybe<UploadFile>
  description: Maybe<Scalars['String']>
  facebookDescription: Maybe<Scalars['String']>
  facebookImage: Maybe<UploadFile>
  facebookTitle: Maybe<Scalars['String']>
  id: Scalars['ID']
  noindex: Maybe<Scalars['Boolean']>
  slug: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  twitterDescription: Maybe<Scalars['String']>
  twitterImage: Maybe<UploadFile>
  twitterTitle: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsSeoMetaDatumInput = {
  defaultImage?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  facebookDescription?: Maybe<Scalars['String']>
  facebookImage?: Maybe<Scalars['ID']>
  facebookTitle?: Maybe<Scalars['String']>
  noindex?: Maybe<Scalars['Boolean']>
  slug?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  twitterDescription?: Maybe<Scalars['String']>
  twitterImage?: Maybe<Scalars['ID']>
  twitterTitle?: Maybe<Scalars['String']>
}

export type ComponentWebElementsShowcaseGrid = {
  __typename?: 'ComponentWebElementsShowcaseGrid'
  _id: Scalars['ID']
  backgroundColor: Maybe<Scalars['String']>
  collection: ContentCollection
  contentBefore: Maybe<Scalars['Markdown']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsShowcaseGridInput = {
  backgroundColor?: Maybe<Scalars['String']>
  contentBefore?: Maybe<Scalars['Markdown']>
  contentCollection?: Maybe<Scalars['ID']>
}

export type ComponentWebElementsTicketApplicationOverviewPanel = {
  __typename?: 'ComponentWebElementsTicketApplicationOverviewPanel'
  _id: Scalars['ID']
  altImageText: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  imageUrl: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsTicketApplicationOverviewPanelInput = {
  altImageText?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type ComponentWebElementsTicketPromotion = {
  __typename?: 'ComponentWebElementsTicketPromotion'
  _id: Scalars['ID']
  color: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  label: Maybe<Scalars['String']>
  type: TicketPromotionType
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsTicketPromotionInput = {
  color?: Maybe<Scalars['String']>
  label?: Maybe<Scalars['String']>
  ticketTypeId: Scalars['String']
  type: TicketPromotionType
}

export type ComponentWebElementsTicketReleasesPanel = {
  __typename?: 'ComponentWebElementsTicketReleasesPanel'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  displayPriceIncludingTax: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsTicketReleasesPanelInput = {
  displayPriceIncludingTax?: Maybe<Scalars['Boolean']>
}

export type ComponentWebElementsTicketTypeInformation = {
  __typename?: 'ComponentWebElementsTicketTypeInformation'
  _id: Scalars['ID']
  benefits: Array<ProductBenefits>
  createdAt: Scalars['DateTime']
  displayPriceIncludingTax: Maybe<Scalars['Boolean']>
  heading: Maybe<Scalars['String']>
  id: Scalars['ID']
  product: Maybe<Products>
  showBenefits: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
}

export type ComponentWebElementsTicketTypeInformationBenefitsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type ComponentWebElementsTicketTypeInformationInput = {
  benefits?: Maybe<Array<Scalars['ID']>>
  displayPriceIncludingTax?: Maybe<Scalars['Boolean']>
  heading?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['ID']>
  showBenefits: Scalars['Boolean']
}

export type ComponentWebLayoutsStoresTicketApplicationsPage = {
  __typename?: 'ComponentWebLayoutsStoresTicketApplicationsPage'
  _id: Scalars['ID']
  applicationForm: Maybe<Form>
  applicationOverviewPanel: Maybe<ComponentWebElementsTicketApplicationOverviewPanel>
  benefits: Array<ComponentWebElementsBenefits>
  categoriesMenu: Maybe<Menu>
  createdAt: Scalars['DateTime']
  description: Maybe<Scalars['Markdown']>
  id: Scalars['ID']
  priceIncreaseCountdownTimer: Maybe<ComponentWebElementsPriceIncreaseCountdownTimer>
  releasePhaseStepper: Maybe<ComponentWebElementsReleasePhaseStepper>
  ticketInfoPanel: Maybe<ComponentWebElementsTicketTypeInformation>
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebLayoutsStoresTicketApplicationsPageInput = {
  applicationForm?: Maybe<Scalars['ID']>
  applicationOverviewPanel?: Maybe<ComponentWebElementsTicketApplicationOverviewPanelInput>
  benefits: Array<ComponentWebElementsBenefitInput>
  categoriesMenu?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['Markdown']>
  priceIncreaseCountdownTimer?: Maybe<ComponentWebElementsPriceIncreaseCountdownTimerInput>
  releasePhaseStepper?: Maybe<ComponentWebElementsReleasePhaseStepperInput>
  ticketInfoPanel?: Maybe<ComponentWebElementsTicketTypeInformationInput>
  title?: Maybe<Scalars['String']>
}

export type ComponentWebLayoutsStoresTicketSalesPage = {
  __typename?: 'ComponentWebLayoutsStoresTicketSalesPage'
  _id: Scalars['ID']
  benefits: Array<ComponentWebElementsBenefits>
  benefitsList: Array<ProductBenefits>
  categoriesMenu: Maybe<Menu>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  priceIncreaseCountdownTimer: Maybe<ComponentWebElementsPriceIncreaseCountdownTimer>
  products: Array<ComponentWebElementsProducts>
  releasePhaseStepper: Maybe<ComponentWebElementsReleasePhaseStepper>
  ticketReleasesPanel: Maybe<ComponentWebElementsTicketReleasesPanel>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebLayoutsStoresTicketSalesPageBenefitsListArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type ComponentWebLayoutsStoresTicketSalesPageInput = {
  benefits: Array<ComponentWebElementsBenefitInput>
  benefitsList?: Maybe<Array<Scalars['ID']>>
  categoriesMenu?: Maybe<Scalars['ID']>
  priceIncreaseCountdownTimer?: Maybe<ComponentWebElementsPriceIncreaseCountdownTimerInput>
  products: Array<ComponentWebElementsProductInput>
  releasePhaseStepper?: Maybe<ComponentWebElementsReleasePhaseStepperInput>
  ticketReleasesPanel?: Maybe<ComponentWebElementsTicketReleasesPanelInput>
}

export type ComponentWebLayoutsTicketApplicationsPage = {
  __typename?: 'ComponentWebLayoutsTicketApplicationsPage'
  _id: Scalars['ID']
  applicationForm: Maybe<Form>
  applicationOverviewPanel: Maybe<ComponentWebElementsTicketApplicationOverviewPanel>
  categoriesMenu: Maybe<Menu>
  createdAt: Scalars['DateTime']
  description: Maybe<Scalars['Markdown']>
  id: Scalars['ID']
  priceIncreaseCountdownTimer: Maybe<ComponentWebElementsPriceIncreaseCountdownTimer>
  releasePhaseStepper: Maybe<ComponentWebElementsReleasePhaseStepper>
  ticketInfoPanel: Maybe<ComponentWebElementsTicketTypeInformation>
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebLayoutsTicketApplicationsPageInput = {
  applicationForm?: Maybe<Scalars['ID']>
  applicationOverviewPanel?: Maybe<ComponentWebElementsTicketApplicationOverviewPanelInput>
  categoriesMenu?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['Markdown']>
  priceIncreaseCountdownTimer?: Maybe<ComponentWebElementsPriceIncreaseCountdownTimerInput>
  releasePhaseStepper?: Maybe<ComponentWebElementsReleasePhaseStepperInput>
  ticketInfoPanel?: Maybe<ComponentWebElementsTicketTypeInformationInput>
  title?: Maybe<Scalars['String']>
}

export type ComponentWebLayoutsTicketSalesPage = {
  __typename?: 'ComponentWebLayoutsTicketSalesPage'
  _id: Scalars['ID']
  categoriesMenu: Maybe<Menu>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  priceIncreaseCountdownTimer: Maybe<ComponentWebElementsPriceIncreaseCountdownTimer>
  promotions: Array<ComponentWebElementsTicketPromotion>
  releasePhaseStepper: Maybe<ComponentWebElementsReleasePhaseStepper>
  ticketReleasesPanel: Maybe<ComponentWebElementsTicketReleasesPanel>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebLayoutsTicketSalesPageInput = {
  categoriesMenu?: Maybe<Scalars['ID']>
  priceIncreaseCountdownTimer?: Maybe<ComponentWebElementsPriceIncreaseCountdownTimerInput>
  promotions: Array<ComponentWebElementsTicketPromotionInput>
  releasePhaseStepper?: Maybe<ComponentWebElementsReleasePhaseStepperInput>
  ticketCategoryId: Scalars['String']
  ticketReleasesPanel?: Maybe<ComponentWebElementsTicketReleasesPanelInput>
}

export type ComponentWebLinksPageLink = {
  __typename?: 'ComponentWebLinksPageLink'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  page: Maybe<WebPage>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebLinksPageLinkInput = {
  page?: Maybe<Scalars['ID']>
}

export type ComponentWebLinksSubMenu = {
  __typename?: 'ComponentWebLinksSubMenu'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  menu: Maybe<Menu>
  updatedAt: Scalars['DateTime']
}

export type ComponentWebLinksSubMenuInput = {
  menu?: Maybe<Scalars['ID']>
}

export type ComponentWebLinksUrlLink = {
  __typename?: 'ComponentWebLinksUrlLink'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  target: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export type ComponentWebLinksUrlLinkInput = {
  target?: Maybe<Scalars['String']>
  url: Scalars['String']
}

export type Conference = {
  __typename?: 'Conference'
  deepLinkBaseUrl: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  displayName: Scalars['String']
  endDate: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  schedule: Maybe<ConferenceSchedule>
  slug: Scalars['String']
  startDate: Maybe<Scalars['String']>
  timezone: Maybe<Scalars['String']>
}

export type ConferenceEndDateArgs = {
  format?: Maybe<Scalars['String']>
}

export type ConferenceStartDateArgs = {
  format?: Maybe<Scalars['String']>
}

export type ConferenceConfiguration = {
  __typename?: 'ConferenceConfiguration'
  algoliaKey: Maybe<Scalars['String']>
  investorMeetingConfiguration: Maybe<ConferenceInvestorMeetingConfiguration>
  pubnubPublishKey: Maybe<Scalars['String']>
  pubnubSecretKey: Maybe<Scalars['String']>
  pubnubSubscribeKey: Maybe<Scalars['String']>
}

export type ConferenceInvestorMeetingConfiguration = {
  __typename?: 'ConferenceInvestorMeetingConfiguration'
  defaultStartupSelections: Maybe<Scalars['Int']>
  investorPortalOpeningAt: Maybe<Scalars['String']>
  meetingsPerSession: Maybe<Scalars['Int']>
  notifyOfficeHoursInvitees: Maybe<Scalars['Boolean']>
  sessionDuration: Maybe<Scalars['Int']>
  sessionLocation: Maybe<Scalars['String']>
  sponsorLogoUrl: Maybe<Scalars['String']>
  startupPortalClosingAt: Maybe<Scalars['String']>
  startupPortalOpeningAt: Maybe<Scalars['String']>
  startupSelectionDeadline: Maybe<Scalars['String']>
}

export type ConferenceInvestorMeetingConfigurationInvestorPortalOpeningAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceInvestorMeetingConfigurationStartupPortalClosingAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceInvestorMeetingConfigurationStartupPortalOpeningAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceInvestorMeetingConfigurationStartupSelectionDeadlineArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceSchedule = {
  __typename?: 'ConferenceSchedule'
  day: Maybe<ConferenceScheduleDay>
  days: Array<ConferenceScheduleDay>
  topics: TopicConnection
  track: Maybe<ConferenceScheduleTrack>
  tracks: ConferenceScheduleTrackConnection
}

export type ConferenceScheduleDayArgs = {
  id?: Maybe<Scalars['ID']>
}

export type ConferenceScheduleTopicsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type ConferenceScheduleTrackArgs = {
  id: Scalars['ID']
}

export type ConferenceScheduleTracksArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type ConferenceScheduleDay = {
  __typename?: 'ConferenceScheduleDay'
  date: Scalars['String']
  dayId: Scalars['ID']
  endsAt: Maybe<Scalars['String']>
  id: Scalars['ID']
  next: Maybe<ConferenceScheduleDay>
  number: Maybe<Scalars['Int']>
  prev: Maybe<ConferenceScheduleDay>
  startsAt: Maybe<Scalars['String']>
  timeslots: ConferenceScheduleTimeslotConnection
  tracks: ConferenceScheduleTrackConnection
}

export type ConferenceScheduleDayDateArgs = {
  format?: Maybe<Scalars['String']>
}

export type ConferenceScheduleDayEndsAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceScheduleDayStartsAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceScheduleDayTimeslotsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type ConferenceScheduleDayTracksArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type ConferenceScheduleTimeslot = {
  __typename?: 'ConferenceScheduleTimeslot'
  description: Maybe<Scalars['String']>
  duration: Maybe<Scalars['Float']>
  endsAt: Maybe<Scalars['String']>
  facebookUrl: Maybe<Scalars['URL']>
  id: Scalars['ID']
  location: Maybe<Location>
  onlineSession: Scalars['Boolean']
  participants: ScheduleTimeslotParticipantConnection
  startsAt: Maybe<Scalars['String']>
  title: Scalars['String']
  topics: TopicConnection
  tracks: ConferenceScheduleTrackConnection
  vimeoUrl: Maybe<Scalars['URL']>
  youtubeUrl: Maybe<Scalars['URL']>
}

export type ConferenceScheduleTimeslotDurationArgs = {
  unit?: Maybe<TimeUnit>
}

export type ConferenceScheduleTimeslotEndsAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceScheduleTimeslotParticipantsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type ConferenceScheduleTimeslotStartsAtArgs = {
  format?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

export type ConferenceScheduleTimeslotTopicsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type ConferenceScheduleTimeslotTracksArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for ConferenceScheduleTimeslot. */
export type ConferenceScheduleTimeslotConnection = {
  __typename?: 'ConferenceScheduleTimeslotConnection'
  /** A list of edges. */
  edges: Array<ConferenceScheduleTimeslotEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ConferenceScheduleTimeslotEdge = {
  __typename?: 'ConferenceScheduleTimeslotEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ConferenceScheduleTimeslot
}

export type ConferenceScheduleTrack = {
  __typename?: 'ConferenceScheduleTrack'
  curated: Scalars['Boolean']
  day: Maybe<ConferenceScheduleDay>
  days: Array<ConferenceScheduleDay>
  description: Maybe<Scalars['String']>
  gatepassUrl: Maybe<Scalars['String']>
  iconCharacter: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  streamSourceUrl: Maybe<Scalars['String']>
  streamable: Scalars['Boolean']
  timeslots: ConferenceScheduleTimeslotConnection
  trackId: Scalars['ID']
}

export type ConferenceScheduleTrackDayArgs = {
  id?: Maybe<Scalars['ID']>
}

export type ConferenceScheduleTrackTimeslotsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for ConferenceScheduleTrack. */
export type ConferenceScheduleTrackConnection = {
  __typename?: 'ConferenceScheduleTrackConnection'
  /** A list of edges. */
  edges: Array<ConferenceScheduleTrackEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ConferenceScheduleTrackEdge = {
  __typename?: 'ConferenceScheduleTrackEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ConferenceScheduleTrack
}

export type ConnectionEntity = Appearance | Attendee

export type ConnectionLink = {
  __typename?: 'ConnectionLink'
  createdAt: Scalars['ISO8601DateTime']
  entity: ConnectionEntity
  id: Scalars['ID']
}

/** The connection type for ConnectionLink. */
export type ConnectionLinkConnection = {
  __typename?: 'ConnectionLinkConnection'
  /** A list of edges. */
  edges: Array<ConnectionLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ConnectionLinkEdge = {
  __typename?: 'ConnectionLinkEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ConnectionLink
}

/** Autogenerated input type of ConnectionLinkRemove */
export type ConnectionLinkRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  type?: Maybe<ConnectionLinkTarget>
}

/** Autogenerated return type of ConnectionLinkRemove */
export type ConnectionLinkRemovePayload = {
  __typename?: 'ConnectionLinkRemovePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  errors: Array<Error>
}

export enum ConnectionLinkTarget {
  /** Connection to appearance */
  Appearance = 'Appearance',
  /** Connection to attendance */
  Attendee = 'Attendee',
}

export type ConnectionRequest = {
  __typename?: 'ConnectionRequest'
  acceptedAt: Maybe<Scalars['ISO8601DateTime']>
  createdAt: Scalars['ISO8601DateTime']
  from: Maybe<ConnectionEntity>
  id: Scalars['ID']
  rejectedAt: Maybe<Scalars['ISO8601DateTime']>
  status: Scalars['String']
  to: Maybe<ConnectionEntity>
}

/** Autogenerated input type of ConnectionRequestAccept */
export type ConnectionRequestAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of ConnectionRequestAccept */
export type ConnectionRequestAcceptPayload = {
  __typename?: 'ConnectionRequestAcceptPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  connectionRequest: Maybe<ConnectionRequest>
  errors: Array<Error>
}

/** The connection type for ConnectionRequest. */
export type ConnectionRequestConnection = {
  __typename?: 'ConnectionRequestConnection'
  /** A list of edges. */
  edges: Array<ConnectionRequestEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated input type of ConnectionRequestCreate */
export type ConnectionRequestCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  initiatedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** When true, the connection will be requested as a partner lead */
  partnerLead?: Maybe<Scalars['Boolean']>
  scanCode?: Maybe<Scalars['String']>
  sendNotification?: Maybe<Scalars['Boolean']>
  source?: Maybe<Scalars['String']>
  type: Scalars['String']
}

/** Autogenerated return type of ConnectionRequestCreate */
export type ConnectionRequestCreatePayload = {
  __typename?: 'ConnectionRequestCreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  connectionRequest: Maybe<ConnectionRequest>
  errors: Array<Error>
}

/** An edge in a connection. */
export type ConnectionRequestEdge = {
  __typename?: 'ConnectionRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ConnectionRequest
}

/** Autogenerated input type of ConnectionRequestReject */
export type ConnectionRequestRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of ConnectionRequestReject */
export type ConnectionRequestRejectPayload = {
  __typename?: 'ConnectionRequestRejectPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  connectionRequest: Maybe<ConnectionRequest>
  errors: Array<Error>
}

export enum ConnectionRequestStatus {
  /** Accepted request */
  Accepted = 'ACCEPTED',
  /** Pending request */
  Pending = 'PENDING',
  /** Rejected request */
  Rejected = 'REJECTED',
}

export enum ConnectionState {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED',
  RequestReceived = 'REQUEST_RECEIVED',
  RequestSent = 'REQUEST_SENT',
}

export type ConnectionStats = {
  __typename?: 'ConnectionStats'
  connectedCount: Scalars['Int']
  requestReceivedCount: Scalars['Int']
  requestSentCount: Scalars['Int']
}

export enum ContactsProvider {
  Facebook = 'FACEBOOK',
  Phonebook = 'PHONEBOOK',
  Twitter = 'TWITTER',
}

export type ContentCollection = {
  __typename?: 'ContentCollection'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  elements: Array<ContentElement>
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type ContentCollectionElementsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type ContentCollectionInput = {
  created_by?: Maybe<Scalars['ID']>
  elements?: Maybe<Array<Scalars['ID']>>
  name: Scalars['String']
  updated_by?: Maybe<Scalars['ID']>
}

export type ContentElement = {
  __typename?: 'ContentElement'
  _id: Scalars['ID']
  collections: Array<ContentCollection>
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  id: Scalars['ID']
  image: Maybe<UploadFile>
  link: Maybe<ComponentWebLinksUrlLink>
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type ContentElementCollectionsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type ContentElementInput = {
  collections?: Maybe<Array<Scalars['ID']>>
  created_by?: Maybe<Scalars['ID']>
  image?: Maybe<Scalars['ID']>
  link?: Maybe<ComponentWebLinksUrlLinkInput>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type Country = {
  __typename?: 'Country'
  callingCode: Scalars['Int']
  id: Scalars['ID']
  name: Scalars['String']
}

export enum CurrencyCode {
  Aed = 'AED',
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Myr = 'MYR',
  Nok = 'NOK',
  Nzd = 'NZD',
  Php = 'PHP',
  Pln = 'PLN',
  Qar = 'QAR',
  Ron = 'RON',
  Rub = 'RUB',
  Sar = 'SAR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Twd = 'TWD',
  Usd = 'USD',
  Zar = 'ZAR',
}

/** The set of device platforms. */
export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB',
}

export type Duplicate = {
  __typename?: 'Duplicate'
  count: Scalars['Int']
}

export type DynamicForm = {
  __typename?: 'DynamicForm'
  data: Scalars['JSON']
  id: Scalars['ID']
  mutation: Scalars['String']
  schema: Scalars['JSONSchemaForm']
  uiSchema: Scalars['JSONSchemaForm']
}

export type DynamicFormSubmissionError = {
  __typename?: 'DynamicFormSubmissionError'
  field: Maybe<Array<Scalars['String']>>
  message: Scalars['String']
}

export type DynamicFormSubmissionPayload = {
  __typename?: 'DynamicFormSubmissionPayload'
  dynamicForm: Maybe<DynamicForm>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<DynamicFormSubmissionError>
}

export enum Enum_Componentwebelementsherosection_Variant {
  Compact = 'COMPACT',
  Regular = 'REGULAR',
}

export enum Enum_Componentwebelementsproducts_Promotiontype {
  Annotation = 'ANNOTATION',
  Highlight = 'HIGHLIGHT',
}

export enum Enum_Componentwebelementsproducts_Type {
  Link = 'link',
  Sale = 'sale',
  SoldOut = 'soldOut',
}

export enum Enum_Componentwebelementsschedulesearchsidebarfilters_Timezone {
  Conference = 'conference',
  Local = 'local',
}

export enum Enum_Products_Type {
  Custom = 'custom',
  Deal = 'deal',
  Package = 'package',
  Product = 'product',
}

export enum Enum_Webpage_Status {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type EmailAdapter = {
  __typename?: 'EmailAdapter'
  id: Maybe<Scalars['ID']>
  name: Maybe<Scalars['String']>
}

export type EmailAuditEntry = {
  __typename?: 'EmailAuditEntry'
  action: Maybe<EmailAuditEntryAction>
  by: Maybe<AuthUser>
  payload: Maybe<Scalars['JSON']>
  reason: Maybe<Scalars['String']>
  scopeId: Maybe<Scalars['ID']>
  scopeType: Maybe<Scalars['String']>
  target: Maybe<Scalars['ID']>
  timestamp: Maybe<Scalars['Date']>
  transactionId: Maybe<Scalars['ID']>
  type: Maybe<Scalars['String']>
}

export enum EmailAuditEntryAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Get = 'GET',
  List = 'LIST',
  NoOp = 'NO_OP',
  Update = 'UPDATE',
}

export type EmailCollection = {
  __typename?: 'EmailCollection'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  disable_emails: Maybe<Scalars['Boolean']>
  disable_missing_template_alerts: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  slug: Scalars['String']
}

export type EmailCollectionCreate = {
  disable_emails?: Maybe<Scalars['Boolean']>
  disable_missing_template_alerts?: Maybe<Scalars['Boolean']>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  slug: Scalars['String']
}

export type EmailCollectionUpdate = {
  disable_emails?: Maybe<Scalars['Boolean']>
  disable_missing_template_alerts?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  slug?: Maybe<Scalars['String']>
}

export type EmailMessage = {
  __typename?: 'EmailMessage'
  address: Scalars['String']
  attachments: Maybe<Array<Maybe<Scalars['String']>>>
  collection: Maybe<EmailCollection>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Maybe<Scalars['String']>
  remoteId: Maybe<Scalars['String']>
  remoteUrl: Maybe<Scalars['String']>
  sendAt: Maybe<Scalars['Date']>
  status: Maybe<EmailMessageStatus>
  statusDetail: Maybe<Scalars['String']>
  template: EmailTemplate
  variables: Maybe<Scalars['JSON']>
}

export type EmailMessageCreate = {
  address: Scalars['String']
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  sendAt?: Maybe<Scalars['Date']>
  template: EmailTemplateCreateOrUpdate
  variables?: Maybe<Scalars['JSON']>
}

export enum EmailMessageStatus {
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Opened = 'OPENED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
}

export type EmailPageAdapter = {
  __typename?: 'EmailPageAdapter'
  content: Maybe<Array<Maybe<EmailAdapter>>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<EmailPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<EmailSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type EmailPageCollection = {
  __typename?: 'EmailPageCollection'
  content: Maybe<Array<EmailCollection>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<EmailPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<EmailSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type EmailPageMessage = {
  __typename?: 'EmailPageMessage'
  content: Maybe<Array<EmailMessage>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<EmailPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<EmailSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type EmailPageTemplate = {
  __typename?: 'EmailPageTemplate'
  content: Maybe<Array<EmailTemplate>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<EmailPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<EmailSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type EmailPageableObject = {
  __typename?: 'EmailPageableObject'
  offset: Maybe<Scalars['Int']>
  pageNumber: Maybe<Scalars['Int']>
  pageSize: Maybe<Scalars['Int']>
  paged: Maybe<Scalars['Boolean']>
  sort: Maybe<EmailSort>
  unpaged: Maybe<Scalars['Boolean']>
}

export type EmailSearchTerm = {
  field?: Maybe<Scalars['String']>
  op?: Maybe<EmailSearchTermOp>
  value?: Maybe<Scalars['Object']>
}

export enum EmailSearchTermOp {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne',
}

export type EmailSort = {
  __typename?: 'EmailSort'
  empty: Maybe<Scalars['Boolean']>
  sorted: Maybe<Scalars['Boolean']>
  unsorted: Maybe<Scalars['Boolean']>
}

export type EmailSortTerm = {
  direction?: Maybe<EmailSortTermDirection>
  field?: Maybe<Scalars['String']>
}

export enum EmailSortTermDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate'
  active: Maybe<Scalars['Boolean']>
  adapter: Maybe<Scalars['ID']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  deleted: Maybe<Scalars['Boolean']>
  fromEmail: Maybe<Scalars['String']>
  fromName: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  labels: Maybe<Array<Maybe<Scalars['String']>>>
  lastSync: Scalars['Date']
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  remoteId: Maybe<Scalars['String']>
  remoteUrl: Maybe<Scalars['String']>
  subject: Maybe<Scalars['String']>
  variables: Maybe<Array<Maybe<Scalars['String']>>>
}

export type EmailTemplateCreate = {
  active?: Maybe<Scalars['Boolean']>
  adapter?: Maybe<Scalars['ID']>
  fromEmail?: Maybe<Scalars['String']>
  fromName?: Maybe<Scalars['String']>
  labels?: Maybe<Array<Maybe<Scalars['String']>>>
  lastSync: Scalars['Date']
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  subject?: Maybe<Scalars['String']>
  variables?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type EmailTemplateCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  adapter?: Maybe<Scalars['ID']>
  fromEmail?: Maybe<Scalars['String']>
  fromName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  labels?: Maybe<Array<Maybe<Scalars['String']>>>
  lastSync?: Maybe<Scalars['Date']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  subject?: Maybe<Scalars['String']>
  variables?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type EmailTemplateUpdate = {
  active?: Maybe<Scalars['Boolean']>
  adapter?: Maybe<Scalars['ID']>
  fromEmail?: Maybe<Scalars['String']>
  fromName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  labels?: Maybe<Array<Maybe<Scalars['String']>>>
  lastSync?: Maybe<Scalars['Date']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  subject?: Maybe<Scalars['String']>
  variables?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type Error = {
  __typename?: 'Error'
  /** A description of the error */
  message: Scalars['String']
  /** Which input value this error came from */
  path: Maybe<Array<Scalars['String']>>
  type: Scalars['String']
}

export type Event = {
  __typename?: 'Event'
  /** Link to the public website of the event */
  baseUrl: Maybe<Scalars['String']>
  brandName: Scalars['String']
  companySizes: Maybe<Array<CompanySize>>
  configuration: Maybe<ConferenceConfiguration>
  /** Country where the event is hosted */
  country: Maybe<EventConfigurationCountry>
  /** Main currency used for buying tickets */
  currency: Maybe<CurrencyCode>
  deepLinkDomain: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  /** Enable/disable physical event registration */
  enableRegistration: Scalars['Boolean']
  /** Date at which the event ends */
  endDate: Maybe<Scalars['ISO8601Date']>
  id: Scalars['ID']
  industries: Maybe<Array<Industry>>
  investorSessionsSummary: Maybe<Array<InvestorSessionsSummary>>
  /** Invoice information of the entity that sells the tickets */
  legalEntity: Maybe<LegalEntity>
  /** Whether the mobile app is enabled for the event */
  mobileAppEnabled: Scalars['Boolean']
  /** Name of the event */
  name: Scalars['String']
  partners: Maybe<AppearanceConnection>
  passportRequired: Maybe<Scalars['Boolean']>
  /** Public domain for the event */
  publicDomain: Maybe<Scalars['String']>
  /** Number of security zones at an event */
  securityZonesCount: Scalars['Int']
  /** Unique identifier of the event */
  slug: Scalars['String']
  sponsor: Maybe<Appearance>
  /** Date at which the event starts */
  startDate: Maybe<Scalars['ISO8601Date']>
  /** Support link for the event */
  supportLink: Maybe<Scalars['String']>
  taxNumber: Scalars['String']
  timeZone: Maybe<TimeZone>
  /** Timezone of the country hosting the event */
  timezone: Maybe<Scalars['String']>
  versions: Maybe<Array<PaperTrailVersion>>
}

export type EventPartnersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type EventConfigurationCountry = {
  __typename?: 'EventConfigurationCountry'
  /** ISO 3166-1 alpha-2 */
  code: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

/** The connection type for EventConfigurationCountry. */
export type EventConfigurationCountryConnection = {
  __typename?: 'EventConfigurationCountryConnection'
  /** A list of edges. */
  edges: Array<EventConfigurationCountryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type EventConfigurationCountryEdge = {
  __typename?: 'EventConfigurationCountryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: EventConfigurationCountry
}

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection'
  /** A list of edges. */
  edges: Array<EventEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** Autogenerated input type of EventCreate */
export type EventCreateInput = {
  baseUrl?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  countryId?: Maybe<Scalars['ID']>
  currency?: Maybe<CurrencyCode>
  description?: Maybe<Scalars['String']>
  enableRegistration?: Maybe<Scalars['Boolean']>
  /** Must be equal to or greater than the start_date */
  endDate?: Maybe<Scalars['String']>
  legalEntityId?: Maybe<Scalars['ID']>
  mobileAppEnabled?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  publicDomain?: Maybe<Scalars['String']>
  securityZonesCount?: Maybe<Scalars['Int']>
  slug: Scalars['String']
  startDate?: Maybe<Scalars['String']>
  supportLink?: Maybe<Scalars['String']>
  taxNumber?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

/** Autogenerated return type of EventCreate. */
export type EventCreatePayload = {
  __typename?: 'EventCreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  event: Maybe<Event>
  userErrors: Array<UserError>
}

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Event
}

export type EventFilter = {
  endDateAfter?: Maybe<Scalars['ISO8601Date']>
  endDateBefore?: Maybe<Scalars['ISO8601Date']>
  startDateAfter?: Maybe<Scalars['ISO8601Date']>
  startDateBefore?: Maybe<Scalars['ISO8601Date']>
}

/** Autogenerated input type of EventUpdate */
export type EventUpdateInput = {
  baseUrl?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  countryId?: Maybe<Scalars['ID']>
  currency?: Maybe<CurrencyCode>
  description?: Maybe<Scalars['String']>
  enableRegistration?: Maybe<Scalars['Boolean']>
  /** Must be equal to or greater than the start_date */
  endDate?: Maybe<Scalars['String']>
  legalEntityId?: Maybe<Scalars['ID']>
  mobileAppEnabled?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  publicDomain?: Maybe<Scalars['String']>
  securityZonesCount?: Maybe<Scalars['Int']>
  slug: Scalars['String']
  startDate?: Maybe<Scalars['String']>
  supportLink?: Maybe<Scalars['String']>
  taxNumber?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
}

/** Autogenerated return type of EventUpdate. */
export type EventUpdatePayload = {
  __typename?: 'EventUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  event: Maybe<Event>
  userErrors: Array<UserError>
}

export type FileInput = {
  alternativeText?: Maybe<Scalars['String']>
  caption?: Maybe<Scalars['String']>
  created_by?: Maybe<Scalars['ID']>
  ext?: Maybe<Scalars['String']>
  formats?: Maybe<Scalars['JSON']>
  hash: Scalars['String']
  height?: Maybe<Scalars['Int']>
  mime: Scalars['String']
  name: Scalars['String']
  previewUrl?: Maybe<Scalars['String']>
  provider: Scalars['String']
  provider_metadata?: Maybe<Scalars['JSON']>
  related: Array<Scalars['ID']>
  size: Scalars['Float']
  updated_by?: Maybe<Scalars['ID']>
  url: Scalars['String']
  width?: Maybe<Scalars['Int']>
}

export type Form = {
  __typename?: 'Form'
  _id: Scalars['ID']
  contentBefore: Maybe<Scalars['Markdown']>
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  dynamicForm: DynamicForm
  formAnalyticsGoal: Maybe<Scalars['String']>
  formEventLabel: Maybe<Scalars['String']>
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type FormInput = {
  contentBefore?: Maybe<Scalars['Markdown']>
  created_by?: Maybe<Scalars['ID']>
  formAnalyticsGoal?: Maybe<Scalars['String']>
  formEventLabel?: Maybe<Scalars['String']>
  formstackId?: Maybe<Scalars['String']>
  name: Scalars['String']
  submissions?: Maybe<Array<Scalars['ID']>>
  successMessage: Scalars['Markdown']
  updated_by?: Maybe<Scalars['ID']>
}

export type Industry = {
  __typename?: 'Industry'
  id: Scalars['ID']
  name: Scalars['String']
}

export type InputId = {
  id: Scalars['ID']
}

/** Autogenerated input type of InvestorAccessGrant */
export type InvestorAccessGrantInput = {
  bookingReferences: Array<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  startupSelectionsCount: Scalars['Int']
}

/** Autogenerated return type of InvestorAccessGrant */
export type InvestorAccessGrantPayload = {
  __typename?: 'InvestorAccessGrantPayload'
  attendances: Maybe<Array<Attendee>>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  errors: Array<Error>
  invalidBookingReferences: Maybe<Array<Scalars['String']>>
  successMessage: Maybe<Scalars['String']>
}

export type InvestorMeetingConfiguration = {
  investorMeetingsDefaultStartupSelections?: Maybe<Scalars['Int']>
  investorMeetingsMeetingsPerSession?: Maybe<Scalars['Int']>
  investorMeetingsPortalOpeningAt?: Maybe<Scalars['ISO8601DateTime']>
  investorMeetingsSessionDuration?: Maybe<Scalars['Int']>
  investorMeetingsSessionLocation?: Maybe<Scalars['String']>
  investorMeetingsSponsorLogo?: Maybe<Scalars['String']>
  investorMeetingsStartupPortalClosingAt?: Maybe<Scalars['ISO8601DateTime']>
  investorMeetingsStartupPortalOpeningAt?: Maybe<Scalars['ISO8601DateTime']>
  investorMeetingsStartupSelectionDeadline?: Maybe<Scalars['ISO8601DateTime']>
  notifyOfficeHoursInvitees?: Maybe<Scalars['Boolean']>
}

/** Autogenerated input type of InvestorMeetingConfigurationUpdate */
export type InvestorMeetingConfigurationUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  investorMeetingConfiguration?: Maybe<InvestorMeetingConfiguration>
}

/** Autogenerated return type of InvestorMeetingConfigurationUpdate */
export type InvestorMeetingConfigurationUpdatePayload = {
  __typename?: 'InvestorMeetingConfigurationUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

/** Autogenerated input type of InvestorPortalRevokeAccess */
export type InvestorPortalRevokeAccessInput = {
  attendanceId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of InvestorPortalRevokeAccess */
export type InvestorPortalRevokeAccessPayload = {
  __typename?: 'InvestorPortalRevokeAccessPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export type InvestorSession = {
  __typename?: 'InvestorSession'
  attendanceId: Maybe<Scalars['ID']>
  endsAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  startsAt: Scalars['ISO8601DateTime']
  tableNumber: Scalars['Int']
}

export type InvestorSessionConfiguration = {
  attendanceId: Scalars['ID']
  startsAt?: Maybe<Scalars['ISO8601DateTime']>
  unlockInvestor: Scalars['Boolean']
}

/** The connection type for InvestorSession. */
export type InvestorSessionConnection = {
  __typename?: 'InvestorSessionConnection'
  /** A list of edges. */
  edges: Array<InvestorSessionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type InvestorSessionEdge = {
  __typename?: 'InvestorSessionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: InvestorSession
}

export type InvestorSessionsConfiguration = {
  investorSessionsCount: Scalars['Int']
  investorSessionsEndsAt: Scalars['ISO8601DateTime']
  investorSessionsId?: Maybe<Array<Scalars['ID']>>
  investorSessionsStartsAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of InvestorSessionsCreate */
export type InvestorSessionsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  investorSessionsConfiguration?: Maybe<InvestorSessionsConfiguration>
}

/** Autogenerated return type of InvestorSessionsCreate */
export type InvestorSessionsCreatePayload = {
  __typename?: 'InvestorSessionsCreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export type InvestorSessionsSummary = {
  __typename?: 'InvestorSessionsSummary'
  available: Maybe<Scalars['ID']>
  claimed: Maybe<Scalars['ID']>
  count: Maybe<Scalars['ID']>
  endsAt: Maybe<Scalars['ISO8601DateTime']>
  ids: Maybe<Array<Scalars['ID']>>
  startsAt: Maybe<Scalars['ISO8601DateTime']>
}

/** Autogenerated input type of InvestorSessionsUpdate */
export type InvestorSessionsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  investorSessionsConfiguration?: Maybe<InvestorSessionsConfiguration>
}

/** Autogenerated return type of InvestorSessionsUpdate */
export type InvestorSessionsUpdatePayload = {
  __typename?: 'InvestorSessionsUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export enum InvestorsWithSessions {
  /** all_investors */
  AllInvestors = 'ALL_INVESTORS',
  /** with_sessions */
  WithSessions = 'WITH_SESSIONS',
  /** without_session */
  WithoutSession = 'WITHOUT_SESSION',
}

export type LegalEntity = {
  __typename?: 'LegalEntity'
  address: Maybe<Address>
  displayName: Scalars['String']
  email: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  note: Maybe<Scalars['String']>
  phone: Maybe<Scalars['String']>
  regNumber: Maybe<Scalars['String']>
  taxNumber: Maybe<Scalars['String']>
  versions: Maybe<Array<PaperTrailVersion>>
  website: Maybe<Scalars['String']>
}

/** The connection type for LegalEntity. */
export type LegalEntityConnection = {
  __typename?: 'LegalEntityConnection'
  /** A list of edges. */
  edges: Array<LegalEntityEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** Autogenerated input type of LegalEntityCreate */
export type LegalEntityCreateInput = {
  address?: Maybe<AddressInput>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Must be unique */
  displayName: Scalars['String']
  email?: Maybe<Scalars['String']>
  name: Scalars['String']
  note?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  regNumber?: Maybe<Scalars['String']>
  taxNumber?: Maybe<Scalars['String']>
  website?: Maybe<Scalars['String']>
}

/** Autogenerated return type of LegalEntityCreate. */
export type LegalEntityCreatePayload = {
  __typename?: 'LegalEntityCreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  legalEntity: Maybe<LegalEntity>
  userErrors: Array<UserError>
}

/** An edge in a connection. */
export type LegalEntityEdge = {
  __typename?: 'LegalEntityEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: LegalEntity
}

/** Autogenerated input type of LegalEntityUpdate */
export type LegalEntityUpdateInput = {
  address?: Maybe<AddressInput>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  displayName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  regNumber?: Maybe<Scalars['String']>
  taxNumber?: Maybe<Scalars['String']>
  website?: Maybe<Scalars['String']>
}

/** Autogenerated return type of LegalEntityUpdate. */
export type LegalEntityUpdatePayload = {
  __typename?: 'LegalEntityUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  legalEntity: Maybe<LegalEntity>
  userErrors: Array<UserError>
}

export type Location = {
  __typename?: 'Location'
  /** @deprecated This field is deprecated */
  gatepassUrl: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** @deprecated This field is deprecated */
  livestreamUrl: Maybe<Scalars['String']>
  name: Scalars['String']
  slug: Scalars['String']
}

export type Locked = {
  __typename?: 'Locked'
  count: Scalars['Int']
}

export type LoginDetails = {
  __typename?: 'LoginDetails'
  lastSignedInAndroidAt: Maybe<Scalars['ISO8601DateTime']>
  lastSignedInCfhAt: Maybe<Scalars['ISO8601DateTime']>
  lastSignedInIosAt: Maybe<Scalars['ISO8601DateTime']>
  lastSignedInWebAt: Maybe<Scalars['ISO8601DateTime']>
}

/** Autogenerated input type of MagicLinkGenerate */
export type MagicLinkGenerateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  /** Use `%{token}` to indicate where to interpolate the token. */
  linkFormat?: Maybe<Scalars['String']>
  ticketReference?: Maybe<Scalars['String']>
}

/** Autogenerated return type of MagicLinkGenerate */
export type MagicLinkGeneratePayload = {
  __typename?: 'MagicLinkGeneratePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export type Menu = {
  __typename?: 'Menu'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  id: Scalars['ID']
  label: Maybe<Scalars['String']>
  menuItems: Array<MenuItem>
  name: Scalars['String']
  site: Maybe<Site>
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type MenuMenuItemsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type MenuInput = {
  created_by?: Maybe<Scalars['ID']>
  label?: Maybe<Scalars['String']>
  menuItems?: Maybe<Array<Scalars['ID']>>
  name: Scalars['String']
  site?: Maybe<Scalars['ID']>
  updated_by?: Maybe<Scalars['ID']>
}

export type MenuItem = {
  __typename?: 'MenuItem'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  id: Scalars['ID']
  label: Scalars['String']
  link: MenuItemLinkDynamicZone
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type MenuItemInput = {
  created_by?: Maybe<Scalars['ID']>
  label: Scalars['String']
  link: Array<Scalars['MenuItemLinkDynamicZoneInput']>
  parentMenu?: Maybe<Scalars['ID']>
  updated_by?: Maybe<Scalars['ID']>
}

export type MenuItemLinkDynamicZone =
  | ComponentWebLinksPageLink
  | ComponentWebLinksSubMenu
  | ComponentWebLinksUrlLink

export type Mutation = {
  __typename?: 'Mutation'
  appearanceConnect: Maybe<AppearanceConnectPayload>
  appearanceUpdate: Maybe<AppearanceUpdatePayload>
  assignmentAccountUpdate: Maybe<AssignmentAccountUpdatePayload>
  assignmentAddOnAssign: Maybe<AddOnAssignPayload>
  assignmentAddOnUnassign: Maybe<AddOnUnassignPayload>
  assignmentAddOnUnvoid: Maybe<AssignmentAddOnUnvoidPayload>
  assignmentAddOnVoid: Maybe<AssignmentAddOnVoidPayload>
  assignmentAuthenticate: Maybe<AssignmentAuthenticatePayload>
  /** Returns a login link for the specified account for a given conference. */
  assignmentMagicLinkGenerate: Maybe<AssignmentMagicLinkGeneratePayload>
  assignmentMagicLinkLoginRequest: Maybe<AssignmentMagicLinkLoginRequestPayload>
  assignmentProfileAdminUpdate: Maybe<AssignmentProfileAdminUpdatePayload>
  assignmentProfileUpdate: Maybe<AssignmentProfileUpdatePayload>
  assignmentResendOrderEmail: Maybe<AssignmentResendOrderEmailPayload>
  assignmentSalesforceAccountUpdate: Maybe<AssignmentSalesforceAccountUpdatePayload>
  assignmentTicketLoginUpdate: Maybe<AssignmentTicketLoginUpdatePayload>
  assignmentTicketUpgradeAssign: Maybe<TicketUpgradeAssignPayload>
  assignmentTicketUpgradeUnassign: Maybe<TicketUpgradeUnassignPayload>
  assignmentTicketUpgradeUnvoid: Maybe<TicketUpgradeUnvoidPayload>
  assignmentTicketUpgradeVoid: Maybe<TicketUpgradeVoidPayload>
  attendanceAppearanceSelectionDestroy: Maybe<AttendanceAppearanceSelectionDestroyPayload>
  attendanceAppearanceSelectionUpdate: Maybe<AttendanceAppearanceSelectionsUpdatePayload>
  attendanceInvestorSessionUpdate: Maybe<AttendanceInvestorSessionUpdatePayload>
  attendeeBlock: Maybe<AttendeeBlockPayload>
  attendeeConnect: Maybe<AttendeeConnectPayload>
  attendeeProfileUpdate: Maybe<AttendeeProfileUpdatePayload>
  attendeeUnblock: Maybe<AttendeeUnblockPayload>
  /** *Equivalent to POST /auth/oauths* */
  authCreateOauth: Maybe<AuthOauth>
  /** *Equivalent to POST /auth/roles* */
  authCreateRole: Maybe<AuthRole>
  /** *Equivalent to POST /auth/users* */
  authCreateUser: Maybe<AuthUser>
  /** *Equivalent to DELETE /auth/oauths/{id}* */
  authDeleteOauth: Maybe<AuthOauth>
  /** *Equivalent to DELETE /auth/roles/{id}* */
  authDeleteRole: Maybe<AuthRole>
  /** *Equivalent to DELETE /auth/users/{id}* */
  authDeleteUser: Maybe<AuthUser>
  /** *Equivalent to POST /auth/users/{id}/ensure* */
  authEnsureUserUser: Maybe<AuthUser>
  /** *Equivalent to PUT /auth/roles/{id}/permissions/{permission}* */
  authGrantPermissionRole: Maybe<AuthRole>
  /** *Equivalent to PUT /auth/users/{id}/permissions/{permission}* */
  authGrantPermissionUser: Maybe<AuthUser>
  /** *Equivalent to DELETE /auth/roles/{id}/permissions/{permission}* */
  authRevokePermissionRole: Maybe<AuthRole>
  /** *Equivalent to DELETE /auth/users/{id}/permissions/{permission}* */
  authRevokePermissionUser: Maybe<AuthUser>
  /** *Equivalent to PUT /auth/oauths/{id}* */
  authUpdateOauth: Maybe<AuthOauth>
  /** *Equivalent to PUT /auth/roles/{id}* */
  authUpdateRole: Maybe<AuthRole>
  /** *Equivalent to PUT /auth/users/{id}* */
  authUpdateUser: Maybe<AuthUser>
  authenticateByToken: Maybe<AuthenticateByTokenPayload>
  chatChannelCreate: Maybe<ChatChannelCreatePayload>
  /** *Equivalent to POST /commerce/stores/{storeId}/categories* */
  commerceCreateCategory: Maybe<CommerceCategory>
  /** *Equivalent to POST /commerce/stores/{storeId}/codes* */
  commerceCreateCode: Maybe<CommerceCode>
  /** *Equivalent to POST /commerce/stores/{storeId}/orders/{orderId}/customers* */
  commerceCreateCustomer: Maybe<CommerceCustomer>
  /** *Equivalent to POST /commerce/stores/{storeId}/deals* */
  commerceCreateDeal: Maybe<CommerceDeal>
  /** *Equivalent to POST /commerce/stores/{storeId}/deals/{dealId}/dealItems* */
  commerceCreateDealItem: Maybe<CommerceDealItem>
  /**
   * *Equivalent to POST /commerce/stores/{storeId}/orders*
   * # Creating an Order
   *
   * When creating an order as an admin that is not meant for yourself make sure you pass the `X-Owner` header.
   *
   * This header will ensure that the order belongs to the user who's UUID was passed in the header.
   *
   * If an invalid UUID is passed in this header it is assumed that the intention of the caller is to generate a new
   * order for an unidentified new user (the server generates a new UUID to set as the owner).
   */
  commerceCreateOrder: Maybe<CommerceOrder>
  /** *Equivalent to POST /commerce/stores/{storeId}/product/{productId}/packagedProducts* */
  commerceCreatePackagedProduct: Maybe<CommercePackagedProduct>
  /** *Equivalent to POST /commerce/stores/{storeId}/paymentMethods* */
  commerceCreatePaymentMethod: Maybe<CommercePaymentMethod>
  /** *Equivalent to POST /commerce/stores/{storeId}/products* */
  commerceCreateProduct: Maybe<CommerceProduct>
  /** *Equivalent to POST /commerce/stores/{storeId}/products/{productId}/productOrderCancellations* */
  commerceCreateProductOrderCancellation: Maybe<CommerceProductOrderCancellation>
  /** *Equivalent to POST /commerce/stores/{storeId}/sales* */
  commerceCreateSale: Maybe<CommerceSale>
  /** *Equivalent to POST /commerce/stores/{storeId}/sales/{saleId}/saleProducts* */
  commerceCreateSaleProduct: Maybe<CommerceSaleProduct>
  /** *Equivalent to POST /commerce/stores* */
  commerceCreateStore: Maybe<CommerceStore>
  /** *Equivalent to POST /commerce/stores/{storeId}/tags* */
  commerceCreateTag: Maybe<CommerceTag>
  /** *Equivalent to POST /commerce/stores/{storeId}/taxes* */
  commerceCreateTax: Maybe<CommerceTax>
  /** *Equivalent to POST /commerce/stores/{storeId}/taxTypes* */
  commerceCreateTaxType: Maybe<CommerceTaxType>
  /** *Equivalent to POST /commerce/stores/{storeId}/orders/{orderId}/transactions* */
  commerceCreateTransaction: Maybe<CommerceTransaction>
  /** *Equivalent to POST /commerce/stores/{storeId}/vouchers* */
  commerceCreateVoucher: Maybe<CommerceVoucher>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/categories/{id}* */
  commerceDeleteCategory: Maybe<CommerceCategory>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/codes/{id}* */
  commerceDeleteCode: Maybe<CommerceCode>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/orders/{orderId}/customers/{id}* */
  commerceDeleteCustomer: Maybe<CommerceCustomer>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/deals/{id}* */
  commerceDeleteDeal: Maybe<CommerceDeal>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/deals/{dealId}/dealItems/{id}* */
  commerceDeleteDealItem: Maybe<CommerceDealItem>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/product/{productId}/packagedProducts/{id}* */
  commerceDeletePackagedProduct: Maybe<CommercePackagedProduct>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/paymentMethods/{id}* */
  commerceDeletePaymentMethod: Maybe<CommercePaymentMethod>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/products/{id}* */
  commerceDeleteProduct: Maybe<CommerceProduct>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/products/{productId}/productOrderCancellations/{id}* */
  commerceDeleteProductOrderCancellation: Maybe<CommerceProductOrderCancellation>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/sales/{id}* */
  commerceDeleteSale: Maybe<CommerceSale>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/sales/{saleId}/saleProducts/{id}* */
  commerceDeleteSaleProduct: Maybe<CommerceSaleProduct>
  /** *Equivalent to DELETE /commerce/stores/{id}* */
  commerceDeleteStore: Maybe<CommerceStore>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/tags/{id}* */
  commerceDeleteTag: Maybe<CommerceTag>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/taxes/{id}* */
  commerceDeleteTax: Maybe<CommerceTax>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/taxTypes/{id}* */
  commerceDeleteTaxType: Maybe<CommerceTaxType>
  /** *Equivalent to DELETE /commerce/stores/{storeId}/vouchers/{id}* */
  commerceDeleteVoucher: Maybe<CommerceVoucher>
  /** *Equivalent to PUT /commerce/stores/{storeId}/categories/{id}* */
  commerceUpdateCategory: Maybe<CommerceCategory>
  /** *Equivalent to PUT /commerce/stores/{storeId}/codes/{id}* */
  commerceUpdateCode: Maybe<CommerceCode>
  /** *Equivalent to PUT /commerce/stores/{storeId}/orders/{orderId}/customers/{id}* */
  commerceUpdateCustomer: Maybe<CommerceCustomer>
  /** *Equivalent to PUT /commerce/stores/{storeId}/deals/{id}* */
  commerceUpdateDeal: Maybe<CommerceDeal>
  /** *Equivalent to PUT /commerce/stores/{storeId}/deals/{dealId}/dealItems/{id}* */
  commerceUpdateDealItem: Maybe<CommerceDealItem>
  /** *Equivalent to PUT /commerce/stores/{storeId}/orders/{id}* */
  commerceUpdateOrder: Maybe<CommerceOrder>
  /** *Equivalent to PUT /commerce/stores/{storeId}/product/{productId}/packagedProducts/{id}* */
  commerceUpdatePackagedProduct: Maybe<CommercePackagedProduct>
  /** *Equivalent to PUT /commerce/stores/{storeId}/paymentMethods/{id}* */
  commerceUpdatePaymentMethod: Maybe<CommercePaymentMethod>
  /** *Equivalent to PUT /commerce/stores/{storeId}/products/{id}* */
  commerceUpdateProduct: Maybe<CommerceProduct>
  /** *Equivalent to PUT /commerce/stores/{storeId}/products/{productId}/productOrderCancellations/{id}* */
  commerceUpdateProductOrderCancellation: Maybe<CommerceProductOrderCancellation>
  /** *Equivalent to PUT /commerce/stores/{storeId}/sales/{id}* */
  commerceUpdateSale: Maybe<CommerceSale>
  /** *Equivalent to PUT /commerce/stores/{storeId}/sales/{saleId}/saleProducts/{id}* */
  commerceUpdateSaleProduct: Maybe<CommerceSaleProduct>
  /** *Equivalent to PUT /commerce/stores/{id}* */
  commerceUpdateStore: Maybe<CommerceStore>
  /** *Equivalent to PUT /commerce/stores/{storeId}/tags/{id}* */
  commerceUpdateTag: Maybe<CommerceTag>
  /** *Equivalent to PUT /commerce/stores/{storeId}/taxes/{id}* */
  commerceUpdateTax: Maybe<CommerceTax>
  /** *Equivalent to PUT /commerce/stores/{storeId}/taxTypes/{id}* */
  commerceUpdateTaxType: Maybe<CommerceTaxType>
  /** *Equivalent to PUT /commerce/stores/{storeId}/vouchers/{id}* */
  commerceUpdateVoucher: Maybe<CommerceVoucher>
  connectionLinkRemove: Maybe<ConnectionLinkRemovePayload>
  connectionRequestAccept: Maybe<ConnectionRequestAcceptPayload>
  connectionRequestCreate: Maybe<ConnectionRequestCreatePayload>
  connectionRequestReject: Maybe<ConnectionRequestRejectPayload>
  createBranding: Maybe<CreateBrandingPayload>
  createProduct: Maybe<CreateProductPayload>
  createProductBenefit: Maybe<CreateProductBenefitPayload>
  createSite: Maybe<CreateSitePayload>
  createWebPageConfig: Maybe<CreateWebPageConfigPayload>
  deleteBranding: Maybe<DeleteBrandingPayload>
  deleteProduct: Maybe<DeleteProductPayload>
  deleteProductBenefit: Maybe<DeleteProductBenefitPayload>
  deleteSite: Maybe<DeleteSitePayload>
  deleteWebPageConfig: Maybe<DeleteWebPageConfigPayload>
  /** *Equivalent to POST /email/collections* */
  emailCreateCollection: Maybe<EmailCollection>
  /** *Equivalent to POST /email/collections/{collectionId}/messages* */
  emailCreateMessage: Maybe<EmailMessage>
  /** *Equivalent to PUT /email/collections/{id}* */
  emailUpdateCollection: Maybe<EmailCollection>
  /** Creates a new event */
  eventCreate: Maybe<EventCreatePayload>
  /** Updates an existing event */
  eventUpdate: Maybe<EventUpdatePayload>
  forgotPassword: Maybe<UserPermissionsPasswordPayload>
  investorAccessGrant: Maybe<InvestorAccessGrantPayload>
  investorMeetingConfigurationUpdate: Maybe<InvestorMeetingConfigurationUpdatePayload>
  investorPortalRevokeAccess: Maybe<InvestorPortalRevokeAccessPayload>
  investorSessionsCreate: Maybe<InvestorSessionsCreatePayload>
  investorSessionsUpdate: Maybe<InvestorSessionsUpdatePayload>
  /** Creates a legal entity */
  legalEntityCreate: Maybe<LegalEntityCreatePayload>
  /** Updates an existing legal entity */
  legalEntityUpdate: Maybe<LegalEntityUpdatePayload>
  magicLinkGenerate: Maybe<MagicLinkGeneratePayload>
  myConnectionsEmailSend: Maybe<MyConnectionsEmailSendPayload>
  /** Convert a scheduled campaign to draft. */
  notificationCampaignConvertToDraft: Maybe<NotificationCampaign>
  /** Create a new campaign. */
  notificationCampaignCreate: Maybe<NotificationCampaign>
  /** Schedule a draft campaign to be run. */
  notificationCampaignSchedule: Maybe<NotificationCampaign>
  /** Update a draft campaign. */
  notificationCampaignUpdate: Maybe<NotificationCampaign>
  /**
   * Register a device for notifications.
   * When not unauthenticated the device will be registered but not associated with a user.
   * When authenticated the device will be registered to the authenticated user.
   * May be called repeatedly with the same token to associate and de-associate the device with a user.
   */
  notificationsDeviceRegister: Maybe<NotificationsDevice>
  /** Mark a notification as read. */
  notificationsRead: Maybe<Notifications>
  /** Mark all notifications as read. */
  notificationsReadAll: Maybe<Notifications>
  /** Mark batch of notifications as read. */
  notificationsReadBatch: Maybe<Notifications>
  orderCancel: Maybe<OrderCancelPayload>
  orderCreate: Maybe<OrderCreatePayload>
  orderUpdate: Maybe<OrderUpdatePayload>
  republishTicketAccept: Maybe<RepublishTicketAcceptPayload>
  roomHeartbeat: Maybe<Room>
  roomJoin: Maybe<RoomGrant>
  roomPreview: Maybe<RoomVideoCallConfig>
  roomUpdateFeatures: Maybe<Room>
  sessionTimeslotParticipationCreate: Maybe<SessionTimeslotParticipationCreatePayload>
  submitDynamicFormstackForm: DynamicFormSubmissionPayload
  ticketAccept: Maybe<TicketAcceptPayload>
  ticketAssign: Maybe<TicketAssignPayload>
  ticketCreate: Maybe<TicketCreatePayload>
  ticketLock: Maybe<TicketLockPayload>
  ticketReject: Maybe<TicketRejectPayload>
  ticketSetLeadScanning: Maybe<TicketSetLeadScanningPayload>
  ticketUnlock: Maybe<TicketUnlockPayload>
  ticketUnvoid: Maybe<TicketUnvoidPayload>
  ticketUpdate: Maybe<TicketUpdatePayload>
  ticketVoid: Maybe<TicketVoidPayload>
  updateBranding: Maybe<UpdateBrandingPayload>
  updateProduct: Maybe<UpdateProductPayload>
  updateProductBenefit: Maybe<UpdateProductBenefitPayload>
  updateSite: Maybe<UpdateSitePayload>
  updateWebPageConfig: Maybe<UpdateWebPageConfigPayload>
  /** *Equivalent to POST /webhooks/messages* */
  webhooksCreateMessage: Maybe<WebhooksMessage>
  /** *Equivalent to POST /webhooks/targets* */
  webhooksCreateTarget: Maybe<WebhooksTarget>
  /** *Equivalent to DELETE /webhooks/executions/{id}* */
  webhooksDeleteExecution: Maybe<WebhooksExecution>
  /** *Equivalent to DELETE /webhooks/targets/{id}* */
  webhooksDeleteTarget: Maybe<WebhooksTarget>
  /** *Equivalent to PUT /webhooks/targets/{id}* */
  webhooksUpdateTarget: Maybe<WebhooksTarget>
}

export type MutationAppearanceConnectArgs = {
  input: AppearanceConnectInput
}

export type MutationAppearanceUpdateArgs = {
  input: AppearanceUpdateInput
}

export type MutationAssignmentAccountUpdateArgs = {
  input: AssignmentAccountUpdateInput
}

export type MutationAssignmentAddOnAssignArgs = {
  input: AddOnAssignInput
}

export type MutationAssignmentAddOnUnassignArgs = {
  input: AddOnUnassignInput
}

export type MutationAssignmentAddOnUnvoidArgs = {
  input: AssignmentAddOnUnvoidInput
}

export type MutationAssignmentAddOnVoidArgs = {
  input: AssignmentAddOnVoidInput
}

export type MutationAssignmentAuthenticateArgs = {
  input: AssignmentAuthenticateInput
}

export type MutationAssignmentMagicLinkGenerateArgs = {
  input: AssignmentMagicLinkGenerateInput
}

export type MutationAssignmentMagicLinkLoginRequestArgs = {
  input: AssignmentMagicLinkLoginRequestInput
}

export type MutationAssignmentProfileAdminUpdateArgs = {
  input: AssignmentProfileAdminUpdateInput
}

export type MutationAssignmentProfileUpdateArgs = {
  input: AssignmentProfileUpdateInput
}

export type MutationAssignmentResendOrderEmailArgs = {
  input: AssignmentResendOrderEmailInput
}

export type MutationAssignmentSalesforceAccountUpdateArgs = {
  input: AssignmentSalesforceAccountUpdateInput
}

export type MutationAssignmentTicketLoginUpdateArgs = {
  input: AssignmentTicketLoginUpdateInput
}

export type MutationAssignmentTicketUpgradeAssignArgs = {
  input: TicketUpgradeAssignInput
}

export type MutationAssignmentTicketUpgradeUnassignArgs = {
  input: TicketUpgradeUnassignInput
}

export type MutationAssignmentTicketUpgradeUnvoidArgs = {
  input: TicketUpgradeUnvoidInput
}

export type MutationAssignmentTicketUpgradeVoidArgs = {
  input: TicketUpgradeVoidInput
}

export type MutationAttendanceAppearanceSelectionDestroyArgs = {
  input: AttendanceAppearanceSelectionDestroyInput
}

export type MutationAttendanceAppearanceSelectionUpdateArgs = {
  input: AttendanceAppearanceSelectionsUpdateInput
}

export type MutationAttendanceInvestorSessionUpdateArgs = {
  input: AttendanceInvestorSessionUpdateInput
}

export type MutationAttendeeBlockArgs = {
  input: AttendeeBlockInput
}

export type MutationAttendeeConnectArgs = {
  input: AttendeeConnectInput
}

export type MutationAttendeeProfileUpdateArgs = {
  input: AttendeeProfileUpdateInput
}

export type MutationAttendeeUnblockArgs = {
  input: AttendeeUnblockInput
}

export type MutationAuthCreateOauthArgs = {
  authOauthCreate: AuthOauthCreate
}

export type MutationAuthCreateRoleArgs = {
  authRoleCreate: AuthRoleCreate
}

export type MutationAuthCreateUserArgs = {
  authUserCreate: AuthUserCreate
}

export type MutationAuthDeleteOauthArgs = {
  id: Scalars['ID']
}

export type MutationAuthDeleteRoleArgs = {
  id: Scalars['ID']
}

export type MutationAuthDeleteUserArgs = {
  id: Scalars['ID']
}

export type MutationAuthEnsureUserUserArgs = {
  authUserCreate: AuthUserCreate
  verified: Scalars['Boolean']
}

export type MutationAuthGrantPermissionRoleArgs = {
  id: Scalars['ID']
  permission: Scalars['String']
}

export type MutationAuthGrantPermissionUserArgs = {
  id: Scalars['ID']
  permission: Scalars['String']
}

export type MutationAuthRevokePermissionRoleArgs = {
  id: Scalars['ID']
  permission: Scalars['String']
}

export type MutationAuthRevokePermissionUserArgs = {
  id: Scalars['ID']
  permission: Scalars['String']
}

export type MutationAuthUpdateOauthArgs = {
  authOauthUpdate: AuthOauthUpdate
  id: Scalars['ID']
}

export type MutationAuthUpdateRoleArgs = {
  authRoleUpdate: AuthRoleUpdate
  id: Scalars['ID']
}

export type MutationAuthUpdateUserArgs = {
  authUserUpdate: AuthUserUpdate
  id: Scalars['ID']
}

export type MutationAuthenticateByTokenArgs = {
  input: AuthenticateByTokenInput
}

export type MutationChatChannelCreateArgs = {
  input: ChatChannelCreateInput
}

export type MutationCommerceCreateCategoryArgs = {
  commerceCategoryCreate: CommerceCategoryCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateCodeArgs = {
  commerceCodeCreate: CommerceCodeCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateCustomerArgs = {
  commerceCustomerCreate: CommerceCustomerCreate
  orderId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateDealArgs = {
  commerceDealCreate: CommerceDealCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateDealItemArgs = {
  commerceDealItemCreate: CommerceDealItemCreate
  dealId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateOrderArgs = {
  commerceOrderCreate: CommerceOrderCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreatePackagedProductArgs = {
  commercePackagedProductCreate: CommercePackagedProductCreate
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreatePaymentMethodArgs = {
  commercePaymentMethodCreate: CommercePaymentMethodCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateProductArgs = {
  commerceProductCreate: CommerceProductCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateProductOrderCancellationArgs = {
  commerceProductOrderCancellationCreate: CommerceProductOrderCancellationCreate
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateSaleArgs = {
  commerceSaleCreate: CommerceSaleCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateSaleProductArgs = {
  commerceSaleProductCreate: CommerceSaleProductCreate
  saleId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateStoreArgs = {
  commerceStoreCreate: CommerceStoreCreate
}

export type MutationCommerceCreateTagArgs = {
  commerceTagCreate: CommerceTagCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateTaxArgs = {
  commerceTaxCreate: CommerceTaxCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateTaxTypeArgs = {
  commerceTaxTypeCreate: CommerceTaxTypeCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateTransactionArgs = {
  commerceTransactionCreate: CommerceTransactionCreate
  orderId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceCreateVoucherArgs = {
  commerceVoucherCreate: CommerceVoucherCreate
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteCategoryArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteCodeArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteCustomerArgs = {
  id: Scalars['ID']
  orderId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteDealArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteDealItemArgs = {
  dealId: Scalars['ID']
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeletePackagedProductArgs = {
  id: Scalars['ID']
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeletePaymentMethodArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteProductArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteProductOrderCancellationArgs = {
  id: Scalars['ID']
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteSaleArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteSaleProductArgs = {
  id: Scalars['ID']
  saleId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteStoreArgs = {
  id: Scalars['ID']
}

export type MutationCommerceDeleteTagArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteTaxArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteTaxTypeArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceDeleteVoucherArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateCategoryArgs = {
  commerceCategoryUpdate: CommerceCategoryUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateCodeArgs = {
  commerceCodeUpdate: CommerceCodeUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateCustomerArgs = {
  commerceCustomerUpdate: CommerceCustomerUpdate
  id: Scalars['ID']
  orderId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateDealArgs = {
  commerceDealUpdate: CommerceDealUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateDealItemArgs = {
  commerceDealItemUpdate: CommerceDealItemUpdate
  dealId: Scalars['ID']
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateOrderArgs = {
  commerceOrderUpdate: CommerceOrderUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdatePackagedProductArgs = {
  commercePackagedProductUpdate: CommercePackagedProductUpdate
  id: Scalars['ID']
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdatePaymentMethodArgs = {
  commercePaymentMethodUpdate: CommercePaymentMethodUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateProductArgs = {
  commerceProductUpdate: CommerceProductUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateProductOrderCancellationArgs = {
  commerceProductOrderCancellationUpdate: CommerceProductOrderCancellationUpdate
  id: Scalars['ID']
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateSaleArgs = {
  commerceSaleUpdate: CommerceSaleUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateSaleProductArgs = {
  commerceSaleProductUpdate: CommerceSaleProductUpdate
  id: Scalars['ID']
  saleId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateStoreArgs = {
  commerceStoreUpdate: CommerceStoreUpdate
  id: Scalars['ID']
}

export type MutationCommerceUpdateTagArgs = {
  commerceTagUpdate: CommerceTagUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateTaxArgs = {
  commerceTaxUpdate: CommerceTaxUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateTaxTypeArgs = {
  commerceTaxTypeUpdate: CommerceTaxTypeUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationCommerceUpdateVoucherArgs = {
  commerceVoucherUpdate: CommerceVoucherUpdate
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
}

export type MutationConnectionLinkRemoveArgs = {
  input: ConnectionLinkRemoveInput
}

export type MutationConnectionRequestAcceptArgs = {
  input: ConnectionRequestAcceptInput
}

export type MutationConnectionRequestCreateArgs = {
  input: ConnectionRequestCreateInput
}

export type MutationConnectionRequestRejectArgs = {
  input: ConnectionRequestRejectInput
}

export type MutationCreateBrandingArgs = {
  input?: Maybe<CreateBrandingInput>
}

export type MutationCreateProductArgs = {
  input?: Maybe<CreateProductInput>
}

export type MutationCreateProductBenefitArgs = {
  input?: Maybe<CreateProductBenefitInput>
}

export type MutationCreateSiteArgs = {
  input?: Maybe<CreateSiteInput>
}

export type MutationCreateWebPageConfigArgs = {
  input?: Maybe<CreateWebPageConfigInput>
}

export type MutationDeleteBrandingArgs = {
  input?: Maybe<DeleteBrandingInput>
}

export type MutationDeleteProductArgs = {
  input?: Maybe<DeleteProductInput>
}

export type MutationDeleteProductBenefitArgs = {
  input?: Maybe<DeleteProductBenefitInput>
}

export type MutationDeleteSiteArgs = {
  input?: Maybe<DeleteSiteInput>
}

export type MutationDeleteWebPageConfigArgs = {
  input?: Maybe<DeleteWebPageConfigInput>
}

export type MutationEmailCreateCollectionArgs = {
  emailCollectionCreate: EmailCollectionCreate
}

export type MutationEmailCreateMessageArgs = {
  collectionId?: Maybe<Scalars['ID']>
  emailMessageCreate: EmailMessageCreate
}

export type MutationEmailUpdateCollectionArgs = {
  emailCollectionUpdate: EmailCollectionUpdate
  id: Scalars['ID']
}

export type MutationEventCreateArgs = {
  input: EventCreateInput
}

export type MutationEventUpdateArgs = {
  input: EventUpdateInput
}

export type MutationForgotPasswordArgs = {
  email: Scalars['String']
}

export type MutationInvestorAccessGrantArgs = {
  input: InvestorAccessGrantInput
}

export type MutationInvestorMeetingConfigurationUpdateArgs = {
  input: InvestorMeetingConfigurationUpdateInput
}

export type MutationInvestorPortalRevokeAccessArgs = {
  input: InvestorPortalRevokeAccessInput
}

export type MutationInvestorSessionsCreateArgs = {
  input: InvestorSessionsCreateInput
}

export type MutationInvestorSessionsUpdateArgs = {
  input: InvestorSessionsUpdateInput
}

export type MutationLegalEntityCreateArgs = {
  input: LegalEntityCreateInput
}

export type MutationLegalEntityUpdateArgs = {
  input: LegalEntityUpdateInput
}

export type MutationMagicLinkGenerateArgs = {
  input: MagicLinkGenerateInput
}

export type MutationMyConnectionsEmailSendArgs = {
  input: MyConnectionsEmailSendInput
}

export type MutationNotificationCampaignConvertToDraftArgs = {
  id: Scalars['ID']
}

export type MutationNotificationCampaignCreateArgs = {
  input: NotificationCampaignCreateInput
}

export type MutationNotificationCampaignScheduleArgs = {
  id: Scalars['ID']
}

export type MutationNotificationCampaignUpdateArgs = {
  id: Scalars['ID']
  input: NotificationCampaignCreateInput
}

export type MutationNotificationsDeviceRegisterArgs = {
  input: NotificationsDeviceRegisterInput
}

export type MutationNotificationsReadArgs = {
  id: Scalars['ID']
}

export type MutationNotificationsReadBatchArgs = {
  ids: Array<Scalars['ID']>
}

export type MutationOrderCancelArgs = {
  input: OrderCancelInput
}

export type MutationOrderCreateArgs = {
  input: OrderCreateInput
}

export type MutationOrderUpdateArgs = {
  input: OrderUpdateInput
}

export type MutationRepublishTicketAcceptArgs = {
  input: RepublishTicketAcceptInput
}

export type MutationRoomHeartbeatArgs = {
  id: Scalars['ID']
}

export type MutationRoomJoinArgs = {
  input?: Maybe<RoomJoinInput>
}

export type MutationRoomUpdateFeaturesArgs = {
  id: Scalars['ID']
  input: RoomUpdateFeaturesInput
}

export type MutationSessionTimeslotParticipationCreateArgs = {
  input: SessionTimeslotParticipationCreateInput
}

export type MutationSubmitDynamicFormstackFormArgs = {
  id: Scalars['ID']
  input: Scalars['JSON']
}

export type MutationTicketAcceptArgs = {
  input: TicketAcceptInput
}

export type MutationTicketAssignArgs = {
  input: TicketAssignInput
}

export type MutationTicketCreateArgs = {
  input: TicketCreateInput
}

export type MutationTicketLockArgs = {
  input: TicketLockInput
}

export type MutationTicketRejectArgs = {
  input: TicketRejectInput
}

export type MutationTicketSetLeadScanningArgs = {
  input: TicketSetLeadScanningInput
}

export type MutationTicketUnlockArgs = {
  input: TicketUnlockInput
}

export type MutationTicketUnvoidArgs = {
  input: TicketUnvoidInput
}

export type MutationTicketUpdateArgs = {
  input: TicketUpdateInput
}

export type MutationTicketVoidArgs = {
  input: TicketVoidInput
}

export type MutationUpdateBrandingArgs = {
  input?: Maybe<UpdateBrandingInput>
}

export type MutationUpdateProductArgs = {
  input?: Maybe<UpdateProductInput>
}

export type MutationUpdateProductBenefitArgs = {
  input?: Maybe<UpdateProductBenefitInput>
}

export type MutationUpdateSiteArgs = {
  input?: Maybe<UpdateSiteInput>
}

export type MutationUpdateWebPageConfigArgs = {
  input?: Maybe<UpdateWebPageConfigInput>
}

export type MutationWebhooksCreateMessageArgs = {
  webhooksMessageCreate: WebhooksMessageCreate
}

export type MutationWebhooksCreateTargetArgs = {
  webhooksTargetCreate: WebhooksTargetCreate
}

export type MutationWebhooksDeleteExecutionArgs = {
  id: Scalars['ID']
}

export type MutationWebhooksDeleteTargetArgs = {
  id: Scalars['ID']
}

export type MutationWebhooksUpdateTargetArgs = {
  id: Scalars['ID']
  webhooksTargetUpdate: WebhooksTargetUpdate
}

/** Autogenerated input type of MyConnectionsEmailSend */
export type MyConnectionsEmailSendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of MyConnectionsEmailSend */
export type MyConnectionsEmailSendPayload = {
  __typename?: 'MyConnectionsEmailSendPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  errors: Array<Error>
  recipient: User
}

export type NeverAssigned = {
  __typename?: 'NeverAssigned'
  count: Scalars['Int']
}

/** A notification history entry. */
export type Notification = {
  __typename?: 'Notification'
  /** Notification body. */
  body: Scalars['String']
  /** The context surrounding the notification. */
  context: Maybe<NotificationContext>
  /** Date and time when the notification was created. */
  createdAt: Scalars['String']
  /** Mobile deep link associated with the notificaiton. */
  deepLink: Maybe<Scalars['String']>
  /** Uniquely identifies the campaign. */
  id: Scalars['ID']
  /** Whether the notification has been marked as read. */
  read: Scalars['Boolean']
  /** Notification title. */
  title: Scalars['String']
  /** Web URL associated with the notification. */
  url: Maybe<Scalars['String']>
}

/** A notification campaign. */
export type NotificationCampaign = {
  __typename?: 'NotificationCampaign'
  /** Notification body. */
  body: Scalars['String']
  /** Date and time when the campaign was completed. */
  completedAt: Maybe<Scalars['String']>
  /** Notification context. */
  context: Maybe<NotificationContext>
  /** Date and time when the campaign was created. */
  createdAt: Scalars['String']
  /** Notification deep link. */
  deepLink: Maybe<Scalars['String']>
  /** Number of processed deliveries. */
  deliveryCount: Scalars['Int']
  /** Uniquely identifies the campaign. */
  id: Scalars['ID']
  /** Number of opened notifications. */
  openCount: Scalars['Int']
  /** Date and time when the campaign was scheduled for. */
  scheduledFor: Scalars['String']
  /** Date and time when the campaign was started. */
  startedAt: Maybe<Scalars['String']>
  /** The current state of the campaign. */
  status: NotificationCampaignStatus
  /** True if the campaign targets all conference attendees. */
  targetAllAttendees: Scalars['Boolean']
  /** Specific attendees targeted by the campaign. */
  targetSpecificAttendees: Maybe<Array<Scalars['String']>>
  /** List of topics targeted by the campaign. */
  targetTopics: Maybe<Array<Scalars['String']>>
  /** Notification title. */
  title: Scalars['String']
}

/** Look up campaigns. */
export type NotificationCampaignConnection = {
  __typename?: 'NotificationCampaignConnection'
  /** A list of edges. */
  edges: Array<NotificationCampaignEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/**
 * A new campaign to create.
 * Exactly one of targetAllAttendees, targetSpecificAttendees, and targetTopics should be set.
 */
export type NotificationCampaignCreateInput = {
  /** Notification body. */
  body: Scalars['String']
  /** Notification context type. */
  contextType?: Maybe<NotificationContextType>
  /** Notification context value. */
  contextValue?: Maybe<Scalars['String']>
  /** Notification deep link. */
  deepLink?: Maybe<Scalars['String']>
  /** Date and time when the campaign is scheduled for. */
  scheduledFor: Scalars['String']
  /** Are all attendees in the conference targeted */
  targetAllAttendees?: Maybe<Scalars['Boolean']>
  /** A list of attendee IDs to target. */
  targetSpecificAttendees?: Maybe<Array<Scalars['ID']>>
  /** A list of topics to target. */
  targetTopics?: Maybe<Array<Scalars['String']>>
  /** Notification title. */
  title: Scalars['String']
}

/** An edge in a connection. */
export type NotificationCampaignEdge = {
  __typename?: 'NotificationCampaignEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: NotificationCampaign
}

/** The possible states for a campaign. */
export enum NotificationCampaignStatus {
  /** The campaign has been completed. */
  Completed = 'COMPLETED',
  /** The campaign is a draft. */
  Draft = 'DRAFT',
  /** The campaign has been locked for changes. */
  Locked = 'LOCKED',
  /** The campaign is running. */
  Running = 'RUNNING',
  /** The campaign has been scheduled. */
  Scheduled = 'SCHEDULED',
}

/** The set of possible client configurations. */
export type NotificationConfig = NotificationConfigPubnub

/** Configuration for a pubnub client. */
export type NotificationConfigPubnub = {
  __typename?: 'NotificationConfigPubnub'
  /** The client's pubnub channel */
  channel: Scalars['String']
  /** The client's pubnub subscribe key */
  subscribeKey: Scalars['String']
}

/** Look up notifiactions. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection'
  /** A list of edges. */
  edges: Array<NotificationEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/**
 * The context surrounding a notification. Can point to a particular talk, meeting, chat, or other
 * entities and concepts.
 */
export type NotificationContext = {
  __typename?: 'NotificationContext'
  /** The context type. */
  type: NotificationContextType
  /** The context value. */
  value: Maybe<Scalars['String']>
}

/** The set of possible notification contexts. */
export enum NotificationContextType {
  Appearance = 'APPEARANCE',
  Attendee = 'ATTENDEE',
  CalendarEvent = 'CALENDAR_EVENT',
  ChatChannel = 'CHAT_CHANNEL',
  CommunicationPreferences = 'COMMUNICATION_PREFERENCES',
  ConnectionRequest = 'CONNECTION_REQUEST',
  ExternalUrl = 'EXTERNAL_URL',
  InternalUrl = 'INTERNAL_URL',
  Job = 'JOB',
  Perk = 'PERK',
  Schedule = 'SCHEDULE',
  Ticket = 'TICKET',
  Timeslot = 'TIMESLOT',
}

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Notification
}

/** The user's notifications. */
export type Notifications = {
  __typename?: 'Notifications'
  /** Client-specific configuration. */
  config: Maybe<NotificationConfig>
  /** Notification history. */
  history: NotificationConnection
  /** Number of unread notificaitons in history. */
  unreadCount: Scalars['Int']
}

/** The user's notifications. */
export type NotificationsHistoryArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** A device registered for notifications. */
export type NotificationsDevice = {
  __typename?: 'NotificationsDevice'
  /** Uniquely identifies the device. */
  id: Scalars['ID']
  /** Device token. */
  token: Scalars['String']
}

/** Device to register. */
export type NotificationsDeviceRegisterInput = {
  /** Conference slug. Required when not authenticated. */
  conference?: Maybe<Scalars['String']>
  /** Device platform. */
  platform: DevicePlatform
  /** Platform-specific device token. */
  token: Scalars['String']
}

export type Order = {
  __typename?: 'Order'
  addOns: TaAddOnConnection
  /** @deprecated No longer used. Will always return 0 to maintain backwards compatiability. */
  amount: Scalars['Float']
  booking: Booking
  completedAt: Scalars['ISO8601DateTime']
  currency: Scalars['String']
  id: Scalars['ID']
  invoiceUrl: Maybe<Scalars['String']>
  lastUpdatedAt: Scalars['ISO8601DateTime']
  owner: AssignmentUser
  reference: Scalars['String']
  source: Maybe<OrderSource>
  sourceId: Maybe<Scalars['ID']>
  sourceUrl: Maybe<Scalars['String']>
  state: OrderFilterStatus
  summary: OrderSummary
  ticketUpgrades: TaTicketUpgradeConnection
  tickets: TicketConnection
  ticketsSummary: TicketsSummary
  versions: Maybe<Array<PaperTrailVersion>>
}

export type OrderAddOnsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type OrderTicketUpgradesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type OrderTicketsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<TicketFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of OrderCancel */
export type OrderCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  disableEmailNotification?: Maybe<Scalars['Boolean']>
  reference: Scalars['String']
}

/** Autogenerated return type of OrderCancel. */
export type OrderCancelPayload = {
  __typename?: 'OrderCancelPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  order: Maybe<Order>
  userErrors: Array<UserError>
}

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection'
  /** A list of edges. */
  edges: Array<OrderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** Autogenerated input type of OrderCreate */
export type OrderCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  notify?: Maybe<Scalars['Boolean']>
  owner: AccountAttributes
  reference: Scalars['String']
  source: Scalars['String']
  tickets?: Maybe<Array<TicketAttributes>>
}

/** Autogenerated return type of OrderCreate. */
export type OrderCreatePayload = {
  __typename?: 'OrderCreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  order: Maybe<Order>
  userErrors: Array<UserError>
}

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Order
}

export type OrderFilter = {
  addOnTypeIds?: Maybe<Array<Scalars['ID']>>
  createdAtFrom?: Maybe<Scalars['ISO8601Date']>
  createdAtTo?: Maybe<Scalars['ISO8601Date']>
  status?: Maybe<OrderFilterStatus>
  ticketTypeIds?: Maybe<Array<Scalars['ID']>>
  ticketUpgradeTypeIds?: Maybe<Array<Scalars['ID']>>
}

export enum OrderFilterStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
}

export enum OrderSource {
  TicketMachine = 'TICKET_MACHINE',
  Tito = 'TITO',
}

export type OrderSummary = {
  __typename?: 'OrderSummary'
  addOnType: Maybe<TaAddOnType>
  addOns: Scalars['Int']
  ticketType: Maybe<TicketType>
  ticketUpgradeType: Maybe<TaTicketUpgradeType>
  ticketUpgrades: Scalars['Int']
  /** @deprecated Use `order.ticketsSummary.all` instead. */
  tickets: Scalars['Int']
}

/** Autogenerated input type of OrderUpdate */
export type OrderUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  notify?: Maybe<Scalars['Boolean']>
  owner: AccountAttributes
  reference: Scalars['String']
}

/** Autogenerated return type of OrderUpdate. */
export type OrderUpdatePayload = {
  __typename?: 'OrderUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  order: Maybe<Order>
  userErrors: Array<UserError>
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items?. */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>
}

export type PaperTrailVersion = {
  __typename?: 'PaperTrailVersion'
  command: Maybe<Scalars['String']>
  context: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['ISO8601DateTime']>
  event: Scalars['String']
  id: Scalars['Int']
  itemId: Scalars['ID']
  itemType: Scalars['String']
  object: Maybe<Scalars['String']>
  objectChanges: Maybe<Scalars['String']>
  reason: Maybe<Scalars['String']>
  sourceLocation: Maybe<Scalars['String']>
  whodunnit: Maybe<Scalars['String']>
}

export type Pending = {
  __typename?: 'Pending'
  count: Scalars['Int']
}

export type ProductBenefitInput = {
  created_by?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type ProductBenefits = {
  __typename?: 'ProductBenefits'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type ProductBenefitsAggregator = {
  __typename?: 'ProductBenefitsAggregator'
  count: Maybe<Scalars['Int']>
  totalCount: Maybe<Scalars['Int']>
}

export type ProductBenefitsConnection = {
  __typename?: 'ProductBenefitsConnection'
  aggregate: Maybe<ProductBenefitsAggregator>
  groupBy: Maybe<ProductBenefitsGroupBy>
  values: Maybe<Array<Maybe<ProductBenefits>>>
}

export type ProductBenefitsConnectionCreatedAt = {
  __typename?: 'ProductBenefitsConnectionCreatedAt'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['DateTime']>
}

export type ProductBenefitsConnectionCreated_By = {
  __typename?: 'ProductBenefitsConnectionCreated_by'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductBenefitsConnectionDescription = {
  __typename?: 'ProductBenefitsConnectionDescription'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductBenefitsConnectionId = {
  __typename?: 'ProductBenefitsConnectionId'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductBenefitsConnectionTitle = {
  __typename?: 'ProductBenefitsConnectionTitle'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductBenefitsConnectionUpdatedAt = {
  __typename?: 'ProductBenefitsConnectionUpdatedAt'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['DateTime']>
}

export type ProductBenefitsConnectionUpdated_By = {
  __typename?: 'ProductBenefitsConnectionUpdated_by'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductBenefitsConnection_Id = {
  __typename?: 'ProductBenefitsConnection_id'
  connection: Maybe<ProductBenefitsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductBenefitsGroupBy = {
  __typename?: 'ProductBenefitsGroupBy'
  _id: Maybe<Array<Maybe<ProductBenefitsConnection_Id>>>
  createdAt: Maybe<Array<Maybe<ProductBenefitsConnectionCreatedAt>>>
  created_by: Maybe<Array<Maybe<ProductBenefitsConnectionCreated_By>>>
  description: Maybe<Array<Maybe<ProductBenefitsConnectionDescription>>>
  id: Maybe<Array<Maybe<ProductBenefitsConnectionId>>>
  title: Maybe<Array<Maybe<ProductBenefitsConnectionTitle>>>
  updatedAt: Maybe<Array<Maybe<ProductBenefitsConnectionUpdatedAt>>>
  updated_by: Maybe<Array<Maybe<ProductBenefitsConnectionUpdated_By>>>
}

export type ProductInput = {
  code?: Maybe<Scalars['String']>
  created_by?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  event?: Maybe<Scalars['ID']>
  sourceId?: Maybe<Scalars['String']>
  sourceName?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Enum_Products_Type>
  updated_by?: Maybe<Scalars['ID']>
}

export type Products = {
  __typename?: 'Products'
  _id: Scalars['ID']
  code: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  sourceId: Maybe<Scalars['String']>
  sourceName: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  type: Maybe<Enum_Products_Type>
  updatedAt: Scalars['DateTime']
}

export type ProductsAggregator = {
  __typename?: 'ProductsAggregator'
  count: Maybe<Scalars['Int']>
  totalCount: Maybe<Scalars['Int']>
}

export type ProductsConnection = {
  __typename?: 'ProductsConnection'
  aggregate: Maybe<ProductsAggregator>
  groupBy: Maybe<ProductsGroupBy>
  values: Maybe<Array<Maybe<Products>>>
}

export type ProductsConnectionCode = {
  __typename?: 'ProductsConnectionCode'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductsConnectionCreatedAt = {
  __typename?: 'ProductsConnectionCreatedAt'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['DateTime']>
}

export type ProductsConnectionCreated_By = {
  __typename?: 'ProductsConnectionCreated_by'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductsConnectionDescription = {
  __typename?: 'ProductsConnectionDescription'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductsConnectionEvent = {
  __typename?: 'ProductsConnectionEvent'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductsConnectionId = {
  __typename?: 'ProductsConnectionId'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductsConnectionSourceId = {
  __typename?: 'ProductsConnectionSourceId'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductsConnectionSourceName = {
  __typename?: 'ProductsConnectionSourceName'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductsConnectionTitle = {
  __typename?: 'ProductsConnectionTitle'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductsConnectionType = {
  __typename?: 'ProductsConnectionType'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['String']>
}

export type ProductsConnectionUpdatedAt = {
  __typename?: 'ProductsConnectionUpdatedAt'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['DateTime']>
}

export type ProductsConnectionUpdated_By = {
  __typename?: 'ProductsConnectionUpdated_by'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductsConnection_Id = {
  __typename?: 'ProductsConnection_id'
  connection: Maybe<ProductsConnection>
  key: Maybe<Scalars['ID']>
}

export type ProductsGroupBy = {
  __typename?: 'ProductsGroupBy'
  _id: Maybe<Array<Maybe<ProductsConnection_Id>>>
  code: Maybe<Array<Maybe<ProductsConnectionCode>>>
  createdAt: Maybe<Array<Maybe<ProductsConnectionCreatedAt>>>
  created_by: Maybe<Array<Maybe<ProductsConnectionCreated_By>>>
  description: Maybe<Array<Maybe<ProductsConnectionDescription>>>
  event: Maybe<Array<Maybe<ProductsConnectionEvent>>>
  id: Maybe<Array<Maybe<ProductsConnectionId>>>
  sourceId: Maybe<Array<Maybe<ProductsConnectionSourceId>>>
  sourceName: Maybe<Array<Maybe<ProductsConnectionSourceName>>>
  title: Maybe<Array<Maybe<ProductsConnectionTitle>>>
  type: Maybe<Array<Maybe<ProductsConnectionType>>>
  updatedAt: Maybe<Array<Maybe<ProductsConnectionUpdatedAt>>>
  updated_by: Maybe<Array<Maybe<ProductsConnectionUpdated_By>>>
}

export type Query = {
  __typename?: 'Query'
  adminAttendeeProfile: Maybe<Attendee>
  appConfig: Maybe<AppConfig>
  appearance: Maybe<Appearance>
  appearances: AppearanceConnection
  /** Returns the attendee's profile */
  assignmentProfile: Maybe<AssignmentUser>
  /** Retrieves the current users details */
  assignmentUser: Maybe<AssignmentUser>
  attendance: Maybe<Attendee>
  attendanceAppearanceSelection: AttendanceAppearanceSelection
  attendances: AttendeeConnection
  /** *Equivalent to GET /auth/users/{id}/token* */
  authGenerateTokenUser: Maybe<AuthToken>
  /** *Equivalent to GET /auth/audit/{entity}/{id}* */
  authGetAuditForTypeAndTargetAuditEntry: Maybe<Array<Maybe<AuthAuditEntry>>>
  /** *Equivalent to GET /auth/audit/{entity}* */
  authGetAuditForTypeAuditEntry: Maybe<Array<Maybe<AuthAuditEntry>>>
  /** *Equivalent to GET /auth/me* */
  authGetCurrentUser: Maybe<AuthUser>
  /** *Equivalent to GET /auth/oauths/{id}* */
  authGetOauth: Maybe<AuthOauth>
  /** *Equivalent to GET /auth/roles/{id}* */
  authGetRole: Maybe<AuthRole>
  /** *Equivalent to GET /auth/users/{id}* */
  authGetUser: Maybe<AuthUser>
  /** *Equivalent to GET /auth/tokens/{jwt}/user* */
  authGetUserFromToken: Maybe<AuthUser>
  /** *Equivalent to GET /auth/oauths* */
  authListOauths: Maybe<AuthPageOauth>
  /** *Equivalent to GET /auth/roles* */
  authListRoles: Maybe<AuthPageRole>
  /** *Equivalent to GET /auth/users* */
  authListUsers: Maybe<AuthPageUser>
  /** *Equivalent to GET /auth/logout* */
  authLogout: Maybe<AuthUser>
  /** *Equivalent to GET /auth/tokens/{jwt}/renew* */
  authRenewToken: Maybe<AuthToken>
  /** *Equivalent to GET /auth/users/{id}/verify* */
  authVerifyEmailAdminUser: Maybe<AuthUser>
  /** *Equivalent to GET /auth/tokens/{jwt}/permissions/{permission}* */
  authVerifyPermission: Maybe<AuthPermission>
  /** *Equivalent to GET /auth/users/{id}/permissions/{permission}* */
  authVerifyPermissionUser: Maybe<AuthPermission>
  /** Retrieves a booking by the reference. */
  booking: Maybe<Booking>
  /**
   * Retrieves all bookings.
   * Can be filtered by:
   *   - `filter`
   *   - `search_query`
   */
  bookings: Maybe<BookingConnection>
  branding: Maybe<Branding>
  brandingBySlug: Maybe<Branding>
  brandings: Maybe<Array<Maybe<Branding>>>
  brandingsConnection: Maybe<BrandingConnection>
  chatChannel: Maybe<ChatChannel>
  chatChannels: Maybe<ChatChannelConnection>
  /** *Equivalent to GET /commerce/audit/{entity}/{id}* */
  commerceGetAuditForTypeAndTargetAuditEntry: Maybe<Array<Maybe<CommerceAuditEntry>>>
  /** *Equivalent to GET /commerce/audit/{entity}* */
  commerceGetAuditForTypeAuditEntry: Maybe<Array<Maybe<CommerceAuditEntry>>>
  /** *Equivalent to GET /commerce/stores/{storeId}/categories/{id}* */
  commerceGetCategory: Maybe<CommerceCategory>
  /** *Equivalent to GET /commerce/stores/{storeId}/codes/{id}* */
  commerceGetCode: Maybe<CommerceCode>
  /** *Equivalent to GET /commerce/stores/{storeId}/orders/{orderId}/customers/{id}* */
  commerceGetCustomer: Maybe<CommerceCustomer>
  /** *Equivalent to GET /commerce/stores/{storeId}/deals/{id}* */
  commerceGetDeal: Maybe<CommerceDeal>
  /** *Equivalent to GET /commerce/stores/{storeId}/deals/{dealId}/dealItems/{id}* */
  commerceGetDealItem: Maybe<CommerceDealItem>
  /** *Equivalent to GET /commerce/stores/{storeId}/orders/{id}* */
  commerceGetOrder: Maybe<CommerceOrder>
  /** *Equivalent to GET /commerce/stores/{storeId}/product/{productId}/packagedProducts/{id}* */
  commerceGetPackagedProduct: Maybe<CommercePackagedProduct>
  /** *Equivalent to GET /commerce/paymentGateways/{id}* */
  commerceGetPaymentGateway: Maybe<CommercePaymentGateway>
  /** *Equivalent to GET /commerce/stores/{storeId}/paymentMethods/{id}* */
  commerceGetPaymentMethod: Maybe<CommercePaymentMethod>
  /** *Equivalent to GET /commerce/stores/{storeId}/products/{id}* */
  commerceGetProduct: Maybe<CommerceProduct>
  /** *Equivalent to GET /commerce/stores/{storeId}/products/{productId}/productOrderCancellations/{id}* */
  commerceGetProductOrderCancellation: Maybe<CommerceProductOrderCancellation>
  /** *Equivalent to GET /commerce/stores/{storeId}/sales/{id}* */
  commerceGetSale: Maybe<CommerceSale>
  /** *Equivalent to GET /commerce/stores/{storeId}/sales/{saleId}/saleProducts/{id}* */
  commerceGetSaleProduct: Maybe<CommerceSaleProduct>
  /** *Equivalent to GET /commerce/stores/{id}* */
  commerceGetStore: Maybe<CommerceStore>
  /** *Equivalent to GET /commerce/stores/{storeId}/tags/{id}* */
  commerceGetTag: Maybe<CommerceTag>
  /** *Equivalent to GET /commerce/stores/{storeId}/taxes/{id}* */
  commerceGetTax: Maybe<CommerceTax>
  /** *Equivalent to GET /commerce/stores/{storeId}/taxTypes/{id}* */
  commerceGetTaxType: Maybe<CommerceTaxType>
  /** *Equivalent to GET /commerce/stores/{storeId}/vouchers/{id}* */
  commerceGetVoucher: Maybe<CommerceVoucher>
  /** *Equivalent to GET /commerce/stores/{storeId}/categories* */
  commerceListCategories: Maybe<CommercePageCategory>
  /** *Equivalent to GET /commerce/stores/{storeId}/codes* */
  commerceListCodes: Maybe<CommercePageCode>
  /** *Equivalent to GET /commerce/stores/{storeId}/orders/{orderId}/customers* */
  commerceListCustomers: Maybe<CommercePageCustomer>
  /** *Equivalent to GET /commerce/stores/{storeId}/deals/{dealId}/dealItems* */
  commerceListDealItems: Maybe<CommercePageDealItem>
  /** *Equivalent to GET /commerce/stores/{storeId}/deals* */
  commerceListDeals: Maybe<CommercePageDeal>
  /** *Equivalent to GET /commerce/stores/{storeId}/orders* */
  commerceListOrders: Maybe<CommercePageOrder>
  /** *Equivalent to GET /commerce/stores/{storeId}/product/{productId}/packagedProducts* */
  commerceListPackagedProducts: Maybe<CommercePagePackagedProduct>
  /** *Equivalent to GET /commerce/paymentGateways* */
  commerceListPaymentGateways: Maybe<CommercePagePaymentGateway>
  /** *Equivalent to GET /commerce/stores/{storeId}/paymentMethods* */
  commerceListPaymentMethods: Maybe<CommercePagePaymentMethod>
  /** *Equivalent to GET /commerce/stores/{storeId}/products/{productId}/productOrderCancellations* */
  commerceListProductOrderCancellations: Maybe<CommercePageProductOrderCancellation>
  /** *Equivalent to GET /commerce/stores/{storeId}/products* */
  commerceListProducts: Maybe<CommercePageProduct>
  /** *Equivalent to GET /commerce/stores/{storeId}/sales/{saleId}/saleProducts* */
  commerceListSaleProducts: Maybe<CommercePageSaleProduct>
  /** *Equivalent to GET /commerce/stores/{storeId}/sales* */
  commerceListSales: Maybe<CommercePageSale>
  /**
   * *Equivalent to GET /commerce/stores*
   * # List Stores
   *
   * ...
   */
  commerceListStores: Maybe<CommercePageStore>
  /** *Equivalent to GET /commerce/stores/{storeId}/tags* */
  commerceListTags: Maybe<CommercePageTag>
  /** *Equivalent to GET /commerce/stores/{storeId}/taxTypes* */
  commerceListTaxTypes: Maybe<CommercePageTaxType>
  /** *Equivalent to GET /commerce/stores/{storeId}/taxes* */
  commerceListTaxes: Maybe<CommercePageTax>
  /** *Equivalent to GET /commerce/stores/{storeId}/vouchers* */
  commerceListVouchers: Maybe<CommercePageVoucher>
  /** @deprecated As we consider more to develop more generic APIs, the term "event" is preferrable to "conference". */
  conference: Maybe<Conference>
  /** Retrieves all countries. */
  countries: EventConfigurationCountryConnection
  /** *Equivalent to GET /email/adapters/{id}* */
  emailGetAdapter: Maybe<EmailAdapter>
  /** *Equivalent to GET /email/audit/{entity}/{id}* */
  emailGetAuditForTypeAndTargetAuditEntry: Maybe<Array<Maybe<EmailAuditEntry>>>
  /** *Equivalent to GET /email/audit/{entity}* */
  emailGetAuditForTypeAuditEntry: Maybe<Array<Maybe<EmailAuditEntry>>>
  /** *Equivalent to GET /email/collections/{id}* */
  emailGetCollection: Maybe<EmailCollection>
  /** *Equivalent to GET /email/collections/{collectionId}/messages/{id}* */
  emailGetMessage: Maybe<EmailMessage>
  /** *Equivalent to GET /email/collections/{collectionId}/templates/{id}* */
  emailGetTemplate: Maybe<EmailTemplate>
  /** *Equivalent to GET /email/adapters* */
  emailListAdapters: Maybe<EmailPageAdapter>
  /** *Equivalent to GET /email/collections* */
  emailListCollections: Maybe<EmailPageCollection>
  /** *Equivalent to GET /email/collections/{collectionId}/messages* */
  emailListMessages: Maybe<EmailPageMessage>
  /** *Equivalent to GET /email/collections/{collectionId}/templates* */
  emailListTemplates: Maybe<EmailPageTemplate>
  /**
   * Returns an event by slug.
   * X-EVENT-ID http header is used when the slug argument is not provided on the query.
   */
  event: Maybe<Event>
  /**
   * Retrieves events sorted by start_date in descending order.
   * All events are returned unless the filter is applied.
   */
  events: EventConnection
  formAttendeeProfileUpdate: Maybe<DynamicForm>
  investorSession: Maybe<InvestorSession>
  investorSessions: Maybe<InvestorSessionConnection>
  /** Retrieves all legal_entities. */
  legalEntities: LegalEntityConnection
  /** Returns a legal_entity by id. */
  legalEntity: LegalEntity
  me: Maybe<User>
  /** Look up a campaign. */
  notificationCampaign: Maybe<NotificationCampaign>
  /** Look up campaigns. */
  notificationCampaigns: Maybe<NotificationCampaignConnection>
  /** The user's notifications. */
  notifications: Maybe<Notifications>
  /** Retrieves an order by the booking reference. ex: "xdbaWXXtqN" */
  order: Maybe<Order>
  /**
   * Retrieves all orders.
   * Can be filtered by:
   *   - `filter`
   *   - `search_query`
   */
  orders: OrderConnection
  product: Maybe<Products>
  productBenefit: Maybe<ProductBenefits>
  productBenefits: Maybe<Array<Maybe<ProductBenefits>>>
  productBenefitsConnection: Maybe<ProductBenefitsConnection>
  products: Maybe<Array<Maybe<Products>>>
  productsConnection: Maybe<ProductsConnection>
  room: Maybe<Room>
  scheduleTimeslot: Maybe<ScheduleTimeslot>
  site: Maybe<Site>
  sites: Maybe<Array<Maybe<Site>>>
  sitesConnection: Maybe<SiteConnection>
  taAddOn: Maybe<TaAddOn>
  taAddOnTypes: TaAddOnTypeConnection
  taAddOns: TaAddOnConnection
  /** Retrieves an event */
  taEvent: Maybe<TaEvent>
  /** Retrieves features flags */
  taFeatures: Maybe<Array<TaFeature>>
  taTicketUpgrade: Maybe<TaTicketUpgrade>
  taTicketUpgradeTypes: TaTicketUpgradeTypeConnection
  taTicketUpgrades: Maybe<TaTicketUpgradeConnection>
  /** Retrieves a ticket by the booking reference. ex: "MVSD-1" */
  ticket: Maybe<Ticket>
  ticketType: Maybe<TicketType>
  ticketTypes: TicketTypeConnection
  /**
   * Retrieves all the tickets.
   * Can be filtered by:
   *   - `order_id`
   *   - `filter`
   *   - `search_query`
   */
  tickets: TicketConnection
  /** Retrieves all time zones */
  timeZones: TimeZoneConnection
  topics: TopicConnection
  webPageByHostPath: Maybe<WebPage>
  webPageByPath: Maybe<WebPage>
  webPageConfig: Maybe<WebPageConfig>
  webPageConfigByPathHost: Maybe<WebPageConfig>
  webPageConfigs: Maybe<Array<Maybe<WebPageConfig>>>
  webPageConfigsConnection: Maybe<WebPageConfigConnection>
  webPagesByHostMenuLabel: Maybe<Array<Maybe<WebPage>>>
  /** *Equivalent to GET /webhooks/audit/{entity}/{id}* */
  webhooksGetAuditForTypeAndTargetAuditEntry: Maybe<Array<Maybe<WebhooksAuditEntry>>>
  /** *Equivalent to GET /webhooks/audit/{entity}* */
  webhooksGetAuditForTypeAuditEntry: Maybe<Array<Maybe<WebhooksAuditEntry>>>
  /** *Equivalent to GET /webhooks/executions/{id}* */
  webhooksGetExecution: Maybe<WebhooksExecution>
  /** *Equivalent to GET /webhooks/messages/{id}* */
  webhooksGetMessage: Maybe<WebhooksMessage>
  /** *Equivalent to GET /webhooks/targets/{id}* */
  webhooksGetTarget: Maybe<WebhooksTarget>
  /** *Equivalent to GET /webhooks/executions* */
  webhooksListExecutions: Maybe<WebhooksPageExecution>
  /** *Equivalent to GET /webhooks/messages* */
  webhooksListMessages: Maybe<WebhooksPageMessage>
  /** *Equivalent to GET /webhooks/targets* */
  webhooksListTargets: Maybe<WebhooksPageTarget>
  /** *Equivalent to GET /webhooks/topics* */
  webhooksListTopics: Maybe<WebhooksPageTopic>
}

export type QueryAdminAttendeeProfileArgs = {
  email: Scalars['String']
}

export type QueryAppearanceArgs = {
  id: Scalars['ID']
}

export type QueryAppearancesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
}

export type QueryAssignmentProfileArgs = {
  ticketId: Scalars['ID']
}

export type QueryAssignmentUserArgs = {
  email?: Maybe<Scalars['String']>
}

export type QueryAttendanceArgs = {
  id: Scalars['ID']
}

export type QueryAttendanceAppearanceSelectionArgs = {
  id: Scalars['ID']
}

export type QueryAttendancesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<AttendanceFilter>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  searchQuery?: Maybe<Scalars['String']>
}

export type QueryAuthGenerateTokenUserArgs = {
  expiring?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
}

export type QueryAuthGetAuditForTypeAndTargetAuditEntryArgs = {
  entity: Scalars['String']
  id: Scalars['ID']
}

export type QueryAuthGetAuditForTypeAuditEntryArgs = {
  entity: Scalars['String']
}

export type QueryAuthGetOauthArgs = {
  id: Scalars['ID']
}

export type QueryAuthGetRoleArgs = {
  id: Scalars['ID']
}

export type QueryAuthGetUserArgs = {
  id: Scalars['ID']
}

export type QueryAuthGetUserFromTokenArgs = {
  jwt: Scalars['String']
}

export type QueryAuthListOauthsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<AuthSortTerm>>
  terms?: Maybe<Array<Maybe<Array<AuthSearchTerm>>>>
}

export type QueryAuthListRolesArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<AuthSortTerm>>
  terms?: Maybe<Array<Maybe<Array<AuthSearchTerm>>>>
}

export type QueryAuthListUsersArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<AuthSortTerm>>
  terms?: Maybe<Array<Maybe<Array<AuthSearchTerm>>>>
}

export type QueryAuthRenewTokenArgs = {
  jwt: Scalars['String']
}

export type QueryAuthVerifyEmailAdminUserArgs = {
  id: Scalars['ID']
}

export type QueryAuthVerifyPermissionArgs = {
  jwt: Scalars['String']
  permission: Scalars['String']
}

export type QueryAuthVerifyPermissionUserArgs = {
  id: Scalars['ID']
  permission: Scalars['String']
}

export type QueryBookingArgs = {
  reference: Scalars['String']
}

export type QueryBookingsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<BookingFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  searchQuery?: Maybe<Scalars['String']>
}

export type QueryBrandingArgs = {
  id: Scalars['ID']
}

export type QueryBrandingBySlugArgs = {
  slug: Scalars['String']
}

export type QueryBrandingsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryBrandingsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryChatChannelArgs = {
  id?: Maybe<Scalars['ID']>
  providerId?: Maybe<Scalars['ID']>
}

export type QueryChatChannelsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  includeEmpty?: Maybe<Scalars['Boolean']>
  last?: Maybe<Scalars['Int']>
  provider: ChatProvider
  providerIds?: Maybe<Array<Scalars['ID']>>
}

export type QueryCommerceGetAuditForTypeAndTargetAuditEntryArgs = {
  entity: Scalars['String']
  id: Scalars['ID']
}

export type QueryCommerceGetAuditForTypeAuditEntryArgs = {
  entity: Scalars['String']
}

export type QueryCommerceGetCategoryArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetCodeArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetCustomerArgs = {
  id: Scalars['ID']
  orderId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetDealArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetDealItemArgs = {
  dealId: Scalars['ID']
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetOrderArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetPackagedProductArgs = {
  id: Scalars['ID']
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetPaymentGatewayArgs = {
  bool?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
}

export type QueryCommerceGetPaymentMethodArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetProductArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetProductOrderCancellationArgs = {
  id: Scalars['ID']
  productId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetSaleArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetSaleProductArgs = {
  id: Scalars['ID']
  saleId: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetStoreArgs = {
  bool?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
}

export type QueryCommerceGetTagArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetTaxArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetTaxTypeArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceGetVoucherArgs = {
  id: Scalars['ID']
  storeId?: Maybe<Scalars['ID']>
  validateOrder?: Maybe<Scalars['Boolean']>
}

export type QueryCommerceListCategoriesArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListCodesArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListCustomersArgs = {
  orderId: Scalars['ID']
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListDealItemsArgs = {
  dealId: Scalars['ID']
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListDealsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListOrdersArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListPackagedProductsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  productId: Scalars['ID']
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListPaymentGatewaysArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  terms?: Maybe<Array<CommerceSearchTerm>>
}

export type QueryCommerceListPaymentMethodsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListProductOrderCancellationsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  productId: Scalars['ID']
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListProductsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListSaleProductsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  saleId: Scalars['ID']
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListSalesArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListStoresArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListTagsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListTaxTypesArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListTaxesArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryCommerceListVouchersArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  storeId?: Maybe<Scalars['ID']>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}

export type QueryConferenceArgs = {
  id?: Maybe<Scalars['ID']>
  slug?: Maybe<Scalars['ID']>
}

export type QueryCountriesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryEmailGetAdapterArgs = {
  id: Scalars['ID']
}

export type QueryEmailGetAuditForTypeAndTargetAuditEntryArgs = {
  entity: Scalars['String']
  id: Scalars['ID']
}

export type QueryEmailGetAuditForTypeAuditEntryArgs = {
  entity: Scalars['String']
}

export type QueryEmailGetCollectionArgs = {
  id: Scalars['ID']
}

export type QueryEmailGetMessageArgs = {
  collectionId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
}

export type QueryEmailGetTemplateArgs = {
  collectionId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
}

export type QueryEmailListAdaptersArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<EmailSortTerm>>
  terms?: Maybe<Array<Maybe<Array<EmailSearchTerm>>>>
}

export type QueryEmailListCollectionsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<EmailSortTerm>>
  terms?: Maybe<Array<Maybe<Array<EmailSearchTerm>>>>
}

export type QueryEmailListMessagesArgs = {
  collectionId?: Maybe<Scalars['ID']>
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<EmailSortTerm>>
  terms?: Maybe<Array<Maybe<Array<EmailSearchTerm>>>>
}

export type QueryEmailListTemplatesArgs = {
  collectionId?: Maybe<Scalars['ID']>
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<EmailSortTerm>>
  terms?: Maybe<Array<Maybe<Array<EmailSearchTerm>>>>
}

export type QueryEventArgs = {
  slug?: Maybe<Scalars['String']>
}

export type QueryEventsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<EventFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryInvestorSessionArgs = {
  id: Scalars['ID']
}

export type QueryInvestorSessionsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryLegalEntitiesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryLegalEntityArgs = {
  id: Scalars['ID']
}

export type QueryNotificationCampaignArgs = {
  id: Scalars['ID']
}

export type QueryNotificationCampaignsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryOrderArgs = {
  reference: Scalars['String']
}

export type QueryOrdersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<OrderFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  searchQuery?: Maybe<Scalars['String']>
}

export type QueryProductArgs = {
  id: Scalars['ID']
}

export type QueryProductBenefitArgs = {
  id: Scalars['ID']
}

export type QueryProductBenefitsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryProductBenefitsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryProductsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryProductsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryRoomArgs = {
  id: Scalars['ID']
}

export type QueryScheduleTimeslotArgs = {
  id?: Maybe<Scalars['ID']>
  slug?: Maybe<Scalars['String']>
}

export type QuerySiteArgs = {
  id: Scalars['ID']
}

export type QuerySitesArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QuerySitesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryTaAddOnArgs = {
  id: Scalars['ID']
}

export type QueryTaAddOnTypesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryTaAddOnsArgs = {
  addOnTypeIds?: Maybe<Array<Scalars['ID']>>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  state?: Maybe<AddOnState>
}

export type QueryTaEventArgs = {
  slug: Scalars['String']
}

export type QueryTaTicketUpgradeArgs = {
  id: Scalars['ID']
}

export type QueryTaTicketUpgradeTypesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryTaTicketUpgradesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  ticketUpgradeTypeIds?: Maybe<Array<Scalars['ID']>>
}

export type QueryTicketArgs = {
  reference: Scalars['String']
}

export type QueryTicketTypeArgs = {
  id: Scalars['ID']
}

export type QueryTicketTypesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryTicketsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  bookingId?: Maybe<Scalars['ID']>
  filter?: Maybe<TicketFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderId?: Maybe<Scalars['ID']>
  searchQuery?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<TicketSorter>>
}

export type QueryTimeZonesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryTopicsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryWebPageByHostPathArgs = {
  host: Scalars['String']
  path: Scalars['String']
  slug?: Maybe<Scalars['String']>
}

export type QueryWebPageByPathArgs = {
  path: Scalars['String']
}

export type QueryWebPageConfigArgs = {
  id: Scalars['ID']
}

export type QueryWebPageConfigByPathHostArgs = {
  host: Scalars['String']
  path: Scalars['String']
  slug?: Maybe<Scalars['String']>
}

export type QueryWebPageConfigsArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryWebPageConfigsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>
  sort?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['Int']>
  where?: Maybe<Scalars['JSON']>
}

export type QueryWebPagesByHostMenuLabelArgs = {
  host: Scalars['String']
  menuLabel: Scalars['String']
}

export type QueryWebhooksGetAuditForTypeAndTargetAuditEntryArgs = {
  entity: Scalars['String']
  id: Scalars['ID']
}

export type QueryWebhooksGetAuditForTypeAuditEntryArgs = {
  entity: Scalars['String']
}

export type QueryWebhooksGetExecutionArgs = {
  id: Scalars['ID']
}

export type QueryWebhooksGetMessageArgs = {
  id: Scalars['ID']
}

export type QueryWebhooksGetTargetArgs = {
  id: Scalars['ID']
}

export type QueryWebhooksListExecutionsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<WebhooksSortTerm>>
  terms?: Maybe<Array<Maybe<Array<WebhooksSearchTerm>>>>
}

export type QueryWebhooksListMessagesArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<WebhooksSortTerm>>
  terms?: Maybe<Array<Maybe<Array<WebhooksSearchTerm>>>>
}

export type QueryWebhooksListTargetsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<WebhooksSortTerm>>
  terms?: Maybe<Array<Maybe<Array<WebhooksSearchTerm>>>>
}

export type QueryWebhooksListTopicsArgs = {
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<WebhooksSortTerm>>
  terms?: Maybe<Array<Maybe<Array<WebhooksSearchTerm>>>>
}

export type Rejected = {
  __typename?: 'Rejected'
  count: Scalars['Int']
}

/** Autogenerated input type of RepublishTicketAccept */
export type RepublishTicketAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  reference: Scalars['String']
}

/** Autogenerated return type of RepublishTicketAccept. */
export type RepublishTicketAcceptPayload = {
  __typename?: 'RepublishTicketAcceptPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

export type Room = {
  __typename?: 'Room'
  features: Maybe<RoomFeatureConfig>
  id: Scalars['ID']
  timeslot: Maybe<ScheduleTimeslot>
  title: Scalars['String']
  track: Maybe<ScheduleTrack>
}

export type RoomChatConfig = {
  allowedDomains: Array<Scalars['String']>
}

export type RoomChatConfigPubnub = RoomChatConfig &
  RoomPubnubConfig & {
    __typename?: 'RoomChatConfigPubnub'
    allowedDomains: Array<Scalars['String']>
    authKey: Scalars['String']
    channel: Scalars['String']
    publishKey: Scalars['String']
    subscribeKey: Scalars['String']
  }

export type RoomConfig = {
  __typename?: 'RoomConfig'
  backstageEnabled: Scalars['Boolean']
  chat: Maybe<RoomChatConfig>
  contentLiveStream: Maybe<RoomStreamConfig>
  heartbeatInterval: Scalars['Int']
  moderation: RoomModerationConfig
  questions: Maybe<RoomQuestionsConfig>
  reactions: Maybe<RoomReactionsConfig>
  videoCall: Maybe<RoomVideoCallConfig>
  videoCallLiveStream: Maybe<RoomStreamConfig>
}

export type RoomFeatureConfig = {
  __typename?: 'RoomFeatureConfig'
  backstageEnabled: Scalars['Boolean']
  chatEnabled: Scalars['Boolean']
  questionsEnabled: Scalars['Boolean']
  reactionsEnabled: Scalars['Boolean']
  videoCallEnabled: Scalars['Boolean']
}

export type RoomGrant = {
  __typename?: 'RoomGrant'
  config: RoomConfig
  id: Scalars['ID']
  permissions: RoomPermissions
  role: RoomRole
  room: Room
}

/** Specifies the room to join. Exactly one of the fields must be set. */
export type RoomJoinInput = {
  /** The ID of the corresponding calendar event. */
  calendarEventId?: Maybe<Scalars['ID']>
  /** Deprecated. Use trackId instead. */
  locationId?: Maybe<Scalars['ID']>
  /** The ID of the room. */
  roomId?: Maybe<Scalars['ID']>
  /** The ID of the corresponding timeslot. */
  timeslotId?: Maybe<Scalars['ID']>
  /** The ID of the corresponding schedule track. */
  trackId?: Maybe<Scalars['ID']>
}

export type RoomModerationConfig = RoomModerationConfigPubnub

export type RoomModerationConfigPubnub = RoomPubnubConfig & {
  __typename?: 'RoomModerationConfigPubnub'
  authKey: Scalars['String']
  channel: Scalars['String']
  publishKey: Scalars['String']
  subscribeKey: Scalars['String']
}

export type RoomPermissions = {
  __typename?: 'RoomPermissions'
  changeMode: Scalars['Boolean']
  deleteChatMessage: Scalars['Boolean']
  kickUser: Scalars['Boolean']
  pinChatMessage: Scalars['Boolean']
  publishVideo: Scalars['Boolean']
  readQuestions: Scalars['Boolean']
  toggleParticipantAudio: Scalars['Boolean']
  toggleParticipantVideo: Scalars['Boolean']
  viewBackstage: Scalars['Boolean']
}

export type RoomPubnubConfig = {
  authKey: Scalars['String']
  channel: Scalars['String']
  publishKey: Scalars['String']
  subscribeKey: Scalars['String']
}

export type RoomQuestionsConfig = RoomQuestionsConfigPubnub

export type RoomQuestionsConfigPubnub = RoomPubnubConfig & {
  __typename?: 'RoomQuestionsConfigPubnub'
  authKey: Scalars['String']
  channel: Scalars['String']
  publishKey: Scalars['String']
  subscribeKey: Scalars['String']
}

export enum RoomReaction {
  Canada = 'CANADA',
  Clap = 'CLAP',
  Fire = 'FIRE',
  Heart = 'HEART',
  Laugh = 'LAUGH',
  NotOk = 'NOT_OK',
  Ok = 'OK',
  Portugal = 'PORTUGAL',
  Tomato = 'TOMATO',
}

export type RoomReactionsConfig = {
  enabled: Array<RoomReaction>
}

export type RoomReactionsConfigPubnub = RoomPubnubConfig &
  RoomReactionsConfig & {
    __typename?: 'RoomReactionsConfigPubnub'
    authKey: Scalars['String']
    channel: Scalars['String']
    enabled: Array<RoomReaction>
    publishKey: Scalars['String']
    subscribeKey: Scalars['String']
  }

export enum RoomRole {
  Moderator = 'MODERATOR',
  Participant = 'PARTICIPANT',
  Spectator = 'SPECTATOR',
}

export type RoomStreamConfig = {
  __typename?: 'RoomStreamConfig'
  gatepassUrl: Maybe<Scalars['String']>
  hlsUrl: Maybe<Scalars['String']>
  iframeUrl: Maybe<Scalars['String']>
}

export type RoomUpdateFeaturesInput = {
  backstageEnabled?: Maybe<Scalars['Boolean']>
  chatEnabled?: Maybe<Scalars['Boolean']>
  questionsEnabled?: Maybe<Scalars['Boolean']>
  reactionsEnabled?: Maybe<Scalars['Boolean']>
  videoCallEnabled?: Maybe<Scalars['Boolean']>
}

export type RoomVideoCallConfig = RoomVideoCallConfigVonage

export type RoomVideoCallConfigVonage = {
  __typename?: 'RoomVideoCallConfigVonage'
  apiKey: Scalars['String']
  sessionId: Scalars['String']
  token: Scalars['String']
}

export type ScheduleFormat = {
  __typename?: 'ScheduleFormat'
  id: Scalars['ID']
  label: Scalars['String']
}

export type ScheduleTimeslot = {
  __typename?: 'ScheduleTimeslot'
  archivable: Scalars['Boolean']
  calendarEventId: Maybe<Scalars['String']>
  channelUrl: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  endsAt: Maybe<Scalars['ISO8601DateTime']>
  format: Maybe<ScheduleFormat>
  gatepassUrl: Maybe<Scalars['String']>
  id: Scalars['ID']
  location: Maybe<Location>
  onlineSession: Scalars['Boolean']
  participants: AttendeeConnection
  premium: Scalars['Boolean']
  slug: Maybe<Scalars['String']>
  sponsor: Maybe<Appearance>
  startsAt: Maybe<Scalars['ISO8601DateTime']>
  title: Scalars['String']
  topics: Array<Topic>
  track: Maybe<ScheduleTrack>
  videoFileUrl: Maybe<Scalars['String']>
  vimeoUrl: Maybe<Scalars['String']>
}

export type ScheduleTimeslotParticipantsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for ScheduleTimeslot. */
export type ScheduleTimeslotConnection = {
  __typename?: 'ScheduleTimeslotConnection'
  /** A list of edges. */
  edges: Array<ScheduleTimeslotEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ScheduleTimeslotEdge = {
  __typename?: 'ScheduleTimeslotEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ScheduleTimeslot
}

export type ScheduleTimeslotParticipant = {
  __typename?: 'ScheduleTimeslotParticipant'
  attendee: Attendee
  id: Scalars['ID']
}

/** The connection type for ScheduleTimeslotParticipant. */
export type ScheduleTimeslotParticipantConnection = {
  __typename?: 'ScheduleTimeslotParticipantConnection'
  /** A list of edges. */
  edges: Array<ScheduleTimeslotParticipantEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ScheduleTimeslotParticipantEdge = {
  __typename?: 'ScheduleTimeslotParticipantEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: ScheduleTimeslotParticipant
}

export type ScheduleTrack = {
  __typename?: 'ScheduleTrack'
  gatepassUrl: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  slug: Scalars['String']
  streamSourceUrl: Maybe<Scalars['String']>
  streamable: Scalars['Boolean']
}

export enum SearchRefinementWidgetType {
  DropdownMulti = 'DROPDOWN_MULTI',
  DropdownSingle = 'DROPDOWN_SINGLE',
  Hidden = 'HIDDEN',
  LiveTalksOnly = 'LIVE_TALKS_ONLY',
  NumericSlider = 'NUMERIC_SLIDER',
  TagsMulti = 'TAGS_MULTI',
}

/** Autogenerated input type of SessionTimeslotParticipationCreate */
export type SessionTimeslotParticipationCreateInput = {
  attendanceId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  sessionTimeslotId: Scalars['ID']
}

/** Autogenerated return type of SessionTimeslotParticipationCreate */
export type SessionTimeslotParticipationCreatePayload = {
  __typename?: 'SessionTimeslotParticipationCreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  participations: Maybe<Array<Attendee>>
  successMessage: Maybe<Scalars['String']>
  userErrors: Array<UserError>
}

export type Site = {
  __typename?: 'Site'
  _id: Scalars['ID']
  createdAt: Scalars['DateTime']
  host: Scalars['String']
  id: Scalars['ID']
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type SiteAggregator = {
  __typename?: 'SiteAggregator'
  count: Maybe<Scalars['Int']>
  totalCount: Maybe<Scalars['Int']>
}

export type SiteConnection = {
  __typename?: 'SiteConnection'
  aggregate: Maybe<SiteAggregator>
  groupBy: Maybe<SiteGroupBy>
  values: Maybe<Array<Maybe<Site>>>
}

export type SiteConnectionActiveEvent = {
  __typename?: 'SiteConnectionActiveEvent'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['ID']>
}

export type SiteConnectionCreatedAt = {
  __typename?: 'SiteConnectionCreatedAt'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['DateTime']>
}

export type SiteConnectionCreated_By = {
  __typename?: 'SiteConnectionCreated_by'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['ID']>
}

export type SiteConnectionHost = {
  __typename?: 'SiteConnectionHost'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['String']>
}

export type SiteConnectionId = {
  __typename?: 'SiteConnectionId'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['ID']>
}

export type SiteConnectionTitle = {
  __typename?: 'SiteConnectionTitle'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['String']>
}

export type SiteConnectionUpdatedAt = {
  __typename?: 'SiteConnectionUpdatedAt'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['DateTime']>
}

export type SiteConnectionUpdated_By = {
  __typename?: 'SiteConnectionUpdated_by'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['ID']>
}

export type SiteConnection_Id = {
  __typename?: 'SiteConnection_id'
  connection: Maybe<SiteConnection>
  key: Maybe<Scalars['ID']>
}

export type SiteGroupBy = {
  __typename?: 'SiteGroupBy'
  _id: Maybe<Array<Maybe<SiteConnection_Id>>>
  activeEvent: Maybe<Array<Maybe<SiteConnectionActiveEvent>>>
  createdAt: Maybe<Array<Maybe<SiteConnectionCreatedAt>>>
  created_by: Maybe<Array<Maybe<SiteConnectionCreated_By>>>
  host: Maybe<Array<Maybe<SiteConnectionHost>>>
  id: Maybe<Array<Maybe<SiteConnectionId>>>
  title: Maybe<Array<Maybe<SiteConnectionTitle>>>
  updatedAt: Maybe<Array<Maybe<SiteConnectionUpdatedAt>>>
  updated_by: Maybe<Array<Maybe<SiteConnectionUpdated_By>>>
}

export type SiteInput = {
  activeEvent?: Maybe<Scalars['ID']>
  created_by?: Maybe<Scalars['ID']>
  events?: Maybe<Array<Scalars['ID']>>
  host: Scalars['String']
  menus?: Maybe<Array<Scalars['ID']>>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
  webPages?: Maybe<Array<Scalars['ID']>>
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type TaAddOn = {
  __typename?: 'TAAddOn'
  addOnType: TaAddOnType
  assignment: Maybe<TaAddOnAssignment>
  assignments: Maybe<TaAddOnAssignmentConnection>
  id: Scalars['ID']
  order: Order
  state: AddOnState
  versions: Maybe<Array<PaperTrailVersion>>
}

export type TaAddOnAssignmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type TaAddOnAssignment = {
  __typename?: 'TAAddOnAssignment'
  assignee: Maybe<AssignmentUser>
  assigner: Maybe<AssignmentUser>
  id: Scalars['ID']
  state: AddOnAssignmentState
  versions: Maybe<Array<PaperTrailVersion>>
}

/** The connection type for TAAddOnAssignment. */
export type TaAddOnAssignmentConnection = {
  __typename?: 'TAAddOnAssignmentConnection'
  /** A list of edges. */
  edges: Array<TaAddOnAssignmentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TaAddOnAssignmentEdge = {
  __typename?: 'TAAddOnAssignmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TaAddOnAssignment
}

/** The connection type for TAAddOn. */
export type TaAddOnConnection = {
  __typename?: 'TAAddOnConnection'
  /** A list of edges. */
  edges: Array<TaAddOnEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TaAddOnEdge = {
  __typename?: 'TAAddOnEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TaAddOn
}

export type TaAddOnType = {
  __typename?: 'TAAddOnType'
  applicableTicketTypes: ApplicableTicketConnection
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  sourceId: Maybe<Scalars['String']>
  versions: Maybe<Array<PaperTrailVersion>>
}

export type TaAddOnTypeApplicableTicketTypesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

/** The connection type for TAAddOnType. */
export type TaAddOnTypeConnection = {
  __typename?: 'TAAddOnTypeConnection'
  /** A list of edges. */
  edges: Array<TaAddOnTypeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TaAddOnTypeEdge = {
  __typename?: 'TAAddOnTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TaAddOnType
}

export type TaEvent = {
  __typename?: 'TAEvent'
  companySizes: Scalars['JSONSchemaForm']
  id: Scalars['ID']
  industries: Scalars['JSONSchemaForm']
  mobileAppEnabled: Scalars['Boolean']
  name: Maybe<Scalars['String']>
  passportRequired: Scalars['Boolean']
  slug: Scalars['String']
  sponsorName: Maybe<Scalars['String']>
  sponsorPrivacyPolicyUrl: Maybe<Scalars['String']>
}

/** Lists all configured features */
export type TaFeature = {
  __typename?: 'TAFeature'
  /** The key of the feature */
  name: Scalars['String']
  /** Indicates if the feature is active or not */
  state: Scalars['Boolean']
}

export type TaTicketUpgrade = {
  __typename?: 'TATicketUpgrade'
  assignment: Maybe<TaTicketUpgradeAssignment>
  assignments: Maybe<TaTicketUpgradeAssignmentConnection>
  id: Scalars['ID']
  order: Order
  state: TicketUpgradeState
  ticketUpgradeType: TaTicketUpgradeType
  versions: Maybe<Array<PaperTrailVersion>>
}

export type TaTicketUpgradeAssignmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type TaTicketUpgradeAssignment = {
  __typename?: 'TATicketUpgradeAssignment'
  assignee: Maybe<AssignmentUser>
  assigner: Maybe<AssignmentUser>
  id: Scalars['ID']
  state: TicketUpgradeAssignmentState
  versions: Maybe<Array<PaperTrailVersion>>
}

/** The connection type for TATicketUpgradeAssignment. */
export type TaTicketUpgradeAssignmentConnection = {
  __typename?: 'TATicketUpgradeAssignmentConnection'
  /** A list of edges. */
  edges: Array<TaTicketUpgradeAssignmentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TaTicketUpgradeAssignmentEdge = {
  __typename?: 'TATicketUpgradeAssignmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TaTicketUpgradeAssignment
}

/** The connection type for TATicketUpgrade. */
export type TaTicketUpgradeConnection = {
  __typename?: 'TATicketUpgradeConnection'
  /** A list of edges. */
  edges: Array<TaTicketUpgradeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TaTicketUpgradeEdge = {
  __typename?: 'TATicketUpgradeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TaTicketUpgrade
}

export type TaTicketUpgradeType = {
  __typename?: 'TATicketUpgradeType'
  applicableTicketTypes: ApplicableTicketConnection
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  upgradeTicketType: TicketType
  versions: Maybe<Array<PaperTrailVersion>>
}

export type TaTicketUpgradeTypeApplicableTicketTypesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

/** The connection type for TATicketUpgradeType. */
export type TaTicketUpgradeTypeConnection = {
  __typename?: 'TATicketUpgradeTypeConnection'
  /** A list of edges. */
  edges: Array<TaTicketUpgradeTypeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TaTicketUpgradeTypeEdge = {
  __typename?: 'TATicketUpgradeTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TaTicketUpgradeType
}

export type Ticket = {
  __typename?: 'Ticket'
  acceptedAddOns: TaAddOnConnection
  acceptedTicketUpgrades: TaTicketUpgradeConnection
  assignment: Maybe<Assignment>
  assignments: Maybe<AssignmentConnection>
  bookingRef: Scalars['String']
  checkInDetails: Maybe<CheckInDetails>
  context: TicketContext
  id: Scalars['ID']
  lockedAt: Maybe<Scalars['ISO8601DateTime']>
  order: Order
  state: TicketState
  ticketType: Maybe<TicketType>
  ticketTypeModified: Scalars['Boolean']
  versions: Maybe<Array<PaperTrailVersion>>
}

export type TicketAcceptedAddOnsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type TicketAcceptedTicketUpgradesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type TicketAssignmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of TicketAccept */
export type TicketAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ticketId: Scalars['ID']
}

/** Autogenerated return type of TicketAccept. */
export type TicketAcceptPayload = {
  __typename?: 'TicketAcceptPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketAssign */
export type TicketAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName?: Maybe<Scalars['String']>
  notify?: Maybe<Scalars['Boolean']>
  ticketId: Scalars['ID']
  transferAddOns?: Maybe<Scalars['Boolean']>
  transferUpgrades?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of TicketAssign. */
export type TicketAssignPayload = {
  __typename?: 'TicketAssignPayload'
  assignment: Maybe<Assignment>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

export type TicketAttributes = {
  assignee?: Maybe<AccountAttributes>
  reference: Scalars['String']
  typeId: Scalars['ID']
  void?: Maybe<Scalars['Boolean']>
}

/** The connection type for Ticket. */
export type TicketConnection = {
  __typename?: 'TicketConnection'
  /** A list of edges. */
  edges: Array<TicketEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type TicketContext = {
  __typename?: 'TicketContext'
  acceptable: Scalars['Boolean']
  assignable: Scalars['Boolean']
  editable: Scalars['Boolean']
  rejectable: Scalars['Boolean']
}

/** Autogenerated input type of TicketCreate */
export type TicketCreateInput = {
  assignee?: Maybe<AccountAttributes>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  orderReference: Scalars['String']
  reference: Scalars['String']
  typeId: Scalars['ID']
  void?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of TicketCreate. */
export type TicketCreatePayload = {
  __typename?: 'TicketCreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

/** An edge in a connection. */
export type TicketEdge = {
  __typename?: 'TicketEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Ticket
}

export type TicketFilter = {
  addOnTypeIds?: Maybe<Array<Scalars['ID']>>
  assignment?: Maybe<TicketFilterAssignment>
  status?: Maybe<TicketFilterStatus>
  ticketTypeIds?: Maybe<Array<Scalars['ID']>>
  ticketUpgradeTypeIds?: Maybe<Array<Scalars['ID']>>
}

export enum TicketFilterAssignment {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
}

export enum TicketFilterStatus {
  Accepted = 'ACCEPTED',
  Assigned = 'ASSIGNED',
  CheckedIn = 'CHECKED_IN',
  Duplicate = 'DUPLICATE',
  Locked = 'LOCKED',
  Rejected = 'REJECTED',
  Unassigned = 'UNASSIGNED',
  Void = 'VOID',
}

/** Autogenerated input type of TicketLock */
export type TicketLockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  reference: Scalars['String']
}

/** Autogenerated return type of TicketLock. */
export type TicketLockPayload = {
  __typename?: 'TicketLockPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

export enum TicketPromotionType {
  Annotation = 'ANNOTATION',
  Highlight = 'HIGHLIGHT',
}

/** Autogenerated input type of TicketReject */
export type TicketRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  notify?: Maybe<Scalars['Boolean']>
  ticketId: Scalars['ID']
}

/** Autogenerated return type of TicketReject. */
export type TicketRejectPayload = {
  __typename?: 'TicketRejectPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketSetLeadScanning */
export type TicketSetLeadScanningInput = {
  active: Scalars['Boolean']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  reference: Scalars['String']
}

/** Autogenerated return type of TicketSetLeadScanning. */
export type TicketSetLeadScanningPayload = {
  __typename?: 'TicketSetLeadScanningPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  status: Maybe<Scalars['Boolean']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

export enum TicketSortFields {
  AssigneeEmail = 'ASSIGNEE_EMAIL',
  AssigneeFirstName = 'ASSIGNEE_FIRST_NAME',
  AssigneeLastName = 'ASSIGNEE_LAST_NAME',
  TicketId = 'TICKET_ID',
  TicketReference = 'TICKET_REFERENCE',
  TicketTypeName = 'TICKET_TYPE_NAME',
}

export type TicketSorter = {
  direction?: Maybe<SortDirection>
  field?: Maybe<TicketSortFields>
}

export enum TicketState {
  Accepted = 'ACCEPTED',
  CheckedIn = 'CHECKED_IN',
  Duplicate = 'DUPLICATE',
  Locked = 'LOCKED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Unassigned = 'UNASSIGNED',
  Void = 'VOID',
}

export type TicketType = {
  __typename?: 'TicketType'
  assignmentProperties: Maybe<AssignmentProperties>
  category: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  hidden: Scalars['Boolean']
  id: Scalars['ID']
  leadScanning: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  versions: Maybe<Array<PaperTrailVersion>>
}

/** The connection type for TicketType. */
export type TicketTypeConnection = {
  __typename?: 'TicketTypeConnection'
  /** A list of edges. */
  edges: Array<TicketTypeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TicketTypeEdge = {
  __typename?: 'TicketTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TicketType
}

export type TicketTypeInfo = {
  __typename?: 'TicketTypeInfo'
  count: Scalars['Int']
  id: Scalars['ID']
  name: Scalars['String']
}

/** Autogenerated input type of TicketUnlock */
export type TicketUnlockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  reference: Scalars['String']
}

/** Autogenerated return type of TicketUnlock. */
export type TicketUnlockPayload = {
  __typename?: 'TicketUnlockPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketUnvoid */
export type TicketUnvoidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  disableEmailNotification?: Maybe<Scalars['Boolean']>
  reference: Scalars['String']
}

/** Autogenerated return type of TicketUnvoid. */
export type TicketUnvoidPayload = {
  __typename?: 'TicketUnvoidPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketUpdate */
export type TicketUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  reference: Scalars['String']
  typeId: Scalars['ID']
}

/** Autogenerated return type of TicketUpdate. */
export type TicketUpdatePayload = {
  __typename?: 'TicketUpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketUpgradeAssign */
export type TicketUpgradeAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName?: Maybe<Scalars['String']>
  ticketUpgradeId: Scalars['ID']
}

/** Autogenerated return type of TicketUpgradeAssign. */
export type TicketUpgradeAssignPayload = {
  __typename?: 'TicketUpgradeAssignPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticketUpgrade: Maybe<TaTicketUpgrade>
  userErrors: Array<UserError>
}

export enum TicketUpgradeAssignmentState {
  Accepted = 'ACCEPTED',
  Unaccepted = 'UNACCEPTED',
}

export enum TicketUpgradeState {
  Accepted = 'ACCEPTED',
  Locked = 'LOCKED',
  Unaccepted = 'UNACCEPTED',
  Unassigned = 'UNASSIGNED',
  Void = 'VOID',
}

/** Autogenerated input type of TicketUpgradeUnassign */
export type TicketUpgradeUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ticketUpgradeId: Scalars['ID']
}

/** Autogenerated return type of TicketUpgradeUnassign. */
export type TicketUpgradeUnassignPayload = {
  __typename?: 'TicketUpgradeUnassignPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticketUpgrade: Maybe<TaTicketUpgrade>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketUpgradeUnvoid */
export type TicketUpgradeUnvoidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ticketUpgradeId: Scalars['ID']
}

/** Autogenerated return type of TicketUpgradeUnvoid. */
export type TicketUpgradeUnvoidPayload = {
  __typename?: 'TicketUpgradeUnvoidPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticketUpgrade: Maybe<TaTicketUpgrade>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketUpgradeVoid */
export type TicketUpgradeVoidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ticketUpgradeId: Scalars['ID']
}

/** Autogenerated return type of TicketUpgradeVoid. */
export type TicketUpgradeVoidPayload = {
  __typename?: 'TicketUpgradeVoidPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticketUpgrade: Maybe<TaTicketUpgrade>
  userErrors: Array<UserError>
}

/** Autogenerated input type of TicketVoid */
export type TicketVoidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  disableEmailNotification?: Maybe<Scalars['Boolean']>
  reference: Scalars['String']
}

/** Autogenerated return type of TicketVoid. */
export type TicketVoidPayload = {
  __typename?: 'TicketVoidPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>
  ticket: Maybe<Ticket>
  userErrors: Array<UserError>
}

export type TicketsSummary = {
  __typename?: 'TicketsSummary'
  all: All
}

export enum TimeUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Months = 'MONTHS',
  Seconds = 'SECONDS',
  Weeks = 'WEEKS',
  Years = 'YEARS',
}

export type TimeZone = {
  __typename?: 'TimeZone'
  displayName: Scalars['String']
  ianaName: Scalars['String']
  utcOffset: Scalars['String']
}

/** The connection type for TimeZone. */
export type TimeZoneConnection = {
  __typename?: 'TimeZoneConnection'
  /** A list of edges. */
  edges: Array<TimeZoneEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type TimeZoneEdge = {
  __typename?: 'TimeZoneEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: TimeZone
}

export type Topic = {
  __typename?: 'Topic'
  id: Scalars['ID']
  name: Scalars['String']
}

/** The connection type for Topic. */
export type TopicConnection = {
  __typename?: 'TopicConnection'
  /** A list of edges. */
  edges: Array<TopicEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type TopicEdge = {
  __typename?: 'TopicEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Topic
}

export type Unassigned = {
  __typename?: 'Unassigned'
  count: Scalars['Int']
  neverAssigned: NeverAssigned
  rejected: Rejected
}

export enum UpgradeSortFields {
  AssigneeEmail = 'ASSIGNEE_EMAIL',
  AssigneeFirstName = 'ASSIGNEE_FIRST_NAME',
  AssigneeLastName = 'ASSIGNEE_LAST_NAME',
  UpgradeTypeName = 'UPGRADE_TYPE_NAME',
}

export type UploadFile = {
  __typename?: 'UploadFile'
  _id: Scalars['ID']
  absoluteUrl: Scalars['String']
  alternativeText: Maybe<Scalars['String']>
  caption: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  ext: Maybe<Scalars['String']>
  formats: Maybe<Scalars['JSON']>
  hash: Scalars['String']
  height: Maybe<Scalars['Int']>
  id: Scalars['ID']
  mime: Scalars['String']
  name: Scalars['String']
  previewUrl: Maybe<Scalars['String']>
  provider: Scalars['String']
  provider_metadata: Maybe<Scalars['JSON']>
  size: Scalars['Float']
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
  url: Scalars['String']
  width: Maybe<Scalars['Int']>
}

export type User = {
  __typename?: 'User'
  connectionLinks: ConnectionLinkConnection
  connectionRequests: ConnectionRequestConnection
  connectionStats: ConnectionStats
  contacts: AttendeeConnection
  email: Scalars['String']
  id: Scalars['ID']
  profile: Maybe<Attendee>
  registrationAddOns: Array<Scalars['String']>
  registrationArea: Maybe<Scalars['String']>
  registrationCode: Scalars['String']
}

export type UserConnectionLinksArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  entityIds?: Maybe<Array<Scalars['ID']>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  type?: Maybe<ConnectionLinkTarget>
}

export type UserConnectionRequestsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  fromIds?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  status?: Maybe<ConnectionRequestStatus>
  toIds?: Maybe<Array<Scalars['ID']>>
  type?: Maybe<ConnectionLinkTarget>
}

export type UserContactsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  provider: ContactsProvider
}

export type UserError = {
  __typename?: 'UserError'
  /** A description of the error */
  message: Scalars['String']
  /** Which input value this error came from */
  path: Maybe<Array<Scalars['String']>>
}

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload'
  ok: Scalars['Boolean']
}

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']
  password: Scalars['String']
  provider?: Maybe<Scalars['String']>
}

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']
  password: Scalars['String']
  username: Scalars['String']
}

export type Void = {
  __typename?: 'Void'
  count: Scalars['Int']
}

export type WebPage = {
  __typename?: 'WebPage'
  _id: Scalars['ID']
  content: Array<WebPageContentDynamicZone>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  path: Maybe<Scalars['String']>
  seoTags: Maybe<ComponentWebElementsSeoMetaData>
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type WebPageConfig = {
  __typename?: 'WebPageConfig'
  _id: Scalars['ID']
  baseGoogleAnalyticsTrackingId: Maybe<Scalars['String']>
  branding: Maybe<Branding>
  config: Maybe<WebPageConfig>
  createdAt: Scalars['DateTime']
  created_by: Maybe<AdminUser>
  event: Maybe<WebPageEvent>
  googleAnalyticsLinkerDomains: Array<ComponentSiteConfigGoogleAnalyticsLinkerDomainList>
  googleAnalyticsTrackingId: Maybe<Scalars['String']>
  googleOptimizeId: Maybe<Scalars['String']>
  googleTagManagerId: Maybe<Scalars['String']>
  id: Scalars['ID']
  matomoSiteId: Maybe<Scalars['String']>
  matomoTagManagerContainerId: Maybe<Scalars['String']>
  matomoUrl: Maybe<Scalars['String']>
  metaData: Maybe<ComponentSiteConfigMetaData>
  segmentId: Maybe<Scalars['String']>
  site: Maybe<Site>
  title: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updated_by: Maybe<AdminUser>
}

export type WebPageConfigAggregator = {
  __typename?: 'WebPageConfigAggregator'
  count: Maybe<Scalars['Int']>
  totalCount: Maybe<Scalars['Int']>
}

export type WebPageConfigConnection = {
  __typename?: 'WebPageConfigConnection'
  aggregate: Maybe<WebPageConfigAggregator>
  groupBy: Maybe<WebPageConfigGroupBy>
  values: Maybe<Array<Maybe<WebPageConfig>>>
}

export type WebPageConfigConnectionBaseGoogleAnalyticsTrackingId = {
  __typename?: 'WebPageConfigConnectionBaseGoogleAnalyticsTrackingId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionCreatedAt = {
  __typename?: 'WebPageConfigConnectionCreatedAt'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['DateTime']>
}

export type WebPageConfigConnectionCreated_By = {
  __typename?: 'WebPageConfigConnectionCreated_by'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['ID']>
}

export type WebPageConfigConnectionGoogleAnalyticsTrackingId = {
  __typename?: 'WebPageConfigConnectionGoogleAnalyticsTrackingId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionGoogleOptimizeId = {
  __typename?: 'WebPageConfigConnectionGoogleOptimizeId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionGoogleTagManagerId = {
  __typename?: 'WebPageConfigConnectionGoogleTagManagerId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionId = {
  __typename?: 'WebPageConfigConnectionId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['ID']>
}

export type WebPageConfigConnectionMatomoSiteId = {
  __typename?: 'WebPageConfigConnectionMatomoSiteId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionMatomoTagManagerContainerId = {
  __typename?: 'WebPageConfigConnectionMatomoTagManagerContainerId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionMatomoUrl = {
  __typename?: 'WebPageConfigConnectionMatomoUrl'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionMetaData = {
  __typename?: 'WebPageConfigConnectionMetaData'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['ID']>
}

export type WebPageConfigConnectionSegmentId = {
  __typename?: 'WebPageConfigConnectionSegmentId'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionTitle = {
  __typename?: 'WebPageConfigConnectionTitle'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['String']>
}

export type WebPageConfigConnectionUpdatedAt = {
  __typename?: 'WebPageConfigConnectionUpdatedAt'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['DateTime']>
}

export type WebPageConfigConnectionUpdated_By = {
  __typename?: 'WebPageConfigConnectionUpdated_by'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['ID']>
}

export type WebPageConfigConnection_Id = {
  __typename?: 'WebPageConfigConnection_id'
  connection: Maybe<WebPageConfigConnection>
  key: Maybe<Scalars['ID']>
}

export type WebPageConfigGroupBy = {
  __typename?: 'WebPageConfigGroupBy'
  _id: Maybe<Array<Maybe<WebPageConfigConnection_Id>>>
  baseGoogleAnalyticsTrackingId: Maybe<
    Array<Maybe<WebPageConfigConnectionBaseGoogleAnalyticsTrackingId>>
  >
  createdAt: Maybe<Array<Maybe<WebPageConfigConnectionCreatedAt>>>
  created_by: Maybe<Array<Maybe<WebPageConfigConnectionCreated_By>>>
  googleAnalyticsTrackingId: Maybe<Array<Maybe<WebPageConfigConnectionGoogleAnalyticsTrackingId>>>
  googleOptimizeId: Maybe<Array<Maybe<WebPageConfigConnectionGoogleOptimizeId>>>
  googleTagManagerId: Maybe<Array<Maybe<WebPageConfigConnectionGoogleTagManagerId>>>
  id: Maybe<Array<Maybe<WebPageConfigConnectionId>>>
  matomoSiteId: Maybe<Array<Maybe<WebPageConfigConnectionMatomoSiteId>>>
  matomoTagManagerContainerId: Maybe<
    Array<Maybe<WebPageConfigConnectionMatomoTagManagerContainerId>>
  >
  matomoUrl: Maybe<Array<Maybe<WebPageConfigConnectionMatomoUrl>>>
  metaData: Maybe<Array<Maybe<WebPageConfigConnectionMetaData>>>
  segmentId: Maybe<Array<Maybe<WebPageConfigConnectionSegmentId>>>
  title: Maybe<Array<Maybe<WebPageConfigConnectionTitle>>>
  updatedAt: Maybe<Array<Maybe<WebPageConfigConnectionUpdatedAt>>>
  updated_by: Maybe<Array<Maybe<WebPageConfigConnectionUpdated_By>>>
}

export type WebPageConfigInput = {
  baseGoogleAnalyticsTrackingId?: Maybe<Scalars['String']>
  created_by?: Maybe<Scalars['ID']>
  events?: Maybe<Array<Scalars['ID']>>
  googleAnalyticsLinkerDomains: Array<ComponentSiteConfigGoogleAnalyticsLinkerDomainListInput>
  googleAnalyticsTrackingId?: Maybe<Scalars['String']>
  googleOptimizeId?: Maybe<Scalars['String']>
  googleTagManagerId?: Maybe<Scalars['String']>
  matomoSiteId?: Maybe<Scalars['String']>
  matomoTagManagerContainerId?: Maybe<Scalars['String']>
  matomoUrl?: Maybe<Scalars['String']>
  metaData?: Maybe<ComponentSiteConfigMetaDatumInput>
  segmentId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type WebPageContentDynamicZone =
  | ComponentWebElementsAttendeeSearchSidebarFilters
  | ComponentWebElementsCompanySearchSidebarFilters
  | ComponentWebElementsFreshchat
  | ComponentWebElementsHeroSection
  | ComponentWebElementsScheduleSearchSidebarFilters
  | ComponentWebElementsShowcaseGrid
  | ComponentWebLayoutsStoresTicketApplicationsPage
  | ComponentWebLayoutsStoresTicketSalesPage
  | ComponentWebLayoutsTicketApplicationsPage
  | ComponentWebLayoutsTicketSalesPage

export type WebPageEvent = {
  __typename?: 'WebPageEvent'
  slug: Maybe<Scalars['String']>
  termsAndConditionsUrl: Maybe<Scalars['String']>
}

export type WebPageInput = {
  content: Array<Scalars['WebPageContentDynamicZoneInput']>
  created_by?: Maybe<Scalars['ID']>
  event?: Maybe<Scalars['ID']>
  path?: Maybe<Scalars['String']>
  seoTags?: Maybe<ComponentWebElementsSeoMetaDatumInput>
  site?: Maybe<Scalars['ID']>
  status?: Maybe<Enum_Webpage_Status>
  title: Scalars['String']
  updated_by?: Maybe<Scalars['ID']>
}

export type WebhooksAuditEntry = {
  __typename?: 'WebhooksAuditEntry'
  action: Maybe<WebhooksAuditEntryAction>
  by: Maybe<AuthUser>
  payload: Maybe<Scalars['JSON']>
  reason: Maybe<Scalars['String']>
  scopeId: Maybe<Scalars['ID']>
  scopeType: Maybe<Scalars['String']>
  target: Maybe<Scalars['ID']>
  timestamp: Maybe<Scalars['Date']>
  transactionId: Maybe<Scalars['ID']>
  type: Maybe<Scalars['String']>
}

export enum WebhooksAuditEntryAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Get = 'GET',
  List = 'LIST',
  NoOp = 'NO_OP',
  Update = 'UPDATE',
}

export type WebhooksExecution = {
  __typename?: 'WebhooksExecution'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  latestResponse: Maybe<Scalars['String']>
  latestStatus: Maybe<Scalars['Int']>
  message: Maybe<WebhooksMessage>
  metadata: Maybe<Scalars['JSON']>
  response: Maybe<Scalars['String']>
  retries: Maybe<Array<Maybe<WebhooksExecution>>>
  retryOf: Maybe<WebhooksExecution>
  status: Maybe<Scalars['Int']>
  target: Maybe<WebhooksTarget>
}

export type WebhooksExecutionCreate = {
  message?: Maybe<WebhooksMessageCreateOrUpdate>
  metadata?: Maybe<Scalars['JSON']>
  response?: Maybe<Scalars['String']>
  retries?: Maybe<Array<Maybe<WebhooksExecutionCreateOrUpdate>>>
  retryOf?: Maybe<WebhooksExecutionCreateOrUpdate>
  status?: Maybe<Scalars['Int']>
  target?: Maybe<WebhooksTargetCreateOrUpdate>
}

export type WebhooksExecutionCreateOrUpdate = {
  id?: Maybe<Scalars['ID']>
  message?: Maybe<WebhooksMessageCreateOrUpdate>
  metadata?: Maybe<Scalars['JSON']>
  response?: Maybe<Scalars['String']>
  retries?: Maybe<Array<Maybe<WebhooksExecutionCreateOrUpdate>>>
  retryOf?: Maybe<WebhooksExecutionCreateOrUpdate>
  status?: Maybe<Scalars['Int']>
  target?: Maybe<WebhooksTargetCreateOrUpdate>
}

export type WebhooksExecutionUpdate = {
  id?: Maybe<Scalars['ID']>
  message?: Maybe<WebhooksMessageCreateOrUpdate>
  metadata?: Maybe<Scalars['JSON']>
  response?: Maybe<Scalars['String']>
  retries?: Maybe<Array<Maybe<WebhooksExecutionCreateOrUpdate>>>
  retryOf?: Maybe<WebhooksExecutionCreateOrUpdate>
  status?: Maybe<Scalars['Int']>
  target?: Maybe<WebhooksTargetCreateOrUpdate>
}

export type WebhooksMessage = {
  __typename?: 'WebhooksMessage'
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  executions: Maybe<Array<Maybe<WebhooksExecution>>>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  payload: Scalars['JSON']
  topic: Scalars['String']
}

export type WebhooksMessageCreate = {
  executions?: Maybe<Array<Maybe<WebhooksExecutionCreateOrUpdate>>>
  metadata?: Maybe<Scalars['JSON']>
  payload: Scalars['JSON']
  topic: Scalars['String']
}

export type WebhooksMessageCreateOrUpdate = {
  executions?: Maybe<Array<Maybe<WebhooksExecutionCreateOrUpdate>>>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  payload?: Maybe<Scalars['JSON']>
  topic?: Maybe<Scalars['String']>
}

export type WebhooksMessageUpdate = {
  executions?: Maybe<Array<Maybe<WebhooksExecutionCreateOrUpdate>>>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  payload?: Maybe<Scalars['JSON']>
  topic?: Maybe<Scalars['String']>
}

export type WebhooksPageExecution = {
  __typename?: 'WebhooksPageExecution'
  content: Maybe<Array<Maybe<WebhooksExecution>>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<WebhooksPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<WebhooksSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type WebhooksPageMessage = {
  __typename?: 'WebhooksPageMessage'
  content: Maybe<Array<WebhooksMessage>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<WebhooksPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<WebhooksSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type WebhooksPageTarget = {
  __typename?: 'WebhooksPageTarget'
  content: Maybe<Array<WebhooksTarget>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<WebhooksPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<WebhooksSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type WebhooksPageTopic = {
  __typename?: 'WebhooksPageTopic'
  content: Maybe<Array<Maybe<WebhooksTopic>>>
  empty: Maybe<Scalars['Boolean']>
  first: Maybe<Scalars['Boolean']>
  last: Maybe<Scalars['Boolean']>
  number: Maybe<Scalars['Int']>
  numberOfElements: Maybe<Scalars['Int']>
  pageable: Maybe<WebhooksPageableObject>
  size: Maybe<Scalars['Int']>
  sort: Maybe<WebhooksSort>
  totalElements: Maybe<Scalars['Int']>
  totalPages: Maybe<Scalars['Int']>
}

export type WebhooksPageableObject = {
  __typename?: 'WebhooksPageableObject'
  offset: Maybe<Scalars['Int']>
  pageNumber: Maybe<Scalars['Int']>
  pageSize: Maybe<Scalars['Int']>
  paged: Maybe<Scalars['Boolean']>
  sort: Maybe<WebhooksSort>
  unpaged: Maybe<Scalars['Boolean']>
}

export type WebhooksSearchTerm = {
  field?: Maybe<Scalars['String']>
  op?: Maybe<WebhooksSearchTermOp>
  value?: Maybe<Scalars['Object']>
}

export enum WebhooksSearchTermOp {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne',
}

export type WebhooksSort = {
  __typename?: 'WebhooksSort'
  empty: Maybe<Scalars['Boolean']>
  sorted: Maybe<Scalars['Boolean']>
  unsorted: Maybe<Scalars['Boolean']>
}

export type WebhooksSortTerm = {
  direction?: Maybe<WebhooksSortTermDirection>
  field?: Maybe<Scalars['String']>
}

export enum WebhooksSortTermDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type WebhooksTarget = {
  __typename?: 'WebhooksTarget'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['Date']>
  createdBy: Maybe<AuthUser>
  id: Maybe<Scalars['ID']>
  lastUpdatedAt: Maybe<Scalars['Date']>
  lastUpdatedBy: Maybe<AuthUser>
  metadata: Maybe<Scalars['JSON']>
  name: Scalars['String']
  secret: Scalars['String']
  topic: Scalars['String']
  url: Scalars['String']
}

export type WebhooksTargetCreate = {
  active?: Maybe<Scalars['Boolean']>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  secret: Scalars['String']
  topic: Scalars['String']
  url: Scalars['String']
}

export type WebhooksTargetCreateOrUpdate = {
  active?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  secret?: Maybe<Scalars['String']>
  topic?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type WebhooksTargetUpdate = {
  active?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  secret?: Maybe<Scalars['String']>
  topic?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type WebhooksTopic = {
  __typename?: 'WebhooksTopic'
  id: Maybe<Scalars['ID']>
  route: Maybe<Scalars['String']>
}

export type CreateBrandingInput = {
  data?: Maybe<BrandingInput>
}

export type CreateBrandingPayload = {
  __typename?: 'createBrandingPayload'
  branding: Maybe<Branding>
}

export type CreateContentCollectionInput = {
  data?: Maybe<ContentCollectionInput>
}

export type CreateContentCollectionPayload = {
  __typename?: 'createContentCollectionPayload'
  contentCollection: Maybe<ContentCollection>
}

export type CreateContentElementInput = {
  data?: Maybe<ContentElementInput>
}

export type CreateContentElementPayload = {
  __typename?: 'createContentElementPayload'
  contentElement: Maybe<ContentElement>
}

export type CreateFormInput = {
  data?: Maybe<FormInput>
}

export type CreateFormPayload = {
  __typename?: 'createFormPayload'
  form: Maybe<Form>
}

export type CreateMenuInput = {
  data?: Maybe<MenuInput>
}

export type CreateMenuItemInput = {
  data?: Maybe<MenuItemInput>
}

export type CreateMenuItemPayload = {
  __typename?: 'createMenuItemPayload'
  menuItem: Maybe<MenuItem>
}

export type CreateMenuPayload = {
  __typename?: 'createMenuPayload'
  menu: Maybe<Menu>
}

export type CreateProductBenefitInput = {
  data?: Maybe<ProductBenefitInput>
}

export type CreateProductBenefitPayload = {
  __typename?: 'createProductBenefitPayload'
  productBenefit: Maybe<ProductBenefits>
}

export type CreateProductInput = {
  data?: Maybe<ProductInput>
}

export type CreateProductPayload = {
  __typename?: 'createProductPayload'
  product: Maybe<Products>
}

export type CreateSiteInput = {
  data?: Maybe<SiteInput>
}

export type CreateSitePayload = {
  __typename?: 'createSitePayload'
  site: Maybe<Site>
}

export type CreateWebPageConfigInput = {
  data?: Maybe<WebPageConfigInput>
}

export type CreateWebPageConfigPayload = {
  __typename?: 'createWebPageConfigPayload'
  webPageConfig: Maybe<WebPageConfig>
}

export type CreateWebPageInput = {
  data?: Maybe<WebPageInput>
}

export type CreateWebPagePayload = {
  __typename?: 'createWebPagePayload'
  webPage: Maybe<WebPage>
}

export type DeleteAppConfigPayload = {
  __typename?: 'deleteAppConfigPayload'
  appConfig: Maybe<AppConfig>
}

export type DeleteBrandingInput = {
  where?: Maybe<InputId>
}

export type DeleteBrandingPayload = {
  __typename?: 'deleteBrandingPayload'
  branding: Maybe<Branding>
}

export type DeleteContentCollectionInput = {
  where?: Maybe<InputId>
}

export type DeleteContentCollectionPayload = {
  __typename?: 'deleteContentCollectionPayload'
  contentCollection: Maybe<ContentCollection>
}

export type DeleteContentElementInput = {
  where?: Maybe<InputId>
}

export type DeleteContentElementPayload = {
  __typename?: 'deleteContentElementPayload'
  contentElement: Maybe<ContentElement>
}

export type DeleteFormInput = {
  where?: Maybe<InputId>
}

export type DeleteFormPayload = {
  __typename?: 'deleteFormPayload'
  form: Maybe<Form>
}

export type DeleteMenuInput = {
  where?: Maybe<InputId>
}

export type DeleteMenuItemInput = {
  where?: Maybe<InputId>
}

export type DeleteMenuItemPayload = {
  __typename?: 'deleteMenuItemPayload'
  menuItem: Maybe<MenuItem>
}

export type DeleteMenuPayload = {
  __typename?: 'deleteMenuPayload'
  menu: Maybe<Menu>
}

export type DeleteProductBenefitInput = {
  where?: Maybe<InputId>
}

export type DeleteProductBenefitPayload = {
  __typename?: 'deleteProductBenefitPayload'
  productBenefit: Maybe<ProductBenefits>
}

export type DeleteProductInput = {
  where?: Maybe<InputId>
}

export type DeleteProductPayload = {
  __typename?: 'deleteProductPayload'
  product: Maybe<Products>
}

export type DeleteSiteInput = {
  where?: Maybe<InputId>
}

export type DeleteSitePayload = {
  __typename?: 'deleteSitePayload'
  site: Maybe<Site>
}

export type DeleteWebPageConfigInput = {
  where?: Maybe<InputId>
}

export type DeleteWebPageConfigPayload = {
  __typename?: 'deleteWebPageConfigPayload'
  webPageConfig: Maybe<WebPageConfig>
}

export type DeleteWebPageInput = {
  where?: Maybe<InputId>
}

export type DeleteWebPagePayload = {
  __typename?: 'deleteWebPagePayload'
  webPage: Maybe<WebPage>
}

export type EditAppConfigInput = {
  created_by?: Maybe<Scalars['ID']>
  googleAnalyticsLinkerDomains: Array<EditComponentSiteConfigGoogleAnalyticsLinkerDomainListInput>
  googleAnalyticsTrackingId?: Maybe<Scalars['String']>
  googleFontsUrl?: Maybe<Scalars['String']>
  googleTagManagerId?: Maybe<Scalars['String']>
  matomoSiteId?: Maybe<Scalars['String']>
  matomoTagManagerContainerId?: Maybe<Scalars['String']>
  matomoUrl?: Maybe<Scalars['String']>
  metaData?: Maybe<EditComponentSiteConfigMetaDatumInput>
  segmentId?: Maybe<Scalars['String']>
  theme?: Maybe<Scalars['JSON']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditBrandingInput = {
  created_by?: Maybe<Scalars['ID']>
  events?: Maybe<Array<Scalars['ID']>>
  favicon?: Maybe<Scalars['ID']>
  googleFontsUrl?: Maybe<Scalars['String']>
  headerBranding?: Maybe<Scalars['ID']>
  invoiceFooter?: Maybe<Scalars['ID']>
  invoiceHeader?: Maybe<Scalars['ID']>
  invoiceStamp?: Maybe<Scalars['ID']>
  logo?: Maybe<Scalars['ID']>
  theme?: Maybe<Scalars['JSON']>
  ticketLogo?: Maybe<Scalars['ID']>
  title?: Maybe<Scalars['String']>
  typekitFontsUrl?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditComponentSearchAlgoliaRefinementInput = {
  attribute?: Maybe<Scalars['String']>
  defaults?: Maybe<Scalars['JSON']>
  id?: Maybe<Scalars['ID']>
  refinementItemsLimit?: Maybe<Scalars['Int']>
  title?: Maybe<Scalars['String']>
  variant?: Maybe<SearchRefinementWidgetType>
}

export type EditComponentSiteConfigGoogleAnalyticsLinkerDomainListInput = {
  domain?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
}

export type EditComponentSiteConfigMetaDatumInput = {
  facebookId?: Maybe<Scalars['String']>
  facebookPublisher?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  image?: Maybe<Scalars['ID']>
  siteDescription?: Maybe<Scalars['String']>
  siteTitle?: Maybe<Scalars['String']>
  twitterCreator?: Maybe<Scalars['String']>
  twitterId?: Maybe<Scalars['String']>
}

export type EditComponentWebElementsAttendeeSearchSidebarFilterInput = {
  apiKey?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  indexName?: Maybe<Scalars['String']>
  refinements: Array<EditComponentSearchAlgoliaRefinementInput>
}

export type EditComponentWebElementsBenefitInput = {
  benefit?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
}

export type EditComponentWebElementsCompanySearchSidebarFilterInput = {
  apiKey?: Maybe<Scalars['String']>
  conferenceId?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  indexName?: Maybe<Scalars['String']>
  refinements: Array<EditComponentSearchAlgoliaRefinementInput>
}

export type EditComponentWebElementsCtaLinkInput = {
  id?: Maybe<Scalars['ID']>
  openInNewTab?: Maybe<Scalars['Boolean']>
  text?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type EditComponentWebElementsFreshchatInput = {
  OnDesktop?: Maybe<Scalars['Boolean']>
  OnMobile?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
}

export type EditComponentWebElementsHeroSectionInput = {
  backgroundImage?: Maybe<Scalars['ID']>
  backgroundImageAlt?: Maybe<Scalars['String']>
  backgroundImageDescription?: Maybe<Scalars['String']>
  brandImage?: Maybe<Scalars['ID']>
  ctaLink?: Maybe<EditComponentWebElementsCtaLinkInput>
  id?: Maybe<Scalars['ID']>
  subtitle?: Maybe<Scalars['Markdown']>
  title?: Maybe<Scalars['String']>
  variant?: Maybe<Enum_Componentwebelementsherosection_Variant>
}

export type EditComponentWebElementsPriceIncreaseCountdownTimerInput = {
  id?: Maybe<Scalars['ID']>
  product?: Maybe<Scalars['ID']>
}

export type EditComponentWebElementsProductInput = {
  benefits?: Maybe<Array<Scalars['ID']>>
  buttonLabel?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  link?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['ID']>
  promotionColor?: Maybe<Scalars['String']>
  promotionLabel?: Maybe<Scalars['String']>
  promotionType?: Maybe<Enum_Componentwebelementsproducts_Promotiontype>
  type?: Maybe<Enum_Componentwebelementsproducts_Type>
}

export type EditComponentWebElementsReleasePhaseStepperInput = {
  id?: Maybe<Scalars['ID']>
  product?: Maybe<Scalars['ID']>
}

export type EditComponentWebElementsScheduleSearchSidebarFilterInput = {
  apiKey?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  indexName?: Maybe<Scalars['String']>
  refinements: Array<EditComponentSearchAlgoliaRefinementInput>
  timezone?: Maybe<Enum_Componentwebelementsschedulesearchsidebarfilters_Timezone>
}

export type EditComponentWebElementsSeoMetaDatumInput = {
  defaultImage?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  facebookDescription?: Maybe<Scalars['String']>
  facebookImage?: Maybe<Scalars['ID']>
  facebookTitle?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  noindex?: Maybe<Scalars['Boolean']>
  slug?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  twitterDescription?: Maybe<Scalars['String']>
  twitterImage?: Maybe<Scalars['ID']>
  twitterTitle?: Maybe<Scalars['String']>
}

export type EditComponentWebElementsShowcaseGridInput = {
  backgroundColor?: Maybe<Scalars['String']>
  contentBefore?: Maybe<Scalars['Markdown']>
  contentCollection?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
}

export type EditComponentWebElementsTicketApplicationOverviewPanelInput = {
  altImageText?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  imageUrl?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type EditComponentWebElementsTicketPromotionInput = {
  color?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  label?: Maybe<Scalars['String']>
  ticketTypeId?: Maybe<Scalars['String']>
  type?: Maybe<TicketPromotionType>
}

export type EditComponentWebElementsTicketReleasesPanelInput = {
  displayPriceIncludingTax?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
}

export type EditComponentWebElementsTicketTypeInformationInput = {
  benefits?: Maybe<Array<Scalars['ID']>>
  displayPriceIncludingTax?: Maybe<Scalars['Boolean']>
  heading?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  product?: Maybe<Scalars['ID']>
  showBenefits?: Maybe<Scalars['Boolean']>
}

export type EditComponentWebLayoutsStoresTicketApplicationsPageInput = {
  applicationForm?: Maybe<Scalars['ID']>
  applicationOverviewPanel?: Maybe<EditComponentWebElementsTicketApplicationOverviewPanelInput>
  benefits: Array<EditComponentWebElementsBenefitInput>
  categoriesMenu?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['Markdown']>
  id?: Maybe<Scalars['ID']>
  priceIncreaseCountdownTimer?: Maybe<EditComponentWebElementsPriceIncreaseCountdownTimerInput>
  releasePhaseStepper?: Maybe<EditComponentWebElementsReleasePhaseStepperInput>
  ticketInfoPanel?: Maybe<EditComponentWebElementsTicketTypeInformationInput>
  title?: Maybe<Scalars['String']>
}

export type EditComponentWebLayoutsStoresTicketSalesPageInput = {
  benefits: Array<EditComponentWebElementsBenefitInput>
  benefitsList?: Maybe<Array<Scalars['ID']>>
  categoriesMenu?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  priceIncreaseCountdownTimer?: Maybe<EditComponentWebElementsPriceIncreaseCountdownTimerInput>
  products: Array<EditComponentWebElementsProductInput>
  releasePhaseStepper?: Maybe<EditComponentWebElementsReleasePhaseStepperInput>
  ticketReleasesPanel?: Maybe<EditComponentWebElementsTicketReleasesPanelInput>
}

export type EditComponentWebLayoutsTicketApplicationsPageInput = {
  applicationForm?: Maybe<Scalars['ID']>
  applicationOverviewPanel?: Maybe<EditComponentWebElementsTicketApplicationOverviewPanelInput>
  categoriesMenu?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['Markdown']>
  id?: Maybe<Scalars['ID']>
  priceIncreaseCountdownTimer?: Maybe<EditComponentWebElementsPriceIncreaseCountdownTimerInput>
  releasePhaseStepper?: Maybe<EditComponentWebElementsReleasePhaseStepperInput>
  ticketInfoPanel?: Maybe<EditComponentWebElementsTicketTypeInformationInput>
  title?: Maybe<Scalars['String']>
}

export type EditComponentWebLayoutsTicketSalesPageInput = {
  categoriesMenu?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  priceIncreaseCountdownTimer?: Maybe<EditComponentWebElementsPriceIncreaseCountdownTimerInput>
  promotions: Array<EditComponentWebElementsTicketPromotionInput>
  releasePhaseStepper?: Maybe<EditComponentWebElementsReleasePhaseStepperInput>
  ticketCategoryId?: Maybe<Scalars['String']>
  ticketReleasesPanel?: Maybe<EditComponentWebElementsTicketReleasesPanelInput>
}

export type EditComponentWebLinksPageLinkInput = {
  id?: Maybe<Scalars['ID']>
  page?: Maybe<Scalars['ID']>
}

export type EditComponentWebLinksSubMenuInput = {
  id?: Maybe<Scalars['ID']>
  menu?: Maybe<Scalars['ID']>
}

export type EditComponentWebLinksUrlLinkInput = {
  id?: Maybe<Scalars['ID']>
  target?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type EditContentCollectionInput = {
  created_by?: Maybe<Scalars['ID']>
  elements?: Maybe<Array<Scalars['ID']>>
  name?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditContentElementInput = {
  collections?: Maybe<Array<Scalars['ID']>>
  created_by?: Maybe<Scalars['ID']>
  image?: Maybe<Scalars['ID']>
  link?: Maybe<EditComponentWebLinksUrlLinkInput>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditFileInput = {
  alternativeText?: Maybe<Scalars['String']>
  caption?: Maybe<Scalars['String']>
  created_by?: Maybe<Scalars['ID']>
  ext?: Maybe<Scalars['String']>
  formats?: Maybe<Scalars['JSON']>
  hash?: Maybe<Scalars['String']>
  height?: Maybe<Scalars['Int']>
  mime?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  previewUrl?: Maybe<Scalars['String']>
  provider?: Maybe<Scalars['String']>
  provider_metadata?: Maybe<Scalars['JSON']>
  related: Array<Scalars['ID']>
  size?: Maybe<Scalars['Float']>
  updated_by?: Maybe<Scalars['ID']>
  url?: Maybe<Scalars['String']>
  width?: Maybe<Scalars['Int']>
}

export type EditFormInput = {
  contentBefore?: Maybe<Scalars['Markdown']>
  created_by?: Maybe<Scalars['ID']>
  formAnalyticsGoal?: Maybe<Scalars['String']>
  formEventLabel?: Maybe<Scalars['String']>
  formstackId?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  submissions?: Maybe<Array<Scalars['ID']>>
  successMessage?: Maybe<Scalars['Markdown']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditMenuInput = {
  created_by?: Maybe<Scalars['ID']>
  label?: Maybe<Scalars['String']>
  menuItems?: Maybe<Array<Scalars['ID']>>
  name?: Maybe<Scalars['String']>
  site?: Maybe<Scalars['ID']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditMenuItemInput = {
  created_by?: Maybe<Scalars['ID']>
  label?: Maybe<Scalars['String']>
  link: Array<Scalars['MenuItemLinkDynamicZoneInput']>
  parentMenu?: Maybe<Scalars['ID']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditProductBenefitInput = {
  created_by?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditProductInput = {
  code?: Maybe<Scalars['String']>
  created_by?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  event?: Maybe<Scalars['ID']>
  sourceId?: Maybe<Scalars['String']>
  sourceName?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Enum_Products_Type>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditSiteInput = {
  activeEvent?: Maybe<Scalars['ID']>
  created_by?: Maybe<Scalars['ID']>
  events?: Maybe<Array<Scalars['ID']>>
  host?: Maybe<Scalars['String']>
  menus?: Maybe<Array<Scalars['ID']>>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
  webPages?: Maybe<Array<Scalars['ID']>>
}

export type EditWebPageConfigInput = {
  baseGoogleAnalyticsTrackingId?: Maybe<Scalars['String']>
  created_by?: Maybe<Scalars['ID']>
  events?: Maybe<Array<Scalars['ID']>>
  googleAnalyticsLinkerDomains: Array<EditComponentSiteConfigGoogleAnalyticsLinkerDomainListInput>
  googleAnalyticsTrackingId?: Maybe<Scalars['String']>
  googleOptimizeId?: Maybe<Scalars['String']>
  googleTagManagerId?: Maybe<Scalars['String']>
  matomoSiteId?: Maybe<Scalars['String']>
  matomoTagManagerContainerId?: Maybe<Scalars['String']>
  matomoUrl?: Maybe<Scalars['String']>
  metaData?: Maybe<EditComponentSiteConfigMetaDatumInput>
  segmentId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type EditWebPageInput = {
  content: Array<Scalars['WebPageContentDynamicZoneInput']>
  created_by?: Maybe<Scalars['ID']>
  event?: Maybe<Scalars['ID']>
  path?: Maybe<Scalars['String']>
  seoTags?: Maybe<EditComponentWebElementsSeoMetaDatumInput>
  site?: Maybe<Scalars['ID']>
  status?: Maybe<Enum_Webpage_Status>
  title?: Maybe<Scalars['String']>
  updated_by?: Maybe<Scalars['ID']>
}

export type UpdateAppConfigInput = {
  data?: Maybe<EditAppConfigInput>
}

export type UpdateAppConfigPayload = {
  __typename?: 'updateAppConfigPayload'
  appConfig: Maybe<AppConfig>
}

export type UpdateBrandingInput = {
  data?: Maybe<EditBrandingInput>
  where?: Maybe<InputId>
}

export type UpdateBrandingPayload = {
  __typename?: 'updateBrandingPayload'
  branding: Maybe<Branding>
}

export type UpdateContentCollectionInput = {
  data?: Maybe<EditContentCollectionInput>
  where?: Maybe<InputId>
}

export type UpdateContentCollectionPayload = {
  __typename?: 'updateContentCollectionPayload'
  contentCollection: Maybe<ContentCollection>
}

export type UpdateContentElementInput = {
  data?: Maybe<EditContentElementInput>
  where?: Maybe<InputId>
}

export type UpdateContentElementPayload = {
  __typename?: 'updateContentElementPayload'
  contentElement: Maybe<ContentElement>
}

export type UpdateFormInput = {
  data?: Maybe<EditFormInput>
  where?: Maybe<InputId>
}

export type UpdateFormPayload = {
  __typename?: 'updateFormPayload'
  form: Maybe<Form>
}

export type UpdateMenuInput = {
  data?: Maybe<EditMenuInput>
  where?: Maybe<InputId>
}

export type UpdateMenuItemInput = {
  data?: Maybe<EditMenuItemInput>
  where?: Maybe<InputId>
}

export type UpdateMenuItemPayload = {
  __typename?: 'updateMenuItemPayload'
  menuItem: Maybe<MenuItem>
}

export type UpdateMenuPayload = {
  __typename?: 'updateMenuPayload'
  menu: Maybe<Menu>
}

export type UpdateProductBenefitInput = {
  data?: Maybe<EditProductBenefitInput>
  where?: Maybe<InputId>
}

export type UpdateProductBenefitPayload = {
  __typename?: 'updateProductBenefitPayload'
  productBenefit: Maybe<ProductBenefits>
}

export type UpdateProductInput = {
  data?: Maybe<EditProductInput>
  where?: Maybe<InputId>
}

export type UpdateProductPayload = {
  __typename?: 'updateProductPayload'
  product: Maybe<Products>
}

export type UpdateSiteInput = {
  data?: Maybe<EditSiteInput>
  where?: Maybe<InputId>
}

export type UpdateSitePayload = {
  __typename?: 'updateSitePayload'
  site: Maybe<Site>
}

export type UpdateWebPageConfigInput = {
  data?: Maybe<EditWebPageConfigInput>
  where?: Maybe<InputId>
}

export type UpdateWebPageConfigPayload = {
  __typename?: 'updateWebPageConfigPayload'
  webPageConfig: Maybe<WebPageConfig>
}

export type UpdateWebPageInput = {
  data?: Maybe<EditWebPageInput>
  where?: Maybe<InputId>
}

export type UpdateWebPagePayload = {
  __typename?: 'updateWebPagePayload'
  webPage: Maybe<WebPage>
}

export type AddOnAssignMutationVariables = Exact<{
  input: AddOnAssignInput
}>

export type AddOnAssignMutation = { __typename?: 'Mutation' } & {
  assignmentAddOnAssign: Maybe<
    { __typename?: 'AddOnAssignPayload' } & {
      addOn: Maybe<{ __typename?: 'TAAddOn' } & Pick<TaAddOn, 'id' | 'state'>>
      userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message'>>
    }
  >
}

export type AddOnUnassignMutationVariables = Exact<{
  input: AddOnUnassignInput
}>

export type AddOnUnassignMutation = { __typename?: 'Mutation' } & {
  assignmentAddOnUnassign: Maybe<
    { __typename?: 'AddOnUnassignPayload' } & {
      addOn: Maybe<{ __typename?: 'TAAddOn' } & Pick<TaAddOn, 'id'>>
      userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message'>>
    }
  >
}

export type AssignmentAuthenticateMutationVariables = Exact<{
  input: AssignmentAuthenticateInput
}>

export type AssignmentAuthenticateMutation = { __typename?: 'Mutation' } & {
  assignmentAuthenticate: Maybe<
    { __typename?: 'AssignmentAuthenticatePayload' } & Pick<
      AssignmentAuthenticatePayload,
      'accessToken' | 'conferenceSlug' | 'clientMutationId'
    > & { userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message' | 'path'>> }
  >
}

export type ProfileUpdateMutationVariables = Exact<{
  profile: AssignmentProfileUpdateInput
}>

export type ProfileUpdateMutation = { __typename?: 'Mutation' } & {
  assignmentProfileUpdate: Maybe<
    { __typename?: 'AssignmentProfileUpdatePayload' } & Pick<
      AssignmentProfileUpdatePayload,
      'successMessage'
    > & {
        userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'path' | 'message'>>
        assignee: Maybe<
          { __typename?: 'AssignmentUser' } & Pick<
            AssignmentUser,
            | 'email'
            | 'firstName'
            | 'lastName'
            | 'jobTitle'
            | 'companyName'
            | 'companySizeId'
            | 'industryId'
            | 'phoneNumber'
            | 'city'
            | 'marketingConsent'
            | 'personalisationConsent'
            | 'partnerSharingConsent'
            | 'washingtonPostConsent'
            | 'passportNumber'
          >
        >
      }
  >
}

export type CreateOrderMutationVariables = Exact<{
  storeId?: Maybe<Scalars['ID']>
  commerceOrderCreate: CommerceOrderCreate
}>

export type CreateOrderMutation = { __typename?: 'Mutation' } & {
  commerceCreateOrder: Maybe<
    { __typename?: 'CommerceOrder' } & Pick<
      CommerceOrder,
      | 'id'
      | 'url'
      | 'reference'
      | 'currency'
      | 'invoiceUrl'
      | 'intraEU'
      | 'locked'
      | 'discountCodes'
      | 'discountTotal'
      | 'paymentStatus'
      | 'status'
      | 'valueTotal'
      | 'total'
      | 'subTotal'
      | 'taxTotal'
      | 'metadata'
    > & {
        paymentMethod: Maybe<
          { __typename?: 'CommercePaymentMethod' } & Pick<CommercePaymentMethod, 'id' | 'gateway'>
        >
        customer: Maybe<
          { __typename?: 'CommerceCustomer' } & Pick<
            CommerceCustomer,
            'id' | 'firstName' | 'lastName' | 'email' | 'vatNumber' | 'vatVerified' | 'companyName'
          > & {
              address: Maybe<
                { __typename?: 'CommerceAddress' } & Pick<
                  CommerceAddress,
                  'id' | 'line1' | 'line2' | 'city' | 'country' | 'postalCode'
                >
              >
            }
        >
        taxes: Maybe<
          Array<
            { __typename?: 'CommerceTaxSummary' } & Pick<
              CommerceTaxSummary,
              'name' | 'total' | 'rateAmount' | 'rateType'
            >
          >
        >
        codes: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommerceCode' } & Pick<CommerceCode, 'slug' | 'id' | 'type'> & {
                  deal: Maybe<
                    { __typename?: 'CommerceDeal' } & Pick<
                      CommerceDeal,
                      'active' | 'name' | 'description' | 'endDate' | 'id'
                    > & {
                        dealItems: Maybe<
                          Array<
                            { __typename?: 'CommerceDealItem' } & Pick<
                              CommerceDealItem,
                              'id' | 'min' | 'max' | 'amount' | 'step' | 'type'
                            > & {
                                product: Maybe<
                                  { __typename?: 'CommerceProduct' } & Pick<CommerceProduct, 'id'>
                                >
                              }
                          >
                        >
                      }
                  >
                  voucher: Maybe<
                    { __typename?: 'CommerceVoucher' } & Pick<
                      CommerceVoucher,
                      'active' | 'name' | 'description' | 'id'
                    >
                  >
                }
            >
          >
        >
        items: Array<
          { __typename?: 'CommerceOrderItem' } & Pick<
            CommerceOrderItem,
            'id' | 'itemName' | 'price' | 'quantity' | 'subTotal' | 'total' | 'metadata'
          > & {
              product: Maybe<
                { __typename?: 'CommerceProduct' } & Pick<
                  CommerceProduct,
                  'id' | 'onSale' | 'name' | 'taxMode' | 'metadata'
                >
              >
            }
        >
        transactions: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommerceTransaction' } & Pick<
                CommerceTransaction,
                'amount' | 'metadata' | 'status' | 'lastUpdatedAt' | 'type'
              > & {
                  paymentMethod: Maybe<
                    { __typename?: 'CommercePaymentMethod' } & Pick<CommercePaymentMethod, 'id'>
                  >
                }
            >
          >
        >
      }
  >
}

export type TicketMagicLoginLinkRequestMutationVariables = Exact<{
  input: AssignmentMagicLinkLoginRequestInput
}>

export type TicketMagicLoginLinkRequestMutation = { __typename?: 'Mutation' } & {
  assignmentMagicLinkLoginRequest: Maybe<
    { __typename?: 'AssignmentMagicLinkLoginRequestPayload' } & {
      userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message' | 'path'>>
    }
  >
}

export type TicketAcceptMutationVariables = Exact<{
  ticketId: Scalars['ID']
}>

export type TicketAcceptMutation = { __typename?: 'Mutation' } & {
  ticketAccept: Maybe<
    { __typename?: 'TicketAcceptPayload' } & {
      ticket: Maybe<
        { __typename?: 'Ticket' } & Pick<Ticket, 'id'> & {
            assignment: Maybe<{ __typename?: 'Assignment' } & Pick<Assignment, 'id' | 'state'>>
            context: { __typename?: 'TicketContext' } & Pick<
              TicketContext,
              'assignable' | 'editable' | 'acceptable' | 'rejectable'
            >
          }
      >
      userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message' | 'path'>>
    }
  >
}

export type TicketAssignMutationVariables = Exact<{
  firstName: Scalars['String']
  lastName?: Maybe<Scalars['String']>
  email: Scalars['String']
  ticketId: Scalars['ID']
}>

export type TicketAssignMutation = { __typename?: 'Mutation' } & {
  ticketAssign: Maybe<
    { __typename?: 'TicketAssignPayload' } & {
      ticket: Maybe<
        { __typename?: 'Ticket' } & Pick<Ticket, 'id'> & {
            assignment: Maybe<
              { __typename?: 'Assignment' } & Pick<Assignment, 'id' | 'state'> & {
                  assignee: Maybe<
                    { __typename?: 'AssignmentUser' } & Pick<
                      AssignmentUser,
                      'id' | 'firstName' | 'lastName' | 'email' | 'me'
                    >
                  >
                }
            >
            context: { __typename?: 'TicketContext' } & Pick<
              TicketContext,
              'assignable' | 'editable' | 'acceptable' | 'rejectable'
            >
          }
      >
      userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message' | 'path'>>
    }
  >
}

export type TicketRejectMutationVariables = Exact<{
  ticketId: Scalars['ID']
}>

export type TicketRejectMutation = { __typename?: 'Mutation' } & {
  ticketReject: Maybe<
    { __typename?: 'TicketRejectPayload' } & {
      ticket: Maybe<
        { __typename?: 'Ticket' } & Pick<Ticket, 'id'> & {
            assignment: Maybe<{ __typename?: 'Assignment' } & Pick<Assignment, 'id'>>
            context: { __typename?: 'TicketContext' } & Pick<
              TicketContext,
              'assignable' | 'editable' | 'acceptable' | 'rejectable'
            >
          }
      >
      userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message' | 'path'>>
    }
  >
}

export type TicketSetLeadScanningMutationVariables = Exact<{
  input: TicketSetLeadScanningInput
}>

export type TicketSetLeadScanningMutation = { __typename?: 'Mutation' } & {
  ticketSetLeadScanning: Maybe<
    { __typename?: 'TicketSetLeadScanningPayload' } & Pick<
      TicketSetLeadScanningPayload,
      'status'
    > & {
        ticket: Maybe<{ __typename?: 'Ticket' } & Pick<Ticket, 'id'>>
        userErrors: Array<{ __typename?: 'UserError' } & Pick<UserError, 'message'>>
      }
  >
}

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['ID']
  commerceOrderUpdate: CommerceOrderUpdate
}>

export type UpdateOrderMutation = { __typename?: 'Mutation' } & {
  commerceUpdateOrder: Maybe<
    { __typename?: 'CommerceOrder' } & Pick<
      CommerceOrder,
      | 'id'
      | 'url'
      | 'reference'
      | 'currency'
      | 'invoiceUrl'
      | 'intraEU'
      | 'locked'
      | 'discountTotal'
      | 'paymentStatus'
      | 'status'
      | 'valueTotal'
      | 'total'
      | 'subTotal'
      | 'taxTotal'
      | 'metadata'
      | 'discountCodes'
    > & {
        paymentMethod: Maybe<
          { __typename?: 'CommercePaymentMethod' } & Pick<CommercePaymentMethod, 'id' | 'gateway'>
        >
        customer: Maybe<
          { __typename?: 'CommerceCustomer' } & Pick<
            CommerceCustomer,
            'id' | 'firstName' | 'lastName' | 'email' | 'vatNumber' | 'vatVerified' | 'companyName'
          > & {
              address: Maybe<
                { __typename?: 'CommerceAddress' } & Pick<
                  CommerceAddress,
                  'id' | 'line1' | 'line2' | 'city' | 'country' | 'postalCode' | 'state'
                >
              >
            }
        >
        taxes: Maybe<
          Array<
            { __typename?: 'CommerceTaxSummary' } & Pick<
              CommerceTaxSummary,
              'name' | 'total' | 'rateAmount' | 'rateType'
            >
          >
        >
        codes: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommerceCode' } & Pick<CommerceCode, 'slug' | 'id' | 'type'> & {
                  deal: Maybe<
                    { __typename?: 'CommerceDeal' } & Pick<
                      CommerceDeal,
                      'active' | 'name' | 'description' | 'endDate' | 'id'
                    > & {
                        dealItems: Maybe<
                          Array<
                            { __typename?: 'CommerceDealItem' } & Pick<
                              CommerceDealItem,
                              'id' | 'min' | 'max' | 'amount' | 'step' | 'type'
                            > & {
                                product: Maybe<
                                  { __typename?: 'CommerceProduct' } & Pick<CommerceProduct, 'id'>
                                >
                              }
                          >
                        >
                      }
                  >
                  voucher: Maybe<
                    { __typename?: 'CommerceVoucher' } & Pick<
                      CommerceVoucher,
                      'active' | 'name' | 'description' | 'id'
                    >
                  >
                }
            >
          >
        >
        items: Array<
          { __typename?: 'CommerceOrderItem' } & Pick<
            CommerceOrderItem,
            'id' | 'itemName' | 'price' | 'quantity' | 'subTotal' | 'total' | 'metadata'
          > & {
              product: Maybe<
                { __typename?: 'CommerceProduct' } & Pick<
                  CommerceProduct,
                  'id' | 'onSale' | 'name' | 'taxMode' | 'metadata'
                >
              >
            }
        >
        transactions: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommerceTransaction' } & Pick<
                CommerceTransaction,
                'amount' | 'metadata' | 'status' | 'lastUpdatedAt' | 'type'
              > & {
                  paymentMethod: Maybe<
                    { __typename?: 'CommercePaymentMethod' } & Pick<CommercePaymentMethod, 'id'>
                  >
                }
            >
          >
        >
      }
  >
}

export type GetDealQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type GetDealQuery = { __typename?: 'Query' } & {
  commerceGetDeal: Maybe<
    { __typename?: 'CommerceDeal' } & Pick<
      CommerceDeal,
      'id' | 'name' | 'active' | 'description'
    > & {
        dealItems: Maybe<
          Array<
            { __typename?: 'CommerceDealItem' } & Pick<
              CommerceDealItem,
              'amount' | 'min' | 'type'
            > & {
                product: Maybe<
                  { __typename?: 'CommerceProduct' } & Pick<
                    CommerceProduct,
                    'id' | 'price' | 'name' | 'active'
                  > & {
                      tags: Maybe<
                        Array<
                          { __typename?: 'CommerceTag' } & Pick<
                            CommerceTag,
                            'id' | 'name' | 'description' | 'code'
                          >
                        >
                      >
                      taxType: { __typename?: 'CommerceTaxType' } & {
                        taxes: Maybe<
                          Array<
                            { __typename?: 'CommerceTax' } & Pick<
                              CommerceTax,
                              'name' | 'rateAmount' | 'rateType' | 'country'
                            >
                          >
                        >
                      }
                    }
                >
              }
          >
        >
      }
  >
}

export type CommerceGetOrderQueryVariables = Exact<{
  id: Scalars['ID']
  validateOrder?: Maybe<Scalars['Boolean']>
}>

export type CommerceGetOrderQuery = { __typename?: 'Query' } & {
  commerceGetOrder: Maybe<
    { __typename?: 'CommerceOrder' } & Pick<
      CommerceOrder,
      | 'id'
      | 'url'
      | 'reference'
      | 'currency'
      | 'invoiceUrl'
      | 'intraEU'
      | 'locked'
      | 'discountCodes'
      | 'discountTotal'
      | 'paymentStatus'
      | 'status'
      | 'valueTotal'
      | 'total'
      | 'subTotal'
      | 'taxTotal'
      | 'metadata'
    > & {
        paymentMethod: Maybe<
          { __typename?: 'CommercePaymentMethod' } & Pick<CommercePaymentMethod, 'id' | 'gateway'>
        >
        customer: Maybe<
          { __typename?: 'CommerceCustomer' } & Pick<
            CommerceCustomer,
            'id' | 'firstName' | 'lastName' | 'email' | 'vatNumber' | 'vatVerified' | 'companyName'
          > & {
              address: Maybe<
                { __typename?: 'CommerceAddress' } & Pick<
                  CommerceAddress,
                  'id' | 'line1' | 'line2' | 'city' | 'state' | 'country' | 'postalCode'
                >
              >
            }
        >
        taxes: Maybe<
          Array<
            { __typename?: 'CommerceTaxSummary' } & Pick<
              CommerceTaxSummary,
              'name' | 'total' | 'rateAmount' | 'rateType'
            >
          >
        >
        codes: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommerceCode' } & Pick<CommerceCode, 'slug' | 'id' | 'type'> & {
                  deal: Maybe<
                    { __typename?: 'CommerceDeal' } & Pick<
                      CommerceDeal,
                      'active' | 'name' | 'description' | 'endDate' | 'id'
                    > & {
                        dealItems: Maybe<
                          Array<
                            { __typename?: 'CommerceDealItem' } & Pick<
                              CommerceDealItem,
                              'id' | 'min' | 'max' | 'amount' | 'step' | 'type'
                            > & {
                                product: Maybe<
                                  { __typename?: 'CommerceProduct' } & Pick<CommerceProduct, 'id'>
                                >
                              }
                          >
                        >
                      }
                  >
                  voucher: Maybe<
                    { __typename?: 'CommerceVoucher' } & Pick<
                      CommerceVoucher,
                      'active' | 'name' | 'description' | 'id'
                    >
                  >
                }
            >
          >
        >
        items: Array<
          { __typename?: 'CommerceOrderItem' } & Pick<
            CommerceOrderItem,
            'id' | 'itemName' | 'price' | 'quantity' | 'subTotal' | 'total' | 'metadata'
          > & {
              product: Maybe<
                { __typename?: 'CommerceProduct' } & Pick<
                  CommerceProduct,
                  'id' | 'onSale' | 'name' | 'taxMode' | 'metadata'
                >
              >
            }
        >
        transactions: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommerceTransaction' } & Pick<
                CommerceTransaction,
                'lastUpdatedAt' | 'type' | 'status' | 'amount' | 'metadata'
              > & {
                  paymentMethod: Maybe<
                    { __typename?: 'CommercePaymentMethod' } & Pick<CommercePaymentMethod, 'id'>
                  >
                }
            >
          >
        >
      }
  >
}

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID']
  storeId: Scalars['ID']
}>

export type GetProductQuery = { __typename?: 'Query' } & {
  commerceGetProduct: Maybe<
    { __typename?: 'CommerceProduct' } & Pick<
      CommerceProduct,
      'id' | 'active' | 'name' | 'description' | 'price' | 'taxMode'
    > & {
        taxType: { __typename?: 'CommerceTaxType' } & {
          taxes: Maybe<
            Array<
              { __typename?: 'CommerceTax' } & Pick<
                CommerceTax,
                'rateAmount' | 'rateType' | 'country' | 'name'
              >
            >
          >
        }
        tags: Maybe<
          Array<
            { __typename?: 'CommerceTag' } & Pick<
              CommerceTag,
              'id' | 'name' | 'description' | 'code'
            >
          >
        >
      }
  >
}

export type CommerceGetStoreQueryVariables = Exact<{ [key: string]: never }>

export type CommerceGetStoreQuery = { __typename?: 'Query' } & {
  commerceGetStore: Maybe<
    { __typename?: 'CommerceStore' } & Pick<
      CommerceStore,
      'id' | 'slug' | 'country' | 'currency' | 'currencySymbol'
    > & {
        storeBilling: { __typename?: 'CommerceStoreBilling' } & Pick<
          CommerceStoreBilling,
          'country'
        >
        paymentMethods: Maybe<
          Array<
            { __typename?: 'CommercePaymentMethod' } & Pick<
              CommercePaymentMethod,
              'id' | 'name' | 'active' | 'gateway' | 'configuration'
            >
          >
        >
      }
  >
}

export type ListProductsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}>

export type ListProductsQuery = { __typename?: 'Query' } & {
  commerceListProducts: Maybe<
    { __typename?: 'CommercePageProduct' } & {
      content: Maybe<
        Array<
          { __typename?: 'CommerceProduct' } & Pick<
            CommerceProduct,
            'id' | 'active' | 'name' | 'description' | 'price' | 'taxMode'
          > & {
              taxType: { __typename?: 'CommerceTaxType' } & {
                taxes: Maybe<
                  Array<
                    { __typename?: 'CommerceTax' } & Pick<
                      CommerceTax,
                      'rateAmount' | 'rateType' | 'country' | 'name'
                    >
                  >
                >
              }
              tags: Maybe<
                Array<
                  { __typename?: 'CommerceTag' } & Pick<
                    CommerceTag,
                    'id' | 'name' | 'description' | 'code'
                  >
                >
              >
            }
        >
      >
    }
  >
}

export type ListSalesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  sort?: Maybe<Array<CommerceSortTerm>>
  terms?: Maybe<Array<Maybe<Array<CommerceSearchTerm>>>>
}>

export type ListSalesQuery = { __typename?: 'Query' } & {
  commerceListSales: Maybe<
    { __typename?: 'CommercePageSale' } & {
      content: Maybe<
        Array<
          { __typename?: 'CommerceSale' } & Pick<
            CommerceSale,
            'id' | 'name' | 'description' | 'active' | 'startDate' | 'endDate'
          >
        >
      >
    }
  >
}

export type GetEventLinksQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>
}>

export type GetEventLinksQuery = { __typename?: 'Query' } & {
  event: Maybe<{ __typename?: 'Event' } & Pick<Event, 'baseUrl' | 'publicDomain' | 'supportLink'>>
}

export type TaEventDataQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type TaEventDataQuery = { __typename?: 'Query' } & {
  taEvent: Maybe<
    { __typename?: 'TAEvent' } & Pick<
      TaEvent,
      | 'id'
      | 'slug'
      | 'name'
      | 'industries'
      | 'companySizes'
      | 'passportRequired'
      | 'sponsorName'
      | 'sponsorPrivacyPolicyUrl'
    >
  >
}

export type GetTimeslotQueryVariables = Exact<{
  timeslotSlug: Scalars['String']
}>

export type GetTimeslotQuery = { __typename?: 'Query' } & {
  event: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id' | 'timezone'>>
  scheduleTimeslot: Maybe<
    { __typename?: 'ScheduleTimeslot' } & Pick<
      ScheduleTimeslot,
      | 'id'
      | 'slug'
      | 'title'
      | 'description'
      | 'startsAt'
      | 'endsAt'
      | 'calendarEventId'
      | 'channelUrl'
    > & {
        participants: { __typename?: 'AttendeeConnection' } & {
          edges: Array<
            { __typename?: 'AttendeeEdge' } & {
              node: { __typename?: 'Attendee' } & Pick<
                Attendee,
                'id' | 'name' | 'bio' | 'jobTitle' | 'avatarUrl' | 'companyName'
              >
            }
          >
        }
        location: Maybe<{ __typename?: 'Location' } & Pick<Location, 'name'>>
        topics: Array<{ __typename?: 'Topic' } & Pick<Topic, 'id' | 'name'>>
      }
  >
}

export type GetTimeZoneQueryVariables = Exact<{ [key: string]: never }>

export type GetTimeZoneQuery = { __typename?: 'Query' } & {
  event: Maybe<
    { __typename?: 'Event' } & Pick<Event, 'id'> & {
        timeZone: Maybe<{ __typename?: 'TimeZone' } & Pick<TimeZone, 'ianaName' | 'displayName'>>
      }
  >
}

export type MyAssignmentDashboardQueryVariables = Exact<{ [key: string]: never }>

export type MyAssignmentDashboardQuery = { __typename?: 'Query' } & {
  assignmentUser: Maybe<{ __typename?: 'AssignmentUser' } & Pick<AssignmentUser, 'email'>>
  orders: { __typename?: 'OrderConnection' } & {
    edges: Array<
      { __typename?: 'OrderEdge' } & {
        node: { __typename?: 'Order' } & Pick<
          Order,
          'id' | 'reference' | 'amount' | 'currency' | 'completedAt'
        > & {
            summary: { __typename?: 'OrderSummary' } & Pick<OrderSummary, 'tickets'> & {
                ticketType: Maybe<{ __typename?: 'TicketType' } & Pick<TicketType, 'name'>>
              }
          }
      }
    >
  }
}

export type MyBookingAddonsQueryVariables = Exact<{
  reference: Scalars['String']
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<BookingAddOnFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<BookingAddOnSorter>>
}>

export type MyBookingAddonsQuery = { __typename?: 'Query' } & {
  booking: Maybe<
    { __typename?: 'Booking' } & Pick<Booking, 'id' | 'reference'> & {
        addonTypesSummary: Maybe<
          Array<{ __typename?: 'TicketTypeInfo' } & Pick<TicketTypeInfo, 'count' | 'id' | 'name'>>
        >
        addOns: { __typename?: 'TAAddOnConnection' } & Pick<TaAddOnConnection, 'totalCount'> & {
            edges: Array<
              { __typename?: 'TAAddOnEdge' } & {
                node: { __typename?: 'TAAddOn' } & Pick<TaAddOn, 'id' | 'state'> & {
                    addOnType: { __typename?: 'TAAddOnType' } & Pick<TaAddOnType, 'name'>
                    assignment: Maybe<
                      { __typename?: 'TAAddOnAssignment' } & Pick<
                        TaAddOnAssignment,
                        'id' | 'state'
                      > & {
                          assignee: Maybe<
                            { __typename?: 'AssignmentUser' } & Pick<
                              AssignmentUser,
                              'id' | 'me' | 'firstName' | 'lastName' | 'email'
                            >
                          >
                        }
                    >
                  }
              }
            >
          }
      }
  >
}

export type MyBookingHiddenTicketsQueryVariables = Exact<{
  reference: Scalars['String']
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filterV2?: Maybe<BookingTicketFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  onlyHidden?: Maybe<Scalars['Boolean']>
  search?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<BookingTicketSorter>>
}>

export type MyBookingHiddenTicketsQuery = { __typename?: 'Query' } & {
  booking: Maybe<
    { __typename?: 'Booking' } & Pick<Booking, 'reference'> & {
        tickets: { __typename?: 'TicketConnection' } & {
          edges: Array<
            { __typename?: 'TicketEdge' } & {
              node: { __typename?: 'Ticket' } & Pick<Ticket, 'bookingRef'> & {
                  order: { __typename?: 'Order' } & Pick<Order, 'reference'>
                }
            }
          >
        }
      }
  >
}

export type MyBookingOrdersQueryVariables = Exact<{
  reference: Scalars['String']
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  onlyWithInvoices?: Maybe<Scalars['Boolean']>
}>

export type MyBookingOrdersQuery = { __typename?: 'Query' } & {
  booking: Maybe<
    { __typename?: 'Booking' } & Pick<Booking, 'id'> & {
        orders: { __typename?: 'OrderConnection' } & {
          edges: Array<
            { __typename?: 'OrderEdge' } & {
              node: { __typename?: 'Order' } & Pick<
                Order,
                'invoiceUrl' | 'completedAt' | 'reference'
              >
            }
          >
        }
      }
  >
}

export type MyBookingTicketsQueryVariables = Exact<{
  reference: Scalars['String']
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filterV2?: Maybe<BookingTicketFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<BookingTicketSorter>>
}>

export type MyBookingTicketsQuery = { __typename?: 'Query' } & {
  booking: Maybe<
    { __typename?: 'Booking' } & Pick<Booking, 'id' | 'reference'> & {
        ticketTypesSummary: Maybe<
          Array<{ __typename?: 'TicketTypeInfo' } & Pick<TicketTypeInfo, 'count' | 'id' | 'name'>>
        >
        tickets: { __typename?: 'TicketConnection' } & Pick<TicketConnection, 'totalCount'> & {
            edges: Array<
              { __typename?: 'TicketEdge' } & {
                node: { __typename?: 'Ticket' } & Pick<Ticket, 'id' | 'bookingRef' | 'state'> & {
                    context: { __typename?: 'TicketContext' } & Pick<
                      TicketContext,
                      'acceptable' | 'assignable' | 'editable' | 'rejectable'
                    >
                    acceptedAddOns: { __typename?: 'TAAddOnConnection' } & {
                      edges: Array<
                        { __typename?: 'TAAddOnEdge' } & {
                          node: { __typename?: 'TAAddOn' } & Pick<TaAddOn, 'id' | 'state'> & {
                              addOnType: { __typename?: 'TAAddOnType' } & Pick<
                                TaAddOnType,
                                'id' | 'name' | 'description'
                              >
                              assignment: Maybe<
                                { __typename?: 'TAAddOnAssignment' } & Pick<
                                  TaAddOnAssignment,
                                  'id' | 'state'
                                > & {
                                    assignee: Maybe<
                                      { __typename?: 'AssignmentUser' } & Pick<
                                        AssignmentUser,
                                        'id' | 'me' | 'firstName' | 'lastName' | 'email'
                                      >
                                    >
                                  }
                              >
                            }
                        }
                      >
                    }
                    ticketType: Maybe<
                      { __typename?: 'TicketType' } & Pick<TicketType, 'name' | 'leadScanning'>
                    >
                    order: { __typename?: 'Order' } & {
                      owner: { __typename?: 'AssignmentUser' } & Pick<
                        AssignmentUser,
                        'firstName' | 'lastName' | 'email' | 'me'
                      >
                    }
                    assignment: Maybe<
                      { __typename?: 'Assignment' } & Pick<
                        Assignment,
                        'id' | 'state' | 'leadScanningActive' | 'appLoginEmail'
                      > & {
                          assignee: Maybe<
                            { __typename?: 'AssignmentUser' } & Pick<
                              AssignmentUser,
                              'id' | 'firstName' | 'lastName' | 'email' | 'me'
                            >
                          >
                        }
                    >
                  }
              }
            >
          }
      }
  >
}

export type MyBookingUpgradesQueryVariables = Exact<{
  reference: Scalars['String']
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter?: Maybe<BookingUpgradeFilter>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
  sorter?: Maybe<Array<BookingUpgradeSorter>>
}>

export type MyBookingUpgradesQuery = { __typename?: 'Query' } & {
  booking: Maybe<
    { __typename?: 'Booking' } & Pick<Booking, 'id' | 'reference'> & {
        upgradeTypesSummary: Maybe<
          Array<{ __typename?: 'TicketTypeInfo' } & Pick<TicketTypeInfo, 'count' | 'id' | 'name'>>
        >
        ticketUpgrades: { __typename?: 'TATicketUpgradeConnection' } & Pick<
          TaTicketUpgradeConnection,
          'totalCount'
        > & {
            edges: Array<
              { __typename?: 'TATicketUpgradeEdge' } & {
                node: { __typename?: 'TATicketUpgrade' } & Pick<TaTicketUpgrade, 'id' | 'state'> & {
                    ticketUpgradeType: { __typename?: 'TATicketUpgradeType' } & Pick<
                      TaTicketUpgradeType,
                      'name'
                    >
                    assignment: Maybe<
                      { __typename?: 'TATicketUpgradeAssignment' } & Pick<
                        TaTicketUpgradeAssignment,
                        'id' | 'state'
                      > & {
                          assignee: Maybe<
                            { __typename?: 'AssignmentUser' } & Pick<
                              AssignmentUser,
                              'id' | 'me' | 'firstName' | 'lastName' | 'email'
                            >
                          >
                        }
                    >
                  }
              }
            >
          }
      }
  >
}

export type MyBookingsQueryVariables = Exact<{
  filter?: Maybe<BookingFilter>
  search?: Maybe<Scalars['String']>
}>

export type MyBookingsQuery = { __typename?: 'Query' } & {
  bookings: Maybe<
    { __typename?: 'BookingConnection' } & {
      edges: Array<
        { __typename?: 'BookingEdge' } & {
          node: { __typename?: 'Booking' } & Pick<
            Booking,
            'reference' | 'totalHiddenTickets' | 'totalInvoices'
          > & {
              tickets: { __typename?: 'TicketConnection' } & Pick<TicketConnection, 'totalCount'>
              addOns: { __typename?: 'TAAddOnConnection' } & Pick<TaAddOnConnection, 'totalCount'>
              ticketUpgrades: { __typename?: 'TATicketUpgradeConnection' } & Pick<
                TaTicketUpgradeConnection,
                'totalCount'
              >
            }
        }
      >
    }
  >
}

export type MyDashboardQueryVariables = Exact<{ [key: string]: never }>

export type MyDashboardQuery = { __typename?: 'Query' } & {
  orders: { __typename?: 'OrderConnection' } & {
    edges: Array<
      { __typename?: 'OrderEdge' } & { node: { __typename?: 'Order' } & Pick<Order, 'id'> }
    >
  }
  tickets: { __typename?: 'TicketConnection' } & {
    edges: Array<
      { __typename?: 'TicketEdge' } & { node: { __typename?: 'Ticket' } & Pick<Ticket, 'id'> }
    >
  }
}

export type MyOrdersQueryVariables = Exact<{ [key: string]: never }>

export type MyOrdersQuery = { __typename?: 'Query' } & {
  orders: { __typename?: 'OrderConnection' } & {
    edges: Array<
      { __typename?: 'OrderEdge' } & {
        node: { __typename?: 'Order' } & Pick<
          Order,
          'id' | 'reference' | 'currency' | 'invoiceUrl' | 'completedAt'
        > & {
            summary: { __typename?: 'OrderSummary' } & Pick<
              OrderSummary,
              'addOns' | 'tickets' | 'ticketUpgrades'
            > & {
                addOnType: Maybe<{ __typename?: 'TAAddOnType' } & Pick<TaAddOnType, 'name'>>
                ticketType: Maybe<{ __typename?: 'TicketType' } & Pick<TicketType, 'name'>>
                ticketUpgradeType: Maybe<
                  { __typename?: 'TATicketUpgradeType' } & Pick<TaTicketUpgradeType, 'name'>
                >
              }
            tickets: { __typename?: 'TicketConnection' } & {
              edges: Array<
                { __typename?: 'TicketEdge' } & {
                  node: { __typename?: 'Ticket' } & Pick<Ticket, 'id' | 'bookingRef'> & {
                      ticketType: Maybe<
                        { __typename?: 'TicketType' } & Pick<TicketType, 'hidden' | 'leadScanning'>
                      >
                      assignment: Maybe<
                        { __typename?: 'Assignment' } & Pick<
                          Assignment,
                          'id' | 'leadScanningActive'
                        >
                      >
                    }
                }
              >
            }
            ticketUpgrades: { __typename?: 'TATicketUpgradeConnection' } & {
              edges: Array<
                { __typename?: 'TATicketUpgradeEdge' } & {
                  node: { __typename?: 'TATicketUpgrade' } & {
                    ticketUpgradeType: { __typename?: 'TATicketUpgradeType' } & Pick<
                      TaTicketUpgradeType,
                      'name'
                    >
                  }
                }
              >
            }
          }
      }
    >
  }
}

export type MyTicketsQueryVariables = Exact<{
  bookingId?: Maybe<Scalars['ID']>
  orderId?: Maybe<Scalars['ID']>
  filter?: Maybe<TicketFilter>
  searchQuery?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  last?: Maybe<Scalars['Int']>
  sorter?: Maybe<Array<TicketSorter>>
}>

export type MyTicketsQuery = { __typename?: 'Query' } & {
  tickets: { __typename?: 'TicketConnection' } & {
    edges: Array<
      { __typename?: 'TicketEdge' } & {
        node: { __typename?: 'Ticket' } & Pick<Ticket, 'id' | 'bookingRef' | 'state'> & {
            order: { __typename?: 'Order' } & {
              owner: { __typename?: 'AssignmentUser' } & Pick<AssignmentUser, 'me'>
            }
            ticketType: Maybe<
              { __typename?: 'TicketType' } & Pick<TicketType, 'name' | 'hidden' | 'leadScanning'>
            >
            acceptedAddOns: { __typename?: 'TAAddOnConnection' } & {
              edges: Array<
                { __typename?: 'TAAddOnEdge' } & {
                  node: { __typename?: 'TAAddOn' } & Pick<TaAddOn, 'id' | 'state'> & {
                      addOnType: { __typename?: 'TAAddOnType' } & Pick<
                        TaAddOnType,
                        'id' | 'name' | 'description'
                      >
                    }
                }
              >
            }
            assignment: Maybe<
              { __typename?: 'Assignment' } & Pick<
                Assignment,
                'id' | 'state' | 'appLoginEmail' | 'leadScanningActive'
              > & {
                  assignee: Maybe<
                    { __typename?: 'AssignmentUser' } & Pick<
                      AssignmentUser,
                      | 'id'
                      | 'me'
                      | 'firstName'
                      | 'lastName'
                      | 'email'
                      | 'phoneNumber'
                      | 'city'
                      | 'companyName'
                      | 'companySizeId'
                      | 'industryId'
                      | 'jobTitle'
                      | 'marketingConsent'
                      | 'passportNumber'
                      | 'personalisationConsent'
                      | 'partnerSharingConsent'
                      | 'washingtonPostConsent'
                    >
                  >
                }
            >
            context: { __typename?: 'TicketContext' } & Pick<
              TicketContext,
              'assignable' | 'editable' | 'acceptable' | 'rejectable'
            >
          }
      }
    >
  }
}

export type OrderTicketsLiteQueryVariables = Exact<{
  reference: Scalars['String']
}>

export type OrderTicketsLiteQuery = { __typename?: 'Query' } & {
  order: Maybe<
    { __typename?: 'Order' } & {
      tickets: { __typename?: 'TicketConnection' } & {
        edges: Array<
          { __typename?: 'TicketEdge' } & {
            node: { __typename?: 'Ticket' } & Pick<Ticket, 'id' | 'bookingRef'> & {
                ticketType: Maybe<{ __typename?: 'TicketType' } & Pick<TicketType, 'hidden'>>
              }
          }
        >
      }
    }
  >
}

export type OrderTicketsQueryVariables = Exact<{
  reference: Scalars['String']
  filter?: Maybe<TicketFilter>
}>

export type OrderTicketsQuery = { __typename?: 'Query' } & {
  order: Maybe<
    { __typename?: 'Order' } & {
      tickets: { __typename?: 'TicketConnection' } & {
        edges: Array<
          { __typename?: 'TicketEdge' } & {
            node: { __typename?: 'Ticket' } & Pick<Ticket, 'id' | 'bookingRef' | 'state'> & {
                ticketType: Maybe<
                  { __typename?: 'TicketType' } & Pick<TicketType, 'name' | 'leadScanning'>
                >
                assignment: Maybe<
                  { __typename?: 'Assignment' } & Pick<
                    Assignment,
                    'id' | 'state' | 'appLoginEmail' | 'leadScanningActive'
                  > & {
                      assignee: Maybe<
                        { __typename?: 'AssignmentUser' } & Pick<
                          AssignmentUser,
                          | 'id'
                          | 'me'
                          | 'firstName'
                          | 'lastName'
                          | 'email'
                          | 'phoneNumber'
                          | 'city'
                          | 'companyName'
                          | 'companySizeId'
                          | 'industryId'
                          | 'jobTitle'
                          | 'marketingConsent'
                          | 'passportNumber'
                          | 'personalisationConsent'
                          | 'partnerSharingConsent'
                          | 'washingtonPostConsent'
                        >
                      >
                    }
                >
                order: { __typename?: 'Order' } & Pick<
                  Order,
                  'reference' | 'sourceId' | 'invoiceUrl'
                >
                context: { __typename?: 'TicketContext' } & Pick<
                  TicketContext,
                  'assignable' | 'editable' | 'acceptable' | 'rejectable'
                >
                acceptedAddOns: { __typename?: 'TAAddOnConnection' } & {
                  edges: Array<
                    { __typename?: 'TAAddOnEdge' } & {
                      node: { __typename?: 'TAAddOn' } & Pick<TaAddOn, 'id' | 'state'> & {
                          addOnType: { __typename?: 'TAAddOnType' } & Pick<
                            TaAddOnType,
                            'id' | 'name' | 'description'
                          >
                          assignment: Maybe<
                            { __typename?: 'TAAddOnAssignment' } & Pick<
                              TaAddOnAssignment,
                              'id' | 'state'
                            > & {
                                assignee: Maybe<
                                  { __typename?: 'AssignmentUser' } & Pick<
                                    AssignmentUser,
                                    'id' | 'me' | 'firstName' | 'lastName' | 'email'
                                  >
                                >
                              }
                          >
                        }
                    }
                  >
                }
              }
          }
        >
      }
      addOns: { __typename?: 'TAAddOnConnection' } & {
        edges: Array<
          { __typename?: 'TAAddOnEdge' } & {
            node: { __typename?: 'TAAddOn' } & Pick<TaAddOn, 'id' | 'state'> & {
                addOnType: { __typename?: 'TAAddOnType' } & Pick<
                  TaAddOnType,
                  'id' | 'name' | 'description'
                >
                assignment: Maybe<
                  { __typename?: 'TAAddOnAssignment' } & Pick<TaAddOnAssignment, 'id' | 'state'> & {
                      assignee: Maybe<
                        { __typename?: 'AssignmentUser' } & Pick<
                          AssignmentUser,
                          | 'id'
                          | 'me'
                          | 'firstName'
                          | 'lastName'
                          | 'email'
                          | 'phoneNumber'
                          | 'city'
                          | 'companyName'
                          | 'companySizeId'
                          | 'industryId'
                          | 'jobTitle'
                          | 'marketingConsent'
                          | 'passportNumber'
                          | 'personalisationConsent'
                          | 'partnerSharingConsent'
                          | 'washingtonPostConsent'
                        >
                      >
                    }
                >
                order: { __typename?: 'Order' } & Pick<
                  Order,
                  'reference' | 'sourceId' | 'invoiceUrl'
                >
              }
          }
        >
      }
      ticketUpgrades: { __typename?: 'TATicketUpgradeConnection' } & {
        edges: Array<
          { __typename?: 'TATicketUpgradeEdge' } & {
            node: { __typename?: 'TATicketUpgrade' } & Pick<TaTicketUpgrade, 'id' | 'state'> & {
                ticketUpgradeType: { __typename?: 'TATicketUpgradeType' } & Pick<
                  TaTicketUpgradeType,
                  'name'
                >
                assignment: Maybe<
                  { __typename?: 'TATicketUpgradeAssignment' } & Pick<
                    TaTicketUpgradeAssignment,
                    'id' | 'state'
                  > & {
                      assignee: Maybe<
                        { __typename?: 'AssignmentUser' } & Pick<
                          AssignmentUser,
                          | 'id'
                          | 'me'
                          | 'firstName'
                          | 'lastName'
                          | 'email'
                          | 'phoneNumber'
                          | 'city'
                          | 'companyName'
                          | 'companySizeId'
                          | 'industryId'
                          | 'jobTitle'
                          | 'marketingConsent'
                          | 'passportNumber'
                          | 'personalisationConsent'
                          | 'partnerSharingConsent'
                          | 'washingtonPostConsent'
                        >
                      >
                    }
                >
                order: { __typename?: 'Order' } & Pick<
                  Order,
                  'reference' | 'sourceId' | 'invoiceUrl'
                >
              }
          }
        >
      }
    }
  >
}

export type WebPageByHostPathQueryVariables = Exact<{
  host: Scalars['String']
  path: Scalars['String']
}>

export type WebPageByHostPathQuery = { __typename?: 'Query' } & {
  webPageByHostPath: Maybe<
    { __typename?: 'WebPage' } & Pick<WebPage, 'id' | 'title'> & {
        seoTags: Maybe<
          { __typename?: 'ComponentWebElementsSeoMetaData' } & Pick<
            ComponentWebElementsSeoMetaData,
            | 'title'
            | 'slug'
            | 'description'
            | 'twitterTitle'
            | 'twitterDescription'
            | 'facebookTitle'
            | 'facebookDescription'
            | 'noindex'
          > & {
              defaultImage: Maybe<{ __typename?: 'UploadFile' } & Pick<UploadFile, 'id' | 'url'>>
              twitterImage: Maybe<{ __typename?: 'UploadFile' } & Pick<UploadFile, 'id' | 'url'>>
              facebookImage: Maybe<{ __typename?: 'UploadFile' } & Pick<UploadFile, 'id' | 'url'>>
            }
        >
        content: Array<
          | ({
              __typename: 'ComponentWebElementsAttendeeSearchSidebarFilters'
            } & AttendeeSearchSidebarFiltersFragment)
          | ({
              __typename: 'ComponentWebElementsCompanySearchSidebarFilters'
            } & CompanySearchSidebarFiltersFragment)
          | { __typename: 'ComponentWebElementsFreshchat' }
          | ({ __typename: 'ComponentWebElementsHeroSection' } & HeroSectionFragment)
          | ({
              __typename: 'ComponentWebElementsScheduleSearchSidebarFilters'
            } & ScheduleSearchSidebarFiltersFragment)
          | ({ __typename: 'ComponentWebElementsShowcaseGrid' } & ShowcaseGridFragment)
          | ({
              __typename: 'ComponentWebLayoutsStoresTicketApplicationsPage'
            } & StoresTicketApplicationsPageLayoutFragment)
          | ({
              __typename: 'ComponentWebLayoutsStoresTicketSalesPage'
            } & StoresTicketSalesPageLayoutFragment)
          | { __typename: 'ComponentWebLayoutsTicketApplicationsPage' }
          | { __typename: 'ComponentWebLayoutsTicketSalesPage' }
        >
      }
  >
}

export type StoresTicketSalesPageLayoutFragment = {
  __typename?: 'ComponentWebLayoutsStoresTicketSalesPage'
} & Pick<ComponentWebLayoutsStoresTicketSalesPage, 'id'> & {
    ticketReleasesPanel: Maybe<
      { __typename?: 'ComponentWebElementsTicketReleasesPanel' } & TicketReleasesPanelFragment
    >
    priceIncreaseCountdownTimer: Maybe<
      { __typename?: 'ComponentWebElementsPriceIncreaseCountdownTimer' } & {
        product: Maybe<{ __typename?: 'Products' } & ProductsFragment>
      }
    >
    releasePhaseStepper: Maybe<
      { __typename?: 'ComponentWebElementsReleasePhaseStepper' } & {
        product: Maybe<{ __typename?: 'Products' } & ProductsFragment>
      }
    >
    categoriesMenu: Maybe<{ __typename?: 'Menu' } & TabularMenuFragment>
    products: Array<
      { __typename?: 'ComponentWebElementsProducts' } & Pick<
        ComponentWebElementsProducts,
        | 'id'
        | 'buttonLabel'
        | 'type'
        | 'link'
        | 'promotionLabel'
        | 'promotionColor'
        | 'promotionType'
      > & {
          product: Maybe<
            { __typename?: 'Products' } & Pick<
              Products,
              'code' | 'sourceId' | 'sourceName' | 'type' | 'title' | 'description'
            >
          >
          benefits: Array<
            { __typename?: 'ProductBenefits' } & Pick<
              ProductBenefits,
              'id' | 'title' | 'description'
            >
          >
        }
    >
    benefitsList: Array<
      { __typename?: 'ProductBenefits' } & Pick<ProductBenefits, 'id' | 'title' | 'description'>
    >
    benefits: Array<
      { __typename?: 'ComponentWebElementsBenefits' } & {
        benefit: Maybe<
          { __typename?: 'ProductBenefits' } & Pick<ProductBenefits, 'id' | 'title' | 'description'>
        >
      }
    >
  }

export type StoresTicketApplicationsPageLayoutFragment = {
  __typename?: 'ComponentWebLayoutsStoresTicketApplicationsPage'
} & Pick<ComponentWebLayoutsStoresTicketApplicationsPage, 'id' | 'title' | 'description'> & {
    applicationForm: Maybe<{ __typename?: 'Form' } & ApplicationFormFragment>
    applicationOverviewPanel: Maybe<
      {
        __typename?: 'ComponentWebElementsTicketApplicationOverviewPanel'
      } & ApplicationOverviewPanelFragment
    >
    ticketInfoPanel: Maybe<
      { __typename?: 'ComponentWebElementsTicketTypeInformation' } & StoresTicketInfoPanelFragment
    >
    benefits: Array<
      { __typename?: 'ComponentWebElementsBenefits' } & {
        benefit: Maybe<
          { __typename?: 'ProductBenefits' } & Pick<ProductBenefits, 'id' | 'title' | 'description'>
        >
      }
    >
    categoriesMenu: Maybe<{ __typename?: 'Menu' } & TabularMenuFragment>
    priceIncreaseCountdownTimer: Maybe<
      { __typename?: 'ComponentWebElementsPriceIncreaseCountdownTimer' } & {
        product: Maybe<{ __typename?: 'Products' } & ProductsFragment>
      }
    >
    releasePhaseStepper: Maybe<
      { __typename?: 'ComponentWebElementsReleasePhaseStepper' } & {
        product: Maybe<{ __typename?: 'Products' } & ProductsFragment>
      }
    >
  }

export type ProductsFragment = { __typename?: 'Products' } & Pick<
  Products,
  'id' | 'code' | 'sourceName' | 'sourceId' | 'title' | 'type' | 'description'
>

export type TicketInfoPanelFragment = {
  __typename?: 'ComponentWebElementsTicketTypeInformation'
} & Pick<
  ComponentWebElementsTicketTypeInformation,
  'heading' | 'showBenefits' | 'displayPriceIncludingTax'
>

export type StoresTicketInfoPanelFragment = {
  __typename?: 'ComponentWebElementsTicketTypeInformation'
} & Pick<
  ComponentWebElementsTicketTypeInformation,
  'heading' | 'showBenefits' | 'displayPriceIncludingTax'
> & {
    product: Maybe<{ __typename?: 'Products' } & ProductsFragment>
    benefits: Array<
      { __typename?: 'ProductBenefits' } & Pick<ProductBenefits, 'title' | 'id' | 'description'>
    >
  }

export type TicketReleasesPanelFragment = {
  __typename?: 'ComponentWebElementsTicketReleasesPanel'
} & Pick<ComponentWebElementsTicketReleasesPanel, 'displayPriceIncludingTax'>

export type TicketTypeFragment = { __typename?: 'TicketType' } & Pick<TicketType, 'id'>

export type TabularMenuFragment = { __typename?: 'Menu' } & {
  menuItems: Array<
    { __typename?: 'MenuItem' } & Pick<MenuItem, 'label'> & {
        link:
          | ({ __typename: 'ComponentWebLinksPageLink' } & PageLinkFragment)
          | { __typename: 'ComponentWebLinksSubMenu' }
          | ({ __typename: 'ComponentWebLinksUrlLink' } & UrlLinkFragment)
      }
  >
}

export type UrlLinkFragment = { __typename?: 'ComponentWebLinksUrlLink' } & Pick<
  ComponentWebLinksUrlLink,
  'target' | 'url'
>

export type PageLinkFragment = { __typename?: 'ComponentWebLinksPageLink' } & {
  page: Maybe<{ __typename?: 'WebPage' } & Pick<WebPage, 'path'>>
}

export type ApplicationFormFragment = { __typename?: 'Form' } & Pick<
  Form,
  'id' | 'contentBefore' | 'formAnalyticsGoal' | 'formEventLabel'
> & {
    dynamicForm: { __typename?: 'DynamicForm' } & Pick<
      DynamicForm,
      'id' | 'schema' | 'uiSchema' | 'data' | 'mutation'
    >
  }

export type ApplicationOverviewPanelFragment = {
  __typename?: 'ComponentWebElementsTicketApplicationOverviewPanel'
} & Pick<
  ComponentWebElementsTicketApplicationOverviewPanel,
  'id' | 'title' | 'description' | 'imageUrl' | 'altImageText'
>

export type ShowcaseGridFragment = { __typename?: 'ComponentWebElementsShowcaseGrid' } & Pick<
  ComponentWebElementsShowcaseGrid,
  'id' | 'contentBefore' | 'backgroundColor'
> & {
    collection: { __typename?: 'ContentCollection' } & {
      elements: Array<
        { __typename?: 'ContentElement' } & Pick<ContentElement, 'id' | 'title'> & {
            image: Maybe<{ __typename?: 'UploadFile' } & Pick<UploadFile, 'absoluteUrl'>>
          }
      >
    }
  }

export type ScheduleSearchSidebarFiltersFragment = {
  __typename?: 'ComponentWebElementsScheduleSearchSidebarFilters'
} & Pick<
  ComponentWebElementsScheduleSearchSidebarFilters,
  'id' | 'apiKey' | 'indexName' | 'timezone'
> & {
    refinements: Array<
      { __typename?: 'ComponentSearchAlgoliaRefinement' } & Pick<
        ComponentSearchAlgoliaRefinement,
        'attribute' | 'defaults' | 'variant' | 'title' | 'refinementItemsLimit'
      >
    >
  }

export type AttendeeSearchSidebarFiltersFragment = {
  __typename?: 'ComponentWebElementsAttendeeSearchSidebarFilters'
} & Pick<ComponentWebElementsAttendeeSearchSidebarFilters, 'id' | 'apiKey' | 'indexName'> & {
    refinements: Array<
      { __typename?: 'ComponentSearchAlgoliaRefinement' } & Pick<
        ComponentSearchAlgoliaRefinement,
        'attribute' | 'defaults' | 'variant' | 'title' | 'refinementItemsLimit'
      >
    >
  }

export type CompanySearchSidebarFiltersFragment = {
  __typename?: 'ComponentWebElementsCompanySearchSidebarFilters'
} & Pick<
  ComponentWebElementsCompanySearchSidebarFilters,
  'id' | 'apiKey' | 'conferenceId' | 'indexName'
> & {
    refinements: Array<
      { __typename?: 'ComponentSearchAlgoliaRefinement' } & Pick<
        ComponentSearchAlgoliaRefinement,
        'attribute' | 'defaults' | 'variant' | 'title' | 'refinementItemsLimit'
      >
    >
  }

export type HeroSectionFragment = { __typename?: 'ComponentWebElementsHeroSection' } & Pick<
  ComponentWebElementsHeroSection,
  'id' | 'variant' | 'backgroundImageAlt' | 'backgroundImageDescription' | 'subtitle' | 'title'
> & {
    backgroundImage: Maybe<{ __typename?: 'UploadFile' } & { url: UploadFile['absoluteUrl'] }>
    ctaLink: Maybe<
      { __typename?: 'ComponentWebElementsCtaLink' } & Pick<
        ComponentWebElementsCtaLink,
        'text' | 'url'
      >
    >
    brandImage: Maybe<{ __typename?: 'UploadFile' } & { url: UploadFile['absoluteUrl'] }>
  }

export type WebPageConfigByPathHostQueryVariables = Exact<{
  path: Scalars['String']
  host: Scalars['String']
  slug?: Maybe<Scalars['String']>
}>

export type WebPageConfigByPathHostQuery = { __typename?: 'Query' } & {
  webPageConfigByPathHost: Maybe<
    { __typename?: 'WebPageConfig' } & Pick<WebPageConfig, 'id'> & {
        site: Maybe<{ __typename?: 'Site' } & Pick<Site, 'title'>>
        event: Maybe<{ __typename?: 'WebPageEvent' } & Pick<WebPageEvent, 'termsAndConditionsUrl'>>
        config: Maybe<
          { __typename?: 'WebPageConfig' } & Pick<
            WebPageConfig,
            | 'baseGoogleAnalyticsTrackingId'
            | 'googleAnalyticsTrackingId'
            | 'googleTagManagerId'
            | 'googleOptimizeId'
            | 'matomoSiteId'
            | 'matomoTagManagerContainerId'
            | 'matomoUrl'
            | 'segmentId'
          > & {
              googleAnalyticsLinkerDomains: Array<
                { __typename?: 'ComponentSiteConfigGoogleAnalyticsLinkerDomainList' } & Pick<
                  ComponentSiteConfigGoogleAnalyticsLinkerDomainList,
                  'domain'
                >
              >
              metaData: Maybe<
                { __typename?: 'ComponentSiteConfigMetaData' } & Pick<
                  ComponentSiteConfigMetaData,
                  | 'siteTitle'
                  | 'siteDescription'
                  | 'facebookId'
                  | 'facebookPublisher'
                  | 'twitterId'
                  | 'twitterCreator'
                > & {
                    image: Maybe<{ __typename?: 'UploadFile' } & { url: UploadFile['absoluteUrl'] }>
                  }
              >
            }
        >
        branding: Maybe<
          { __typename?: 'Branding' } & Pick<
            Branding,
            'googleFontsUrl' | 'typekitFontsUrl' | 'theme'
          > & {
              logo: Maybe<
                { __typename?: 'UploadFile' } & Pick<
                  UploadFile,
                  'id' | 'absoluteUrl' | 'alternativeText'
                >
              >
              headerBranding: Maybe<
                { __typename?: 'UploadFile' } & Pick<
                  UploadFile,
                  'id' | 'absoluteUrl' | 'alternativeText'
                >
              >
              favicon: Maybe<{ __typename?: 'UploadFile' } & Pick<UploadFile, 'id' | 'absoluteUrl'>>
              ticketLogo: Maybe<
                { __typename?: 'UploadFile' } & Pick<
                  UploadFile,
                  'id' | 'absoluteUrl' | 'alternativeText'
                >
              >
            }
        >
      }
  >
}

export type WebPagesByHostMenuLabelQueryVariables = Exact<{
  host: Scalars['String']
  menuLabel: Scalars['String']
}>

export type WebPagesByHostMenuLabelQuery = { __typename?: 'Query' } & {
  webPagesByHostMenuLabel: Maybe<
    Array<Maybe<{ __typename?: 'WebPage' } & Pick<WebPage, 'id' | 'title' | 'path'>>>
  >
}

export type DynamicFormPayloadFragment = { __typename?: 'DynamicForm' } & Pick<
  DynamicForm,
  'id' | 'data' | 'schema' | 'mutation' | 'uiSchema'
>

export const TicketReleasesPanelFragmentDoc = gql`
  fragment TicketReleasesPanel on ComponentWebElementsTicketReleasesPanel {
    displayPriceIncludingTax
  }
`
export const ProductsFragmentDoc = gql`
  fragment Products on Products {
    id
    code
    sourceName
    sourceId
    title
    type
    description
  }
`
export const UrlLinkFragmentDoc = gql`
  fragment UrlLink on ComponentWebLinksUrlLink {
    target
    url
  }
`
export const PageLinkFragmentDoc = gql`
  fragment PageLink on ComponentWebLinksPageLink {
    page {
      path
    }
  }
`
export const TabularMenuFragmentDoc = gql`
  fragment TabularMenu on Menu {
    menuItems {
      label
      link {
        __typename
        ... on ComponentWebLinksUrlLink {
          ...UrlLink
        }
        ... on ComponentWebLinksPageLink {
          ...PageLink
        }
      }
    }
  }
  ${UrlLinkFragmentDoc}
  ${PageLinkFragmentDoc}
`
export const StoresTicketSalesPageLayoutFragmentDoc = gql`
  fragment StoresTicketSalesPageLayout on ComponentWebLayoutsStoresTicketSalesPage {
    id
    ticketReleasesPanel {
      ...TicketReleasesPanel
    }
    priceIncreaseCountdownTimer {
      product {
        ...Products
      }
    }
    releasePhaseStepper {
      product {
        ...Products
      }
    }
    categoriesMenu {
      ...TabularMenu
    }
    products {
      id
      buttonLabel
      type
      link
      promotionLabel
      promotionColor
      promotionType
      product {
        code
        sourceId
        sourceName
        type
        title
        description
      }
      benefits {
        id
        title
        description
      }
    }
    benefitsList {
      id
      title
      description
    }
    benefits {
      benefit {
        id
        title
        description
      }
    }
  }
  ${TicketReleasesPanelFragmentDoc}
  ${ProductsFragmentDoc}
  ${TabularMenuFragmentDoc}
`
export const ApplicationFormFragmentDoc = gql`
  fragment ApplicationForm on Form {
    id
    dynamicForm {
      id
      schema
      uiSchema
      data
      mutation
    }
    contentBefore
    formAnalyticsGoal
    formEventLabel
  }
`
export const ApplicationOverviewPanelFragmentDoc = gql`
  fragment ApplicationOverviewPanel on ComponentWebElementsTicketApplicationOverviewPanel {
    id
    title
    description
    imageUrl
    altImageText
  }
`
export const StoresTicketInfoPanelFragmentDoc = gql`
  fragment StoresTicketInfoPanel on ComponentWebElementsTicketTypeInformation {
    heading
    showBenefits
    displayPriceIncludingTax
    product {
      ...Products
    }
    benefits {
      title
      id
      description
    }
  }
  ${ProductsFragmentDoc}
`
export const StoresTicketApplicationsPageLayoutFragmentDoc = gql`
  fragment StoresTicketApplicationsPageLayout on ComponentWebLayoutsStoresTicketApplicationsPage {
    id
    title
    description
    applicationForm {
      ...ApplicationForm
    }
    applicationOverviewPanel {
      ...ApplicationOverviewPanel
    }
    ticketInfoPanel {
      ...StoresTicketInfoPanel
    }
    benefits {
      benefit {
        id
        title
        description
      }
    }
    categoriesMenu {
      ...TabularMenu
    }
    priceIncreaseCountdownTimer {
      product {
        ...Products
      }
    }
    releasePhaseStepper {
      product {
        ...Products
      }
    }
  }
  ${ApplicationFormFragmentDoc}
  ${ApplicationOverviewPanelFragmentDoc}
  ${StoresTicketInfoPanelFragmentDoc}
  ${TabularMenuFragmentDoc}
  ${ProductsFragmentDoc}
`
export const TicketInfoPanelFragmentDoc = gql`
  fragment TicketInfoPanel on ComponentWebElementsTicketTypeInformation {
    heading
    showBenefits
    displayPriceIncludingTax
  }
`
export const TicketTypeFragmentDoc = gql`
  fragment TicketType on TicketType {
    id
  }
`
export const ShowcaseGridFragmentDoc = gql`
  fragment ShowcaseGrid on ComponentWebElementsShowcaseGrid {
    id
    contentBefore
    backgroundColor
    collection {
      elements {
        id
        title
        image {
          absoluteUrl
        }
      }
    }
  }
`
export const ScheduleSearchSidebarFiltersFragmentDoc = gql`
  fragment ScheduleSearchSidebarFilters on ComponentWebElementsScheduleSearchSidebarFilters {
    id
    apiKey
    indexName
    timezone
    refinements {
      attribute
      defaults
      variant
      title
      refinementItemsLimit
    }
  }
`
export const AttendeeSearchSidebarFiltersFragmentDoc = gql`
  fragment AttendeeSearchSidebarFilters on ComponentWebElementsAttendeeSearchSidebarFilters {
    id
    apiKey
    indexName
    refinements {
      attribute
      defaults
      variant
      title
      refinementItemsLimit
    }
  }
`
export const CompanySearchSidebarFiltersFragmentDoc = gql`
  fragment CompanySearchSidebarFilters on ComponentWebElementsCompanySearchSidebarFilters {
    id
    apiKey
    conferenceId
    indexName
    refinements {
      attribute
      defaults
      variant
      title
      refinementItemsLimit
    }
  }
`
export const HeroSectionFragmentDoc = gql`
  fragment HeroSection on ComponentWebElementsHeroSection {
    id
    variant
    backgroundImage {
      url: absoluteUrl
    }
    ctaLink {
      text
      url
    }
    backgroundImageAlt
    backgroundImageDescription
    brandImage {
      url: absoluteUrl
    }
    subtitle
    title
  }
`
export const DynamicFormPayloadFragmentDoc = gql`
  fragment DynamicFormPayload on DynamicForm {
    id
    data
    schema
    mutation
    uiSchema
  }
`
export const AddOnAssignDocument = gql`
  mutation AddOnAssign($input: AddOnAssignInput!) {
    assignmentAddOnAssign(input: $input) {
      addOn {
        id
        state
      }
      userErrors {
        message
      }
    }
  }
`
export type AddOnAssignMutationFn = Apollo.MutationFunction<
  AddOnAssignMutation,
  AddOnAssignMutationVariables
>

/**
 * __useAddOnAssignMutation__
 *
 * To run a mutation, you first call `useAddOnAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOnAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOnAssignMutation, { data, loading, error }] = useAddOnAssignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOnAssignMutation(
  baseOptions?: Apollo.MutationHookOptions<AddOnAssignMutation, AddOnAssignMutationVariables>
) {
  return Apollo.useMutation<AddOnAssignMutation, AddOnAssignMutationVariables>(
    AddOnAssignDocument,
    baseOptions
  )
}
export type AddOnAssignMutationHookResult = ReturnType<typeof useAddOnAssignMutation>
export type AddOnAssignMutationResult = Apollo.MutationResult<AddOnAssignMutation>
export type AddOnAssignMutationOptions = Apollo.BaseMutationOptions<
  AddOnAssignMutation,
  AddOnAssignMutationVariables
>
export const AddOnUnassignDocument = gql`
  mutation AddOnUnassign($input: AddOnUnassignInput!) {
    assignmentAddOnUnassign(input: $input) {
      addOn {
        id
      }
      userErrors {
        message
      }
    }
  }
`
export type AddOnUnassignMutationFn = Apollo.MutationFunction<
  AddOnUnassignMutation,
  AddOnUnassignMutationVariables
>

/**
 * __useAddOnUnassignMutation__
 *
 * To run a mutation, you first call `useAddOnUnassignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOnUnassignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOnUnassignMutation, { data, loading, error }] = useAddOnUnassignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOnUnassignMutation(
  baseOptions?: Apollo.MutationHookOptions<AddOnUnassignMutation, AddOnUnassignMutationVariables>
) {
  return Apollo.useMutation<AddOnUnassignMutation, AddOnUnassignMutationVariables>(
    AddOnUnassignDocument,
    baseOptions
  )
}
export type AddOnUnassignMutationHookResult = ReturnType<typeof useAddOnUnassignMutation>
export type AddOnUnassignMutationResult = Apollo.MutationResult<AddOnUnassignMutation>
export type AddOnUnassignMutationOptions = Apollo.BaseMutationOptions<
  AddOnUnassignMutation,
  AddOnUnassignMutationVariables
>
export const AssignmentAuthenticateDocument = gql`
  mutation AssignmentAuthenticate($input: AssignmentAuthenticateInput!) {
    assignmentAuthenticate(input: $input) {
      accessToken
      conferenceSlug
      clientMutationId
      userErrors {
        message
        path
      }
    }
  }
`
export type AssignmentAuthenticateMutationFn = Apollo.MutationFunction<
  AssignmentAuthenticateMutation,
  AssignmentAuthenticateMutationVariables
>

/**
 * __useAssignmentAuthenticateMutation__
 *
 * To run a mutation, you first call `useAssignmentAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignmentAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignmentAuthenticateMutation, { data, loading, error }] = useAssignmentAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignmentAuthenticateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignmentAuthenticateMutation,
    AssignmentAuthenticateMutationVariables
  >
) {
  return Apollo.useMutation<
    AssignmentAuthenticateMutation,
    AssignmentAuthenticateMutationVariables
  >(AssignmentAuthenticateDocument, baseOptions)
}
export type AssignmentAuthenticateMutationHookResult = ReturnType<
  typeof useAssignmentAuthenticateMutation
>
export type AssignmentAuthenticateMutationResult = Apollo.MutationResult<
  AssignmentAuthenticateMutation
>
export type AssignmentAuthenticateMutationOptions = Apollo.BaseMutationOptions<
  AssignmentAuthenticateMutation,
  AssignmentAuthenticateMutationVariables
>
export const ProfileUpdateDocument = gql`
  mutation profileUpdate($profile: AssignmentProfileUpdateInput!) {
    assignmentProfileUpdate(input: $profile) {
      successMessage
      userErrors {
        path
        message
      }
      assignee {
        email
        firstName
        lastName
        jobTitle
        companyName
        companySizeId
        industryId
        phoneNumber
        city
        marketingConsent
        personalisationConsent
        partnerSharingConsent
        washingtonPostConsent
        passportNumber
      }
    }
  }
`
export type ProfileUpdateMutationFn = Apollo.MutationFunction<
  ProfileUpdateMutation,
  ProfileUpdateMutationVariables
>

/**
 * __useProfileUpdateMutation__
 *
 * To run a mutation, you first call `useProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdateMutation, { data, loading, error }] = useProfileUpdateMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useProfileUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>
) {
  return Apollo.useMutation<ProfileUpdateMutation, ProfileUpdateMutationVariables>(
    ProfileUpdateDocument,
    baseOptions
  )
}
export type ProfileUpdateMutationHookResult = ReturnType<typeof useProfileUpdateMutation>
export type ProfileUpdateMutationResult = Apollo.MutationResult<ProfileUpdateMutation>
export type ProfileUpdateMutationOptions = Apollo.BaseMutationOptions<
  ProfileUpdateMutation,
  ProfileUpdateMutationVariables
>
export const CreateOrderDocument = gql`
  mutation createOrder($storeId: ID, $commerceOrderCreate: CommerceOrderCreate!) {
    commerceCreateOrder(storeId: $storeId, commerceOrderCreate: $commerceOrderCreate) {
      id
      url
      reference
      currency
      invoiceUrl
      intraEU
      locked
      paymentMethod {
        id
        gateway
      }
      customer {
        id
        firstName
        lastName
        email
        vatNumber
        vatVerified
        companyName
        address {
          id
          line1
          line2
          city
          country
          postalCode
        }
      }
      discountCodes
      discountTotal
      paymentStatus
      status
      valueTotal
      total
      subTotal
      taxTotal
      metadata
      taxes {
        name
        total
        rateAmount
        rateType
      }
      codes {
        slug
        deal {
          active
          name
          description
          endDate
          dealItems {
            id
            min
            max
            amount
            product {
              id
            }
            step
            type
          }
          id
        }
        voucher {
          active
          name
          description
          id
        }
        id
        type
      }
      items {
        id
        itemName
        price
        quantity
        subTotal
        total
        metadata
        product {
          id
          onSale
          name
          taxMode
          metadata
        }
      }
      transactions {
        amount
        metadata
        status
        lastUpdatedAt
        type
        paymentMethod {
          id
        }
      }
    }
  }
`
export type CreateOrderMutationFn = Apollo.MutationFunction<
  CreateOrderMutation,
  CreateOrderMutationVariables
>

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      commerceOrderCreate: // value for 'commerceOrderCreate'
 *   },
 * });
 */
export function useCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>
) {
  return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(
    CreateOrderDocument,
    baseOptions
  )
}
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateOrderMutation,
  CreateOrderMutationVariables
>
export const TicketMagicLoginLinkRequestDocument = gql`
  mutation TicketMagicLoginLinkRequest($input: AssignmentMagicLinkLoginRequestInput!) {
    assignmentMagicLinkLoginRequest(input: $input) {
      userErrors {
        message
        path
      }
    }
  }
`
export type TicketMagicLoginLinkRequestMutationFn = Apollo.MutationFunction<
  TicketMagicLoginLinkRequestMutation,
  TicketMagicLoginLinkRequestMutationVariables
>

/**
 * __useTicketMagicLoginLinkRequestMutation__
 *
 * To run a mutation, you first call `useTicketMagicLoginLinkRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTicketMagicLoginLinkRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ticketMagicLoginLinkRequestMutation, { data, loading, error }] = useTicketMagicLoginLinkRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTicketMagicLoginLinkRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TicketMagicLoginLinkRequestMutation,
    TicketMagicLoginLinkRequestMutationVariables
  >
) {
  return Apollo.useMutation<
    TicketMagicLoginLinkRequestMutation,
    TicketMagicLoginLinkRequestMutationVariables
  >(TicketMagicLoginLinkRequestDocument, baseOptions)
}
export type TicketMagicLoginLinkRequestMutationHookResult = ReturnType<
  typeof useTicketMagicLoginLinkRequestMutation
>
export type TicketMagicLoginLinkRequestMutationResult = Apollo.MutationResult<
  TicketMagicLoginLinkRequestMutation
>
export type TicketMagicLoginLinkRequestMutationOptions = Apollo.BaseMutationOptions<
  TicketMagicLoginLinkRequestMutation,
  TicketMagicLoginLinkRequestMutationVariables
>
export const TicketAcceptDocument = gql`
  mutation TicketAccept($ticketId: ID!) {
    ticketAccept(input: { ticketId: $ticketId }) {
      ticket {
        id
        assignment {
          id
          state
        }
        context {
          assignable
          editable
          acceptable
          rejectable
        }
      }
      userErrors {
        message
        path
      }
    }
  }
`
export type TicketAcceptMutationFn = Apollo.MutationFunction<
  TicketAcceptMutation,
  TicketAcceptMutationVariables
>

/**
 * __useTicketAcceptMutation__
 *
 * To run a mutation, you first call `useTicketAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTicketAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ticketAcceptMutation, { data, loading, error }] = useTicketAcceptMutation({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useTicketAcceptMutation(
  baseOptions?: Apollo.MutationHookOptions<TicketAcceptMutation, TicketAcceptMutationVariables>
) {
  return Apollo.useMutation<TicketAcceptMutation, TicketAcceptMutationVariables>(
    TicketAcceptDocument,
    baseOptions
  )
}
export type TicketAcceptMutationHookResult = ReturnType<typeof useTicketAcceptMutation>
export type TicketAcceptMutationResult = Apollo.MutationResult<TicketAcceptMutation>
export type TicketAcceptMutationOptions = Apollo.BaseMutationOptions<
  TicketAcceptMutation,
  TicketAcceptMutationVariables
>
export const TicketAssignDocument = gql`
  mutation TicketAssign($firstName: String!, $lastName: String, $email: String!, $ticketId: ID!) {
    ticketAssign(
      input: { firstName: $firstName, lastName: $lastName, email: $email, ticketId: $ticketId }
    ) {
      ticket {
        id
        assignment {
          id
          state
          assignee {
            id
            firstName
            lastName
            email
            me
          }
        }
        context {
          assignable
          editable
          acceptable
          rejectable
        }
      }
      userErrors {
        message
        path
      }
    }
  }
`
export type TicketAssignMutationFn = Apollo.MutationFunction<
  TicketAssignMutation,
  TicketAssignMutationVariables
>

/**
 * __useTicketAssignMutation__
 *
 * To run a mutation, you first call `useTicketAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTicketAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ticketAssignMutation, { data, loading, error }] = useTicketAssignMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useTicketAssignMutation(
  baseOptions?: Apollo.MutationHookOptions<TicketAssignMutation, TicketAssignMutationVariables>
) {
  return Apollo.useMutation<TicketAssignMutation, TicketAssignMutationVariables>(
    TicketAssignDocument,
    baseOptions
  )
}
export type TicketAssignMutationHookResult = ReturnType<typeof useTicketAssignMutation>
export type TicketAssignMutationResult = Apollo.MutationResult<TicketAssignMutation>
export type TicketAssignMutationOptions = Apollo.BaseMutationOptions<
  TicketAssignMutation,
  TicketAssignMutationVariables
>
export const TicketRejectDocument = gql`
  mutation TicketReject($ticketId: ID!) {
    ticketReject(input: { ticketId: $ticketId }) {
      ticket {
        id
        assignment {
          id
        }
        context {
          assignable
          editable
          acceptable
          rejectable
        }
      }
      userErrors {
        message
        path
      }
    }
  }
`
export type TicketRejectMutationFn = Apollo.MutationFunction<
  TicketRejectMutation,
  TicketRejectMutationVariables
>

/**
 * __useTicketRejectMutation__
 *
 * To run a mutation, you first call `useTicketRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTicketRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ticketRejectMutation, { data, loading, error }] = useTicketRejectMutation({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useTicketRejectMutation(
  baseOptions?: Apollo.MutationHookOptions<TicketRejectMutation, TicketRejectMutationVariables>
) {
  return Apollo.useMutation<TicketRejectMutation, TicketRejectMutationVariables>(
    TicketRejectDocument,
    baseOptions
  )
}
export type TicketRejectMutationHookResult = ReturnType<typeof useTicketRejectMutation>
export type TicketRejectMutationResult = Apollo.MutationResult<TicketRejectMutation>
export type TicketRejectMutationOptions = Apollo.BaseMutationOptions<
  TicketRejectMutation,
  TicketRejectMutationVariables
>
export const TicketSetLeadScanningDocument = gql`
  mutation TicketSetLeadScanning($input: TicketSetLeadScanningInput!) {
    ticketSetLeadScanning(input: $input) {
      ticket {
        id
      }
      status
      userErrors {
        message
      }
    }
  }
`
export type TicketSetLeadScanningMutationFn = Apollo.MutationFunction<
  TicketSetLeadScanningMutation,
  TicketSetLeadScanningMutationVariables
>

/**
 * __useTicketSetLeadScanningMutation__
 *
 * To run a mutation, you first call `useTicketSetLeadScanningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTicketSetLeadScanningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ticketSetLeadScanningMutation, { data, loading, error }] = useTicketSetLeadScanningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTicketSetLeadScanningMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TicketSetLeadScanningMutation,
    TicketSetLeadScanningMutationVariables
  >
) {
  return Apollo.useMutation<TicketSetLeadScanningMutation, TicketSetLeadScanningMutationVariables>(
    TicketSetLeadScanningDocument,
    baseOptions
  )
}
export type TicketSetLeadScanningMutationHookResult = ReturnType<
  typeof useTicketSetLeadScanningMutation
>
export type TicketSetLeadScanningMutationResult = Apollo.MutationResult<
  TicketSetLeadScanningMutation
>
export type TicketSetLeadScanningMutationOptions = Apollo.BaseMutationOptions<
  TicketSetLeadScanningMutation,
  TicketSetLeadScanningMutationVariables
>
export const UpdateOrderDocument = gql`
  mutation updateOrder($id: ID!, $commerceOrderUpdate: CommerceOrderUpdate!) {
    commerceUpdateOrder(id: $id, commerceOrderUpdate: $commerceOrderUpdate) {
      id
      url
      reference
      currency
      invoiceUrl
      intraEU
      locked
      paymentMethod {
        id
        gateway
      }
      customer {
        id
        firstName
        lastName
        email
        vatNumber
        vatVerified
        companyName
        address {
          id
          line1
          line2
          city
          country
          postalCode
          state
        }
      }
      discountTotal
      paymentStatus
      status
      valueTotal
      total
      subTotal
      taxTotal
      metadata
      taxes {
        name
        total
        rateAmount
        rateType
      }
      codes {
        slug
        deal {
          active
          name
          description
          endDate
          dealItems {
            id
            min
            max
            amount
            product {
              id
            }
            step
            type
          }
          id
        }
        voucher {
          active
          name
          description
          id
        }
        id
        type
      }
      discountCodes
      items {
        id
        itemName
        price
        quantity
        subTotal
        total
        metadata
        itemName
        product {
          id
          onSale
          name
          taxMode
          metadata
        }
      }
      transactions {
        amount
        metadata
        status
        lastUpdatedAt
        type
        paymentMethod {
          id
        }
      }
    }
  }
`
export type UpdateOrderMutationFn = Apollo.MutationFunction<
  UpdateOrderMutation,
  UpdateOrderMutationVariables
>

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      commerceOrderUpdate: // value for 'commerceOrderUpdate'
 *   },
 * });
 */
export function useUpdateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>
) {
  return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(
    UpdateOrderDocument,
    baseOptions
  )
}
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrderMutation,
  UpdateOrderMutationVariables
>
export const GetDealDocument = gql`
  query getDeal($id: ID!) {
    commerceGetDeal(id: $id) {
      id
      name
      active
      description
      dealItems {
        amount
        min
        type
        product {
          id
          price
          tags {
            id
            name
            description
            code
          }
          name
          active
          taxType {
            taxes {
              name
              rateAmount
              rateType
              country
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetDealQuery__
 *
 * To run a query within a React component, call `useGetDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDealQuery(
  baseOptions: Apollo.QueryHookOptions<GetDealQuery, GetDealQueryVariables>
) {
  return Apollo.useQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, baseOptions)
}
export function useGetDealLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDealQuery, GetDealQueryVariables>
) {
  return Apollo.useLazyQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, baseOptions)
}
export type GetDealQueryHookResult = ReturnType<typeof useGetDealQuery>
export type GetDealLazyQueryHookResult = ReturnType<typeof useGetDealLazyQuery>
export type GetDealQueryResult = Apollo.QueryResult<GetDealQuery, GetDealQueryVariables>
export const CommerceGetOrderDocument = gql`
  query CommerceGetOrder($id: ID!, $validateOrder: Boolean) {
    commerceGetOrder(id: $id, validateOrder: $validateOrder) {
      id
      url
      reference
      currency
      invoiceUrl
      intraEU
      locked
      paymentMethod {
        id
        gateway
      }
      customer {
        id
        firstName
        lastName
        email
        vatNumber
        vatVerified
        companyName
        address {
          id
          line1
          line2
          city
          state
          country
          postalCode
        }
      }
      discountCodes
      discountTotal
      paymentStatus
      status
      valueTotal
      total
      subTotal
      taxTotal
      metadata
      taxes {
        name
        total
        rateAmount
        rateType
      }
      codes {
        slug
        deal {
          active
          name
          description
          endDate
          dealItems {
            id
            min
            max
            amount
            product {
              id
            }
            step
            type
          }
          id
        }
        voucher {
          active
          name
          description
          id
        }
        id
        type
      }
      items {
        id
        itemName
        price
        quantity
        subTotal
        total
        metadata
        product {
          id
          onSale
          name
          taxMode
          metadata
        }
      }
      transactions {
        lastUpdatedAt
        type
        status
        amount
        paymentMethod {
          id
        }
        metadata
      }
    }
  }
`

/**
 * __useCommerceGetOrderQuery__
 *
 * To run a query within a React component, call `useCommerceGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommerceGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommerceGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      validateOrder: // value for 'validateOrder'
 *   },
 * });
 */
export function useCommerceGetOrderQuery(
  baseOptions: Apollo.QueryHookOptions<CommerceGetOrderQuery, CommerceGetOrderQueryVariables>
) {
  return Apollo.useQuery<CommerceGetOrderQuery, CommerceGetOrderQueryVariables>(
    CommerceGetOrderDocument,
    baseOptions
  )
}
export function useCommerceGetOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CommerceGetOrderQuery, CommerceGetOrderQueryVariables>
) {
  return Apollo.useLazyQuery<CommerceGetOrderQuery, CommerceGetOrderQueryVariables>(
    CommerceGetOrderDocument,
    baseOptions
  )
}
export type CommerceGetOrderQueryHookResult = ReturnType<typeof useCommerceGetOrderQuery>
export type CommerceGetOrderLazyQueryHookResult = ReturnType<typeof useCommerceGetOrderLazyQuery>
export type CommerceGetOrderQueryResult = Apollo.QueryResult<
  CommerceGetOrderQuery,
  CommerceGetOrderQueryVariables
>
export const GetProductDocument = gql`
  query getProduct($id: ID!, $storeId: ID!) {
    commerceGetProduct(id: $id, storeId: $storeId) {
      id
      active
      name
      description
      price
      taxType {
        taxes {
          rateAmount
          rateType
          country
          name
        }
      }
      taxMode
      tags {
        id
        name
        description
        code
      }
    }
  }
`

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useGetProductQuery(
  baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>
) {
  return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, baseOptions)
}
export function useGetProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>
) {
  return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(
    GetProductDocument,
    baseOptions
  )
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>
export const CommerceGetStoreDocument = gql`
  query CommerceGetStore {
    commerceGetStore {
      id
      slug
      country
      currency
      currencySymbol
      storeBilling {
        country
      }
      paymentMethods {
        id
        name
        active
        gateway
        configuration
      }
    }
  }
`

/**
 * __useCommerceGetStoreQuery__
 *
 * To run a query within a React component, call `useCommerceGetStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommerceGetStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommerceGetStoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommerceGetStoreQuery(
  baseOptions?: Apollo.QueryHookOptions<CommerceGetStoreQuery, CommerceGetStoreQueryVariables>
) {
  return Apollo.useQuery<CommerceGetStoreQuery, CommerceGetStoreQueryVariables>(
    CommerceGetStoreDocument,
    baseOptions
  )
}
export function useCommerceGetStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CommerceGetStoreQuery, CommerceGetStoreQueryVariables>
) {
  return Apollo.useLazyQuery<CommerceGetStoreQuery, CommerceGetStoreQueryVariables>(
    CommerceGetStoreDocument,
    baseOptions
  )
}
export type CommerceGetStoreQueryHookResult = ReturnType<typeof useCommerceGetStoreQuery>
export type CommerceGetStoreLazyQueryHookResult = ReturnType<typeof useCommerceGetStoreLazyQuery>
export type CommerceGetStoreQueryResult = Apollo.QueryResult<
  CommerceGetStoreQuery,
  CommerceGetStoreQueryVariables
>
export const ListProductsDocument = gql`
  query listProducts(
    $page: Int
    $pageSize: Int
    $sort: [CommerceSortTerm!]
    $terms: [[CommerceSearchTerm!]]
  ) {
    commerceListProducts(page: $page, pageSize: $pageSize, sort: $sort, terms: $terms) {
      content {
        id
        active
        name
        description
        price
        taxType {
          taxes {
            rateAmount
            rateType
            country
            name
          }
        }
        taxMode
        tags {
          id
          name
          description
          code
        }
      }
    }
  }
`

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sort: // value for 'sort'
 *      terms: // value for 'terms'
 *   },
 * });
 */
export function useListProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListProductsQuery, ListProductsQueryVariables>
) {
  return Apollo.useQuery<ListProductsQuery, ListProductsQueryVariables>(
    ListProductsDocument,
    baseOptions
  )
}
export function useListProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>
) {
  return Apollo.useLazyQuery<ListProductsQuery, ListProductsQueryVariables>(
    ListProductsDocument,
    baseOptions
  )
}
export type ListProductsQueryHookResult = ReturnType<typeof useListProductsQuery>
export type ListProductsLazyQueryHookResult = ReturnType<typeof useListProductsLazyQuery>
export type ListProductsQueryResult = Apollo.QueryResult<
  ListProductsQuery,
  ListProductsQueryVariables
>
export const ListSalesDocument = gql`
  query listSales(
    $page: Int
    $pageSize: Int
    $sort: [CommerceSortTerm!]
    $terms: [[CommerceSearchTerm!]]
  ) {
    commerceListSales(page: $page, pageSize: $pageSize, sort: $sort, terms: $terms) {
      content {
        id
        name
        description
        active
        startDate
        endDate
      }
    }
  }
`

/**
 * __useListSalesQuery__
 *
 * To run a query within a React component, call `useListSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSalesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sort: // value for 'sort'
 *      terms: // value for 'terms'
 *   },
 * });
 */
export function useListSalesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListSalesQuery, ListSalesQueryVariables>
) {
  return Apollo.useQuery<ListSalesQuery, ListSalesQueryVariables>(ListSalesDocument, baseOptions)
}
export function useListSalesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSalesQuery, ListSalesQueryVariables>
) {
  return Apollo.useLazyQuery<ListSalesQuery, ListSalesQueryVariables>(
    ListSalesDocument,
    baseOptions
  )
}
export type ListSalesQueryHookResult = ReturnType<typeof useListSalesQuery>
export type ListSalesLazyQueryHookResult = ReturnType<typeof useListSalesLazyQuery>
export type ListSalesQueryResult = Apollo.QueryResult<ListSalesQuery, ListSalesQueryVariables>
export const GetEventLinksDocument = gql`
  query GetEventLinks($slug: String) {
    event(slug: $slug) {
      baseUrl
      publicDomain
      supportLink
    }
  }
`

/**
 * __useGetEventLinksQuery__
 *
 * To run a query within a React component, call `useGetEventLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLinksQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetEventLinksQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEventLinksQuery, GetEventLinksQueryVariables>
) {
  return Apollo.useQuery<GetEventLinksQuery, GetEventLinksQueryVariables>(
    GetEventLinksDocument,
    baseOptions
  )
}
export function useGetEventLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEventLinksQuery, GetEventLinksQueryVariables>
) {
  return Apollo.useLazyQuery<GetEventLinksQuery, GetEventLinksQueryVariables>(
    GetEventLinksDocument,
    baseOptions
  )
}
export type GetEventLinksQueryHookResult = ReturnType<typeof useGetEventLinksQuery>
export type GetEventLinksLazyQueryHookResult = ReturnType<typeof useGetEventLinksLazyQuery>
export type GetEventLinksQueryResult = Apollo.QueryResult<
  GetEventLinksQuery,
  GetEventLinksQueryVariables
>
export const TaEventDataDocument = gql`
  query taEventData($slug: String!) {
    taEvent(slug: $slug) {
      id
      slug
      name
      industries
      companySizes
      passportRequired
      sponsorName
      sponsorPrivacyPolicyUrl
    }
  }
`

/**
 * __useTaEventDataQuery__
 *
 * To run a query within a React component, call `useTaEventDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaEventDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaEventDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTaEventDataQuery(
  baseOptions: Apollo.QueryHookOptions<TaEventDataQuery, TaEventDataQueryVariables>
) {
  return Apollo.useQuery<TaEventDataQuery, TaEventDataQueryVariables>(
    TaEventDataDocument,
    baseOptions
  )
}
export function useTaEventDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TaEventDataQuery, TaEventDataQueryVariables>
) {
  return Apollo.useLazyQuery<TaEventDataQuery, TaEventDataQueryVariables>(
    TaEventDataDocument,
    baseOptions
  )
}
export type TaEventDataQueryHookResult = ReturnType<typeof useTaEventDataQuery>
export type TaEventDataLazyQueryHookResult = ReturnType<typeof useTaEventDataLazyQuery>
export type TaEventDataQueryResult = Apollo.QueryResult<TaEventDataQuery, TaEventDataQueryVariables>
export const GetTimeslotDocument = gql`
  query GetTimeslot($timeslotSlug: String!) {
    event {
      id
      timezone
    }
    scheduleTimeslot(slug: $timeslotSlug) {
      id
      slug
      title
      description
      startsAt
      endsAt
      participants {
        edges {
          node {
            id
            name
            bio
            jobTitle
            avatarUrl
            companyName
          }
        }
      }
      calendarEventId
      location {
        name
      }
      channelUrl
      topics {
        id
        name
      }
    }
  }
`

/**
 * __useGetTimeslotQuery__
 *
 * To run a query within a React component, call `useGetTimeslotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeslotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeslotQuery({
 *   variables: {
 *      timeslotSlug: // value for 'timeslotSlug'
 *   },
 * });
 */
export function useGetTimeslotQuery(
  baseOptions: Apollo.QueryHookOptions<GetTimeslotQuery, GetTimeslotQueryVariables>
) {
  return Apollo.useQuery<GetTimeslotQuery, GetTimeslotQueryVariables>(
    GetTimeslotDocument,
    baseOptions
  )
}
export function useGetTimeslotLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTimeslotQuery, GetTimeslotQueryVariables>
) {
  return Apollo.useLazyQuery<GetTimeslotQuery, GetTimeslotQueryVariables>(
    GetTimeslotDocument,
    baseOptions
  )
}
export type GetTimeslotQueryHookResult = ReturnType<typeof useGetTimeslotQuery>
export type GetTimeslotLazyQueryHookResult = ReturnType<typeof useGetTimeslotLazyQuery>
export type GetTimeslotQueryResult = Apollo.QueryResult<GetTimeslotQuery, GetTimeslotQueryVariables>
export const GetTimeZoneDocument = gql`
  query GetTimeZone {
    event {
      id
      timeZone {
        ianaName
        displayName
      }
    }
  }
`

/**
 * __useGetTimeZoneQuery__
 *
 * To run a query within a React component, call `useGetTimeZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZoneQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimeZoneQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTimeZoneQuery, GetTimeZoneQueryVariables>
) {
  return Apollo.useQuery<GetTimeZoneQuery, GetTimeZoneQueryVariables>(
    GetTimeZoneDocument,
    baseOptions
  )
}
export function useGetTimeZoneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTimeZoneQuery, GetTimeZoneQueryVariables>
) {
  return Apollo.useLazyQuery<GetTimeZoneQuery, GetTimeZoneQueryVariables>(
    GetTimeZoneDocument,
    baseOptions
  )
}
export type GetTimeZoneQueryHookResult = ReturnType<typeof useGetTimeZoneQuery>
export type GetTimeZoneLazyQueryHookResult = ReturnType<typeof useGetTimeZoneLazyQuery>
export type GetTimeZoneQueryResult = Apollo.QueryResult<GetTimeZoneQuery, GetTimeZoneQueryVariables>
export const MyAssignmentDashboardDocument = gql`
  query MyAssignmentDashboard {
    assignmentUser {
      email
    }
    orders {
      edges {
        node {
          id
          reference
          amount
          currency
          summary {
            tickets
            ticketType {
              name
            }
          }
          completedAt
        }
      }
    }
  }
`

/**
 * __useMyAssignmentDashboardQuery__
 *
 * To run a query within a React component, call `useMyAssignmentDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAssignmentDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAssignmentDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAssignmentDashboardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyAssignmentDashboardQuery,
    MyAssignmentDashboardQueryVariables
  >
) {
  return Apollo.useQuery<MyAssignmentDashboardQuery, MyAssignmentDashboardQueryVariables>(
    MyAssignmentDashboardDocument,
    baseOptions
  )
}
export function useMyAssignmentDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyAssignmentDashboardQuery,
    MyAssignmentDashboardQueryVariables
  >
) {
  return Apollo.useLazyQuery<MyAssignmentDashboardQuery, MyAssignmentDashboardQueryVariables>(
    MyAssignmentDashboardDocument,
    baseOptions
  )
}
export type MyAssignmentDashboardQueryHookResult = ReturnType<typeof useMyAssignmentDashboardQuery>
export type MyAssignmentDashboardLazyQueryHookResult = ReturnType<
  typeof useMyAssignmentDashboardLazyQuery
>
export type MyAssignmentDashboardQueryResult = Apollo.QueryResult<
  MyAssignmentDashboardQuery,
  MyAssignmentDashboardQueryVariables
>
export const MyBookingAddonsDocument = gql`
  query MyBookingAddons(
    $reference: String!
    $after: String
    $before: String
    $filter: BookingAddOnFilter
    $first: Int
    $last: Int
    $offset: Int
    $search: String
    $sorter: [BookingAddOnSorter!]
  ) {
    booking(reference: $reference) {
      id
      reference
      addonTypesSummary {
        count
        id
        name
      }
      addOns(
        after: $after
        before: $before
        filter: $filter
        first: $first
        last: $last
        offset: $offset
        search: $search
        sorter: $sorter
      ) {
        totalCount
        edges {
          node {
            id
            addOnType {
              name
            }
            assignment {
              id
              state
              assignee {
                id
                me
                firstName
                lastName
                email
              }
            }
            state
          }
        }
      }
    }
  }
`

/**
 * __useMyBookingAddonsQuery__
 *
 * To run a query within a React component, call `useMyBookingAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBookingAddonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBookingAddonsQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useMyBookingAddonsQuery(
  baseOptions: Apollo.QueryHookOptions<MyBookingAddonsQuery, MyBookingAddonsQueryVariables>
) {
  return Apollo.useQuery<MyBookingAddonsQuery, MyBookingAddonsQueryVariables>(
    MyBookingAddonsDocument,
    baseOptions
  )
}
export function useMyBookingAddonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyBookingAddonsQuery, MyBookingAddonsQueryVariables>
) {
  return Apollo.useLazyQuery<MyBookingAddonsQuery, MyBookingAddonsQueryVariables>(
    MyBookingAddonsDocument,
    baseOptions
  )
}
export type MyBookingAddonsQueryHookResult = ReturnType<typeof useMyBookingAddonsQuery>
export type MyBookingAddonsLazyQueryHookResult = ReturnType<typeof useMyBookingAddonsLazyQuery>
export type MyBookingAddonsQueryResult = Apollo.QueryResult<
  MyBookingAddonsQuery,
  MyBookingAddonsQueryVariables
>
export const MyBookingHiddenTicketsDocument = gql`
  query MyBookingHiddenTickets(
    $reference: String!
    $after: String
    $before: String
    $filterV2: BookingTicketFilter
    $first: Int
    $last: Int
    $offset: Int
    $onlyHidden: Boolean
    $search: String
    $sorter: [BookingTicketSorter!]
  ) {
    booking(reference: $reference) {
      reference
      tickets(
        after: $after
        before: $before
        filterV2: $filterV2
        first: $first
        last: $last
        offset: $offset
        onlyHidden: $onlyHidden
        search: $search
        sorter: $sorter
      ) {
        edges {
          node {
            bookingRef
            order {
              reference
            }
          }
        }
      }
    }
  }
`

/**
 * __useMyBookingHiddenTicketsQuery__
 *
 * To run a query within a React component, call `useMyBookingHiddenTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBookingHiddenTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBookingHiddenTicketsQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filterV2: // value for 'filterV2'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      offset: // value for 'offset'
 *      onlyHidden: // value for 'onlyHidden'
 *      search: // value for 'search'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useMyBookingHiddenTicketsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyBookingHiddenTicketsQuery,
    MyBookingHiddenTicketsQueryVariables
  >
) {
  return Apollo.useQuery<MyBookingHiddenTicketsQuery, MyBookingHiddenTicketsQueryVariables>(
    MyBookingHiddenTicketsDocument,
    baseOptions
  )
}
export function useMyBookingHiddenTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyBookingHiddenTicketsQuery,
    MyBookingHiddenTicketsQueryVariables
  >
) {
  return Apollo.useLazyQuery<MyBookingHiddenTicketsQuery, MyBookingHiddenTicketsQueryVariables>(
    MyBookingHiddenTicketsDocument,
    baseOptions
  )
}
export type MyBookingHiddenTicketsQueryHookResult = ReturnType<
  typeof useMyBookingHiddenTicketsQuery
>
export type MyBookingHiddenTicketsLazyQueryHookResult = ReturnType<
  typeof useMyBookingHiddenTicketsLazyQuery
>
export type MyBookingHiddenTicketsQueryResult = Apollo.QueryResult<
  MyBookingHiddenTicketsQuery,
  MyBookingHiddenTicketsQueryVariables
>
export const MyBookingOrdersDocument = gql`
  query MyBookingOrders(
    $reference: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $offset: Int
    $onlyWithInvoices: Boolean
  ) {
    booking(reference: $reference) {
      id
      orders(
        after: $after
        before: $before
        first: $first
        last: $last
        offset: $offset
        onlyWithInvoices: $onlyWithInvoices
      ) {
        edges {
          node {
            invoiceUrl
            completedAt
            reference
          }
        }
      }
    }
  }
`

/**
 * __useMyBookingOrdersQuery__
 *
 * To run a query within a React component, call `useMyBookingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBookingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBookingOrdersQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      offset: // value for 'offset'
 *      onlyWithInvoices: // value for 'onlyWithInvoices'
 *   },
 * });
 */
export function useMyBookingOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<MyBookingOrdersQuery, MyBookingOrdersQueryVariables>
) {
  return Apollo.useQuery<MyBookingOrdersQuery, MyBookingOrdersQueryVariables>(
    MyBookingOrdersDocument,
    baseOptions
  )
}
export function useMyBookingOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyBookingOrdersQuery, MyBookingOrdersQueryVariables>
) {
  return Apollo.useLazyQuery<MyBookingOrdersQuery, MyBookingOrdersQueryVariables>(
    MyBookingOrdersDocument,
    baseOptions
  )
}
export type MyBookingOrdersQueryHookResult = ReturnType<typeof useMyBookingOrdersQuery>
export type MyBookingOrdersLazyQueryHookResult = ReturnType<typeof useMyBookingOrdersLazyQuery>
export type MyBookingOrdersQueryResult = Apollo.QueryResult<
  MyBookingOrdersQuery,
  MyBookingOrdersQueryVariables
>
export const MyBookingTicketsDocument = gql`
  query MyBookingTickets(
    $reference: String!
    $after: String
    $before: String
    $filterV2: BookingTicketFilter
    $first: Int
    $last: Int
    $offset: Int
    $search: String
    $sorter: [BookingTicketSorter!]
  ) {
    booking(reference: $reference) {
      id
      reference
      ticketTypesSummary {
        count
        id
        name
      }
      tickets(
        after: $after
        before: $before
        filterV2: $filterV2
        first: $first
        last: $last
        offset: $offset
        search: $search
        sorter: $sorter
      ) {
        totalCount
        edges {
          node {
            id
            bookingRef
            state
            context {
              acceptable
              assignable
              editable
              rejectable
            }
            acceptedAddOns {
              edges {
                node {
                  id
                  addOnType {
                    id
                    name
                    description
                  }
                  assignment {
                    id
                    state
                    assignee {
                      id
                      me
                      firstName
                      lastName
                      email
                    }
                  }
                  state
                }
              }
            }
            ticketType {
              name
              leadScanning
            }
            order {
              owner {
                firstName
                lastName
                email
                me
              }
            }
            assignment {
              id
              state
              leadScanningActive
              appLoginEmail
              assignee {
                id
                firstName
                lastName
                email
                me
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useMyBookingTicketsQuery__
 *
 * To run a query within a React component, call `useMyBookingTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBookingTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBookingTicketsQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filterV2: // value for 'filterV2'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useMyBookingTicketsQuery(
  baseOptions: Apollo.QueryHookOptions<MyBookingTicketsQuery, MyBookingTicketsQueryVariables>
) {
  return Apollo.useQuery<MyBookingTicketsQuery, MyBookingTicketsQueryVariables>(
    MyBookingTicketsDocument,
    baseOptions
  )
}
export function useMyBookingTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyBookingTicketsQuery, MyBookingTicketsQueryVariables>
) {
  return Apollo.useLazyQuery<MyBookingTicketsQuery, MyBookingTicketsQueryVariables>(
    MyBookingTicketsDocument,
    baseOptions
  )
}
export type MyBookingTicketsQueryHookResult = ReturnType<typeof useMyBookingTicketsQuery>
export type MyBookingTicketsLazyQueryHookResult = ReturnType<typeof useMyBookingTicketsLazyQuery>
export type MyBookingTicketsQueryResult = Apollo.QueryResult<
  MyBookingTicketsQuery,
  MyBookingTicketsQueryVariables
>
export const MyBookingUpgradesDocument = gql`
  query MyBookingUpgrades(
    $reference: String!
    $after: String
    $before: String
    $filter: BookingUpgradeFilter
    $first: Int
    $last: Int
    $offset: Int
    $search: String
    $sorter: [BookingUpgradeSorter!]
  ) {
    booking(reference: $reference) {
      id
      reference
      upgradeTypesSummary {
        count
        id
        name
      }
      ticketUpgrades(
        after: $after
        before: $before
        filter: $filter
        first: $first
        last: $last
        offset: $offset
        search: $search
        sorter: $sorter
      ) {
        totalCount
        edges {
          node {
            id
            ticketUpgradeType {
              name
            }
            assignment {
              id
              state
              assignee {
                id
                me
                firstName
                lastName
                email
              }
            }
            state
          }
        }
      }
    }
  }
`

/**
 * __useMyBookingUpgradesQuery__
 *
 * To run a query within a React component, call `useMyBookingUpgradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBookingUpgradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBookingUpgradesQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useMyBookingUpgradesQuery(
  baseOptions: Apollo.QueryHookOptions<MyBookingUpgradesQuery, MyBookingUpgradesQueryVariables>
) {
  return Apollo.useQuery<MyBookingUpgradesQuery, MyBookingUpgradesQueryVariables>(
    MyBookingUpgradesDocument,
    baseOptions
  )
}
export function useMyBookingUpgradesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyBookingUpgradesQuery, MyBookingUpgradesQueryVariables>
) {
  return Apollo.useLazyQuery<MyBookingUpgradesQuery, MyBookingUpgradesQueryVariables>(
    MyBookingUpgradesDocument,
    baseOptions
  )
}
export type MyBookingUpgradesQueryHookResult = ReturnType<typeof useMyBookingUpgradesQuery>
export type MyBookingUpgradesLazyQueryHookResult = ReturnType<typeof useMyBookingUpgradesLazyQuery>
export type MyBookingUpgradesQueryResult = Apollo.QueryResult<
  MyBookingUpgradesQuery,
  MyBookingUpgradesQueryVariables
>
export const MyBookingsDocument = gql`
  query MyBookings($filter: BookingFilter, $search: String) {
    bookings(filter: $filter, searchQuery: $search) {
      edges {
        node {
          reference
          tickets {
            totalCount
          }
          totalHiddenTickets
          totalInvoices
          addOns {
            totalCount
          }
          ticketUpgrades {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useMyBookingsQuery__
 *
 * To run a query within a React component, call `useMyBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBookingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMyBookingsQuery(
  baseOptions?: Apollo.QueryHookOptions<MyBookingsQuery, MyBookingsQueryVariables>
) {
  return Apollo.useQuery<MyBookingsQuery, MyBookingsQueryVariables>(MyBookingsDocument, baseOptions)
}
export function useMyBookingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyBookingsQuery, MyBookingsQueryVariables>
) {
  return Apollo.useLazyQuery<MyBookingsQuery, MyBookingsQueryVariables>(
    MyBookingsDocument,
    baseOptions
  )
}
export type MyBookingsQueryHookResult = ReturnType<typeof useMyBookingsQuery>
export type MyBookingsLazyQueryHookResult = ReturnType<typeof useMyBookingsLazyQuery>
export type MyBookingsQueryResult = Apollo.QueryResult<MyBookingsQuery, MyBookingsQueryVariables>
export const MyDashboardDocument = gql`
  query MyDashboard {
    orders {
      edges {
        node {
          id
        }
      }
    }
    tickets {
      edges {
        node {
          id
        }
      }
    }
  }
`

/**
 * __useMyDashboardQuery__
 *
 * To run a query within a React component, call `useMyDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDashboardQuery(
  baseOptions?: Apollo.QueryHookOptions<MyDashboardQuery, MyDashboardQueryVariables>
) {
  return Apollo.useQuery<MyDashboardQuery, MyDashboardQueryVariables>(
    MyDashboardDocument,
    baseOptions
  )
}
export function useMyDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyDashboardQuery, MyDashboardQueryVariables>
) {
  return Apollo.useLazyQuery<MyDashboardQuery, MyDashboardQueryVariables>(
    MyDashboardDocument,
    baseOptions
  )
}
export type MyDashboardQueryHookResult = ReturnType<typeof useMyDashboardQuery>
export type MyDashboardLazyQueryHookResult = ReturnType<typeof useMyDashboardLazyQuery>
export type MyDashboardQueryResult = Apollo.QueryResult<MyDashboardQuery, MyDashboardQueryVariables>
export const MyOrdersDocument = gql`
  query MyOrders {
    orders {
      edges {
        node {
          id
          reference
          currency
          invoiceUrl
          summary {
            addOns
            addOnType {
              name
            }
            tickets
            ticketType {
              name
            }
            ticketUpgrades
            ticketUpgradeType {
              name
            }
          }
          completedAt
          tickets {
            edges {
              node {
                id
                bookingRef
                ticketType {
                  hidden
                  leadScanning
                }
                assignment {
                  id
                  leadScanningActive
                }
              }
            }
          }
          ticketUpgrades {
            edges {
              node {
                ticketUpgradeType {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useMyOrdersQuery__
 *
 * To run a query within a React component, call `useMyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables>
) {
  return Apollo.useQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, baseOptions)
}
export function useMyOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables>
) {
  return Apollo.useLazyQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, baseOptions)
}
export type MyOrdersQueryHookResult = ReturnType<typeof useMyOrdersQuery>
export type MyOrdersLazyQueryHookResult = ReturnType<typeof useMyOrdersLazyQuery>
export type MyOrdersQueryResult = Apollo.QueryResult<MyOrdersQuery, MyOrdersQueryVariables>
export const MyTicketsDocument = gql`
  query MyTickets(
    $bookingId: ID
    $orderId: ID
    $filter: TicketFilter
    $searchQuery: String
    $first: Int
    $offset: Int
    $after: String
    $before: String
    $last: Int
    $sorter: [TicketSorter!]
  ) {
    tickets(
      bookingId: $bookingId
      orderId: $orderId
      filter: $filter
      after: $after
      before: $before
      first: $first
      offset: $offset
      last: $last
      searchQuery: $searchQuery
      sorter: $sorter
    ) {
      edges {
        node {
          id
          bookingRef
          order {
            owner {
              me
            }
          }
          ticketType {
            name
            hidden
            leadScanning
          }
          acceptedAddOns {
            edges {
              node {
                id
                addOnType {
                  id
                  name
                  description
                }
                state
              }
            }
          }
          assignment {
            id
            state
            appLoginEmail
            leadScanningActive
            assignee {
              id
              me
              firstName
              lastName
              email
              phoneNumber
              city
              companyName
              companySizeId
              industryId
              jobTitle
              marketingConsent
              passportNumber
              personalisationConsent
              partnerSharingConsent
              washingtonPostConsent
            }
          }
          state
          context {
            assignable
            editable
            acceptable
            rejectable
          }
        }
      }
    }
  }
`

/**
 * __useMyTicketsQuery__
 *
 * To run a query within a React component, call `useMyTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTicketsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      orderId: // value for 'orderId'
 *      filter: // value for 'filter'
 *      searchQuery: // value for 'searchQuery'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useMyTicketsQuery(
  baseOptions?: Apollo.QueryHookOptions<MyTicketsQuery, MyTicketsQueryVariables>
) {
  return Apollo.useQuery<MyTicketsQuery, MyTicketsQueryVariables>(MyTicketsDocument, baseOptions)
}
export function useMyTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyTicketsQuery, MyTicketsQueryVariables>
) {
  return Apollo.useLazyQuery<MyTicketsQuery, MyTicketsQueryVariables>(
    MyTicketsDocument,
    baseOptions
  )
}
export type MyTicketsQueryHookResult = ReturnType<typeof useMyTicketsQuery>
export type MyTicketsLazyQueryHookResult = ReturnType<typeof useMyTicketsLazyQuery>
export type MyTicketsQueryResult = Apollo.QueryResult<MyTicketsQuery, MyTicketsQueryVariables>
export const OrderTicketsLiteDocument = gql`
  query OrderTicketsLite($reference: String!) {
    order(reference: $reference) {
      tickets {
        edges {
          node {
            id
            bookingRef
            ticketType {
              hidden
            }
          }
        }
      }
    }
  }
`

/**
 * __useOrderTicketsLiteQuery__
 *
 * To run a query within a React component, call `useOrderTicketsLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderTicketsLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderTicketsLiteQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useOrderTicketsLiteQuery(
  baseOptions: Apollo.QueryHookOptions<OrderTicketsLiteQuery, OrderTicketsLiteQueryVariables>
) {
  return Apollo.useQuery<OrderTicketsLiteQuery, OrderTicketsLiteQueryVariables>(
    OrderTicketsLiteDocument,
    baseOptions
  )
}
export function useOrderTicketsLiteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrderTicketsLiteQuery, OrderTicketsLiteQueryVariables>
) {
  return Apollo.useLazyQuery<OrderTicketsLiteQuery, OrderTicketsLiteQueryVariables>(
    OrderTicketsLiteDocument,
    baseOptions
  )
}
export type OrderTicketsLiteQueryHookResult = ReturnType<typeof useOrderTicketsLiteQuery>
export type OrderTicketsLiteLazyQueryHookResult = ReturnType<typeof useOrderTicketsLiteLazyQuery>
export type OrderTicketsLiteQueryResult = Apollo.QueryResult<
  OrderTicketsLiteQuery,
  OrderTicketsLiteQueryVariables
>
export const OrderTicketsDocument = gql`
  query OrderTickets($reference: String!, $filter: TicketFilter) {
    order(reference: $reference) {
      tickets(filter: $filter) {
        edges {
          node {
            id
            bookingRef
            ticketType {
              name
              leadScanning
            }
            assignment {
              id
              state
              appLoginEmail
              leadScanningActive
              assignee {
                id
                me
                firstName
                lastName
                email
                phoneNumber
                city
                companyName
                companySizeId
                industryId
                jobTitle
                marketingConsent
                passportNumber
                personalisationConsent
                partnerSharingConsent
                washingtonPostConsent
              }
            }
            order {
              reference
              sourceId
              invoiceUrl
            }
            state
            context {
              assignable
              editable
              acceptable
              rejectable
            }
            acceptedAddOns {
              edges {
                node {
                  id
                  addOnType {
                    id
                    name
                    description
                  }
                  assignment {
                    id
                    state
                    assignee {
                      id
                      me
                      firstName
                      lastName
                      email
                    }
                  }
                  state
                }
              }
            }
            state
          }
        }
      }
      addOns {
        edges {
          node {
            id
            addOnType {
              id
              name
              description
            }
            assignment {
              id
              state
              assignee {
                id
                me
                firstName
                lastName
                email
                phoneNumber
                city
                companyName
                companySizeId
                industryId
                jobTitle
                marketingConsent
                passportNumber
                personalisationConsent
                partnerSharingConsent
                washingtonPostConsent
              }
            }
            state
            order {
              reference
              sourceId
              invoiceUrl
            }
          }
        }
      }
      ticketUpgrades {
        edges {
          node {
            id
            ticketUpgradeType {
              name
            }
            assignment {
              id
              state
              assignee {
                id
                me
                firstName
                lastName
                email
                phoneNumber
                city
                companyName
                companySizeId
                industryId
                jobTitle
                marketingConsent
                passportNumber
                personalisationConsent
                partnerSharingConsent
                washingtonPostConsent
              }
            }
            state
            order {
              reference
              sourceId
              invoiceUrl
            }
          }
        }
      }
    }
  }
`

/**
 * __useOrderTicketsQuery__
 *
 * To run a query within a React component, call `useOrderTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderTicketsQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderTicketsQuery(
  baseOptions: Apollo.QueryHookOptions<OrderTicketsQuery, OrderTicketsQueryVariables>
) {
  return Apollo.useQuery<OrderTicketsQuery, OrderTicketsQueryVariables>(
    OrderTicketsDocument,
    baseOptions
  )
}
export function useOrderTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrderTicketsQuery, OrderTicketsQueryVariables>
) {
  return Apollo.useLazyQuery<OrderTicketsQuery, OrderTicketsQueryVariables>(
    OrderTicketsDocument,
    baseOptions
  )
}
export type OrderTicketsQueryHookResult = ReturnType<typeof useOrderTicketsQuery>
export type OrderTicketsLazyQueryHookResult = ReturnType<typeof useOrderTicketsLazyQuery>
export type OrderTicketsQueryResult = Apollo.QueryResult<
  OrderTicketsQuery,
  OrderTicketsQueryVariables
>
export const WebPageByHostPathDocument = gql`
  query WebPageByHostPath($host: String!, $path: String!) {
    webPageByHostPath(path: $path, host: $host) {
      id
      title
      seoTags {
        defaultImage {
          id
          url
        }
        title
        slug
        description
        twitterTitle
        twitterDescription
        twitterImage {
          id
          url
        }
        facebookTitle
        facebookImage {
          id
          url
        }
        facebookDescription
        noindex
      }
      content {
        __typename
        ... on ComponentWebLayoutsStoresTicketSalesPage {
          ...StoresTicketSalesPageLayout
        }
        ... on ComponentWebLayoutsStoresTicketApplicationsPage {
          ...StoresTicketApplicationsPageLayout
        }
        ... on ComponentWebElementsShowcaseGrid {
          ...ShowcaseGrid
        }
        ... on ComponentWebElementsScheduleSearchSidebarFilters {
          ...ScheduleSearchSidebarFilters
        }
        ... on ComponentWebElementsAttendeeSearchSidebarFilters {
          ...AttendeeSearchSidebarFilters
        }
        ... on ComponentWebElementsCompanySearchSidebarFilters {
          ...CompanySearchSidebarFilters
        }
        ... on ComponentWebElementsHeroSection {
          ...HeroSection
        }
      }
    }
  }
  ${StoresTicketSalesPageLayoutFragmentDoc}
  ${StoresTicketApplicationsPageLayoutFragmentDoc}
  ${ShowcaseGridFragmentDoc}
  ${ScheduleSearchSidebarFiltersFragmentDoc}
  ${AttendeeSearchSidebarFiltersFragmentDoc}
  ${CompanySearchSidebarFiltersFragmentDoc}
  ${HeroSectionFragmentDoc}
`

/**
 * __useWebPageByHostPathQuery__
 *
 * To run a query within a React component, call `useWebPageByHostPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebPageByHostPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebPageByHostPathQuery({
 *   variables: {
 *      host: // value for 'host'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useWebPageByHostPathQuery(
  baseOptions: Apollo.QueryHookOptions<WebPageByHostPathQuery, WebPageByHostPathQueryVariables>
) {
  return Apollo.useQuery<WebPageByHostPathQuery, WebPageByHostPathQueryVariables>(
    WebPageByHostPathDocument,
    baseOptions
  )
}
export function useWebPageByHostPathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WebPageByHostPathQuery, WebPageByHostPathQueryVariables>
) {
  return Apollo.useLazyQuery<WebPageByHostPathQuery, WebPageByHostPathQueryVariables>(
    WebPageByHostPathDocument,
    baseOptions
  )
}
export type WebPageByHostPathQueryHookResult = ReturnType<typeof useWebPageByHostPathQuery>
export type WebPageByHostPathLazyQueryHookResult = ReturnType<typeof useWebPageByHostPathLazyQuery>
export type WebPageByHostPathQueryResult = Apollo.QueryResult<
  WebPageByHostPathQuery,
  WebPageByHostPathQueryVariables
>
export const WebPageConfigByPathHostDocument = gql`
  query webPageConfigByPathHost($path: String!, $host: String!, $slug: String) {
    webPageConfigByPathHost(path: $path, host: $host, slug: $slug) {
      id
      site {
        title
      }
      event {
        termsAndConditionsUrl
      }
      config {
        baseGoogleAnalyticsTrackingId
        googleAnalyticsTrackingId
        googleTagManagerId
        googleOptimizeId
        googleAnalyticsLinkerDomains {
          domain
        }
        matomoSiteId
        matomoTagManagerContainerId
        matomoUrl
        segmentId
        metaData {
          image {
            url: absoluteUrl
          }
          siteTitle
          siteDescription
          facebookId
          facebookPublisher
          twitterId
          twitterCreator
        }
      }
      branding {
        googleFontsUrl
        typekitFontsUrl
        theme
        logo {
          id
          absoluteUrl
          alternativeText
        }
        headerBranding {
          id
          absoluteUrl
          alternativeText
        }
        favicon {
          id
          absoluteUrl
        }
        ticketLogo {
          id
          absoluteUrl
          alternativeText
        }
      }
    }
  }
`

/**
 * __useWebPageConfigByPathHostQuery__
 *
 * To run a query within a React component, call `useWebPageConfigByPathHostQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebPageConfigByPathHostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebPageConfigByPathHostQuery({
 *   variables: {
 *      path: // value for 'path'
 *      host: // value for 'host'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useWebPageConfigByPathHostQuery(
  baseOptions: Apollo.QueryHookOptions<
    WebPageConfigByPathHostQuery,
    WebPageConfigByPathHostQueryVariables
  >
) {
  return Apollo.useQuery<WebPageConfigByPathHostQuery, WebPageConfigByPathHostQueryVariables>(
    WebPageConfigByPathHostDocument,
    baseOptions
  )
}
export function useWebPageConfigByPathHostLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WebPageConfigByPathHostQuery,
    WebPageConfigByPathHostQueryVariables
  >
) {
  return Apollo.useLazyQuery<WebPageConfigByPathHostQuery, WebPageConfigByPathHostQueryVariables>(
    WebPageConfigByPathHostDocument,
    baseOptions
  )
}
export type WebPageConfigByPathHostQueryHookResult = ReturnType<
  typeof useWebPageConfigByPathHostQuery
>
export type WebPageConfigByPathHostLazyQueryHookResult = ReturnType<
  typeof useWebPageConfigByPathHostLazyQuery
>
export type WebPageConfigByPathHostQueryResult = Apollo.QueryResult<
  WebPageConfigByPathHostQuery,
  WebPageConfigByPathHostQueryVariables
>
export const WebPagesByHostMenuLabelDocument = gql`
  query WebPagesByHostMenuLabel($host: String!, $menuLabel: String!) {
    webPagesByHostMenuLabel(menuLabel: $menuLabel, host: $host) {
      id
      title
      path
    }
  }
`

/**
 * __useWebPagesByHostMenuLabelQuery__
 *
 * To run a query within a React component, call `useWebPagesByHostMenuLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebPagesByHostMenuLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebPagesByHostMenuLabelQuery({
 *   variables: {
 *      host: // value for 'host'
 *      menuLabel: // value for 'menuLabel'
 *   },
 * });
 */
export function useWebPagesByHostMenuLabelQuery(
  baseOptions: Apollo.QueryHookOptions<
    WebPagesByHostMenuLabelQuery,
    WebPagesByHostMenuLabelQueryVariables
  >
) {
  return Apollo.useQuery<WebPagesByHostMenuLabelQuery, WebPagesByHostMenuLabelQueryVariables>(
    WebPagesByHostMenuLabelDocument,
    baseOptions
  )
}
export function useWebPagesByHostMenuLabelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WebPagesByHostMenuLabelQuery,
    WebPagesByHostMenuLabelQueryVariables
  >
) {
  return Apollo.useLazyQuery<WebPagesByHostMenuLabelQuery, WebPagesByHostMenuLabelQueryVariables>(
    WebPagesByHostMenuLabelDocument,
    baseOptions
  )
}
export type WebPagesByHostMenuLabelQueryHookResult = ReturnType<
  typeof useWebPagesByHostMenuLabelQuery
>
export type WebPagesByHostMenuLabelLazyQueryHookResult = ReturnType<
  typeof useWebPagesByHostMenuLabelLazyQuery
>
export type WebPagesByHostMenuLabelQueryResult = Apollo.QueryResult<
  WebPagesByHostMenuLabelQuery,
  WebPagesByHostMenuLabelQueryVariables
>
